// IMPORTANT: do NOT reassign `mavlink20` here. The base definition (with
// `.message`, `.messages`, `.header`, etc.) lives in `./mavlink.js`. We
// extend that same object with the extra enum/MSG_ID constants below so
// that loading this wrapper does not clobber the protocol implementation.
const { mavlink20 } = require('./mavlink');

mavlink20.ACCELCAL_VEHICLE_POS_LEVEL = 1 // 
mavlink20.ACCELCAL_VEHICLE_POS_LEFT = 2 // 
mavlink20.ACCELCAL_VEHICLE_POS_RIGHT = 3 // 
mavlink20.ACCELCAL_VEHICLE_POS_NOSEDOWN = 4 // 
mavlink20.ACCELCAL_VEHICLE_POS_NOSEUP = 5 // 
mavlink20.ACCELCAL_VEHICLE_POS_BACK = 6 // 
mavlink20.ACCELCAL_VEHICLE_POS_SUCCESS = 16777215 // 
mavlink20.ACCELCAL_VEHICLE_POS_FAILED = 16777216 // 
mavlink20.ACCELCAL_VEHICLE_POS_ENUM_END = 16777217 // 

// HEADING_TYPE
mavlink20.HEADING_TYPE_COURSE_OVER_GROUND = 0 // 
mavlink20.HEADING_TYPE_HEADING = 1 // 
mavlink20.HEADING_TYPE_DEFAULT = 2 // 
mavlink20.HEADING_TYPE_ENUM_END = 3 // 

// MAV_CMD
mavlink20.MAV_CMD_NAV_WAYPOINT = 16 // Navigate to waypoint. This is intended for use in missions (for guided
                        // commands outside of missions use
                        // MAV_CMD_DO_REPOSITION).
mavlink20.MAV_CMD_NAV_LOITER_UNLIM = 17 // Loiter around this waypoint an unlimited amount of time
mavlink20.MAV_CMD_NAV_LOITER_TURNS = 18 // Loiter around this waypoint for X turns
mavlink20.MAV_CMD_NAV_LOITER_TIME = 19 // Loiter at the specified latitude, longitude and altitude for a certain
                        // amount of time. Multicopter vehicles stop
                        // at the point (within a vehicle-specific
                        // acceptance radius). Forward-only moving
                        // vehicles (e.g. fixed-wing) circle the point
                        // with the specified radius/direction. If the
                        // Heading Required parameter (2) is non-zero
                        // forward moving aircraft will only leave the
                        // loiter circle once heading towards the next
                        // waypoint.
mavlink20.MAV_CMD_NAV_RETURN_TO_LAUNCH = 20 // Return to launch location
mavlink20.MAV_CMD_NAV_LAND = 21 // Land at location.
mavlink20.MAV_CMD_NAV_TAKEOFF = 22 // Takeoff from ground / hand. Vehicles that support multiple takeoff
                        // modes (e.g. VTOL quadplane) should take off
                        // using the currently configured mode.
mavlink20.MAV_CMD_NAV_LAND_LOCAL = 23 // Land at local position (local frame only)
mavlink20.MAV_CMD_NAV_TAKEOFF_LOCAL = 24 // Takeoff from local position (local frame only)
mavlink20.MAV_CMD_NAV_FOLLOW = 25 // Vehicle following, i.e. this waypoint represents the position of a
                        // moving vehicle
mavlink20.MAV_CMD_NAV_CONTINUE_AND_CHANGE_ALT = 30 // Continue on the current course and climb/descend to specified
                        // altitude.  When the altitude is reached
                        // continue to the next command (i.e., don't
                        // proceed to the next command until the
                        // desired altitude is reached.
mavlink20.MAV_CMD_NAV_LOITER_TO_ALT = 31 // Begin loiter at the specified Latitude and Longitude.  If Lat=Lon=0,
                        // then loiter at the current position.  Don't
                        // consider the navigation command complete
                        // (don't leave loiter) until the altitude has
                        // been reached. Additionally, if the Heading
                        // Required parameter is non-zero the aircraft
                        // will not leave the loiter until heading
                        // toward the next waypoint.
mavlink20.MAV_CMD_DO_FOLLOW = 32 // Begin following a target
mavlink20.MAV_CMD_DO_FOLLOW_REPOSITION = 33 // Reposition the MAV after a follow target command has been sent
mavlink20.MAV_CMD_DO_ORBIT = 34 // Start orbiting on the circumference of a circle defined by the
                        // parameters. Setting values to NaN/INT32_MAX
                        // (as appropriate) results in using defaults.
mavlink20.MAV_CMD_DO_FIGURE_EIGHT = 35 // Fly a figure eight path as defined by the parameters.           Set
                        // parameters to NaN/INT32_MAX (as
                        // appropriate) to use system-default values.
                        // The command is intended for fixed wing
                        // vehicles (and VTOL hybrids flying in fixed-
                        // wing mode), allowing POI tracking for
                        // gimbals that don't support infinite
                        // rotation.           This command only
                        // defines the flight path. Speed should be
                        // set independently (use e.g.
                        // MAV_CMD_DO_CHANGE_SPEED).           Yaw and
                        // other degrees of freedom are not specified,
                        // and will be flight-stack specific (on
                        // vehicles where they can be controlled
                        // independent of the heading).
mavlink20.MAV_CMD_NAV_ROI = 80 // Sets the region of interest (ROI) for a sensor set or the vehicle
                        // itself. This can then be used by the
                        // vehicle's control system to control the
                        // vehicle attitude and the attitude of
                        // various sensors such as cameras.
mavlink20.MAV_CMD_NAV_PATHPLANNING = 81 // Control autonomous path planning on the MAV.
mavlink20.MAV_CMD_NAV_SPLINE_WAYPOINT = 82 // Navigate to waypoint using a spline path.
mavlink20.MAV_CMD_NAV_ALTITUDE_WAIT = 83 // Mission command to wait for an altitude or downwards vertical speed.
                        // This is meant for high altitude balloon
                        // launches, allowing the aircraft to be idle
                        // until either an altitude is reached or a
                        // negative vertical speed is reached
                        // (indicating early balloon burst). The
                        // wiggle time is how often to wiggle the
                        // control surfaces to prevent them seizing
                        // up.
mavlink20.MAV_CMD_NAV_VTOL_TAKEOFF = 84 // Takeoff from ground using VTOL mode, and transition to forward flight
                        // with specified heading. The command should
                        // be ignored by vehicles that dont support
                        // both VTOL and fixed-wing flight
                        // (multicopters, boats,etc.).
mavlink20.MAV_CMD_NAV_VTOL_LAND = 85 // Land using VTOL mode
mavlink20.MAV_CMD_NAV_GUIDED_ENABLE = 92 // hand control over to an external controller
mavlink20.MAV_CMD_NAV_DELAY = 93 // Delay the next navigation command a number of seconds or until a
                        // specified time
mavlink20.MAV_CMD_NAV_PAYLOAD_PLACE = 94 // Descend and place payload. Vehicle moves to specified location,
                        // descends until it detects a hanging payload
                        // has reached the ground, and then releases
                        // the payload. If ground is not detected
                        // before the reaching the maximum descent
                        // value (param1), the command will complete
                        // without releasing the payload.
mavlink20.MAV_CMD_NAV_LAST = 95 // NOP - This command is only used to mark the upper limit of the
                        // NAV/ACTION commands in the enumeration
mavlink20.MAV_CMD_CONDITION_DELAY = 112 // Delay mission state machine.
mavlink20.MAV_CMD_CONDITION_CHANGE_ALT = 113 // Ascend/descend to target altitude at specified rate. Delay mission
                        // state machine until desired altitude
                        // reached.
mavlink20.MAV_CMD_CONDITION_DISTANCE = 114 // Delay mission state machine until within desired distance of next NAV
                        // point.
mavlink20.MAV_CMD_CONDITION_YAW = 115 // Reach a certain target angle.
mavlink20.MAV_CMD_CONDITION_LAST = 159 // NOP - This command is only used to mark the upper limit of the
                        // CONDITION commands in the enumeration
mavlink20.MAV_CMD_DO_SET_MODE = 176 // Set system mode.
mavlink20.MAV_CMD_DO_JUMP = 177 // Jump to the desired command in the mission list.  Repeat this action
                        // only the specified number of times
mavlink20.MAV_CMD_DO_CHANGE_SPEED = 178 // Change speed and/or throttle set points. The value persists until it
                        // is overridden or there is a mode change
mavlink20.MAV_CMD_DO_SET_HOME = 179 //            Sets the home position to either to the current position or
                        // a specified position.           The home
                        // position is the default position that the
                        // system will return to and land on.
                        // The position is set automatically by the
                        // system during the takeoff (and may also be
                        // set using this command).           Note:
                        // the current home position may be emitted in
                        // a HOME_POSITION message on request (using
                        // MAV_CMD_REQUEST_MESSAGE with param1=242).
mavlink20.MAV_CMD_DO_SET_PARAMETER = 180 // Set a system parameter.  Caution!  Use of this command requires
                        // knowledge of the numeric enumeration value
                        // of the parameter.
mavlink20.MAV_CMD_DO_SET_RELAY = 181 // Set a relay to a condition.
mavlink20.MAV_CMD_DO_REPEAT_RELAY = 182 // Cycle a relay on and off for a desired number of cycles with a desired
                        // period.
mavlink20.MAV_CMD_DO_SET_SERVO = 183 // Set a servo to a desired PWM value.
mavlink20.MAV_CMD_DO_REPEAT_SERVO = 184 // Cycle a between its nominal setting and a desired PWM for a desired
                        // number of cycles with a desired period.
mavlink20.MAV_CMD_DO_FLIGHTTERMINATION = 185 // Terminate flight immediately.           Flight termination immediately
                        // and irreversibly terminates the current
                        // flight, returning the vehicle to ground.
                        // The vehicle will ignore RC or other input
                        // until it has been power-cycled.
                        // Termination may trigger safety measures,
                        // including: disabling motors and deployment
                        // of parachute on multicopters, and setting
                        // flight surfaces to initiate a landing
                        // pattern on fixed-wing).           On
                        // multicopters without a parachute it may
                        // trigger a crash landing.           Support
                        // for this command can be tested using the
                        // protocol bit:
                        // MAV_PROTOCOL_CAPABILITY_FLIGHT_TERMINATION.
                        // Support for this command can also be tested
                        // by sending the command with param1=0 (<
                        // 0.5); the ACK should be either
                        // MAV_RESULT_FAILED or
                        // MAV_RESULT_UNSUPPORTED.
mavlink20.MAV_CMD_DO_CHANGE_ALTITUDE = 186 // Change altitude set point.
mavlink20.MAV_CMD_DO_SET_ACTUATOR = 187 // Sets actuators (e.g. servos) to a desired value. The actuator numbers
                        // are mapped to specific outputs (e.g. on any
                        // MAIN or AUX PWM or UAVCAN) using a flight-
                        // stack specific mechanism (i.e. a
                        // parameter).
mavlink20.MAV_CMD_DO_RETURN_PATH_START = 188 // Mission item to specify the start of a failsafe/landing return-path
                        // segment (the end of the segment is the next
                        // MAV_CMD_DO_LAND_START item).           A
                        // vehicle that is using missions for landing
                        // (e.g. in a return mode) will join the
                        // mission on the closest path of the return-
                        // path segment (instead of
                        // MAV_CMD_DO_LAND_START or the nearest
                        // waypoint).           The main use case is
                        // to minimize the failsafe flight path in
                        // corridor missions, where the
                        // inbound/outbound paths are constrained (by
                        // geofences) to the same particular path.
                        // The MAV_CMD_NAV_RETURN_PATH_START would be
                        // placed at the start of the return path.
                        // If a failsafe occurs on the outbound path
                        // the vehicle will move to the nearest point
                        // on the return path (which is parallel for
                        // this kind of mission), effectively turning
                        // round and following the shortest path to
                        // landing.           If a failsafe occurs on
                        // the inbound path the vehicle is already on
                        // the return segment and will continue to
                        // landing.           The
                        // Latitude/Longitude/Altitude are optional,
                        // and may be set to 0 if not needed.
                        // If specified, the item defines the waypoint
                        // at which the return segment starts.
                        // If sent using as a command, the vehicle
                        // will perform a mission landing (using the
                        // land segment if defined) or reject the
                        // command if mission landings are not
                        // supported, or no mission landing is
                        // defined. When used as a command any
                        // position information in the command is
                        // ignored.
mavlink20.MAV_CMD_DO_LAND_START = 189 // Mission command to perform a landing. This is used as a marker in a
                        // mission to tell the autopilot where a
                        // sequence of mission items that represents a
                        // landing starts.           It may also be
                        // sent via a COMMAND_LONG to trigger a
                        // landing, in which case the nearest
                        // (geographically) landing sequence in the
                        // mission will be used.           The
                        // Latitude/Longitude/Altitude is optional,
                        // and may be set to 0 if not needed. If
                        // specified then it will be used to help find
                        // the closest landing sequence.
mavlink20.MAV_CMD_DO_RALLY_LAND = 190 // Mission command to perform a landing from a rally point.
mavlink20.MAV_CMD_DO_GO_AROUND = 191 // Mission command to safely abort an autonomous landing.
mavlink20.MAV_CMD_DO_REPOSITION = 192 // Reposition the vehicle to a specific WGS84 global position. This
                        // command is intended for guided commands
                        // (for missions use MAV_CMD_NAV_WAYPOINT
                        // instead).
mavlink20.MAV_CMD_DO_PAUSE_CONTINUE = 193 // If in a GPS controlled position mode, hold the current position or
                        // continue.
mavlink20.MAV_CMD_DO_SET_REVERSE = 194 // Set moving direction to forward or reverse.
mavlink20.MAV_CMD_DO_SET_ROI_LOCATION = 195 // Sets the region of interest (ROI) to a location. This can then be used
                        // by the vehicle's control system to control
                        // the vehicle attitude and the attitude of
                        // various sensors such as cameras. This
                        // command can be sent to a gimbal manager but
                        // not to a gimbal device. A gimbal is not to
                        // react to this message.
mavlink20.MAV_CMD_DO_SET_ROI_WPNEXT_OFFSET = 196 // Sets the region of interest (ROI) to be toward next waypoint, with
                        // optional pitch/roll/yaw offset. This can
                        // then be used by the vehicle's control
                        // system to control the vehicle attitude and
                        // the attitude of various sensors such as
                        // cameras. This command can be sent to a
                        // gimbal manager but not to a gimbal device.
                        // A gimbal device is not to react to this
                        // message.
mavlink20.MAV_CMD_DO_SET_ROI_NONE = 197 // Cancels any previous ROI command returning the vehicle/sensors to
                        // default flight characteristics. This can
                        // then be used by the vehicle's control
                        // system to control the vehicle attitude and
                        // the attitude of various sensors such as
                        // cameras. This command can be sent to a
                        // gimbal manager but not to a gimbal device.
                        // A gimbal device is not to react to this
                        // message. After this command the gimbal
                        // manager should go back to manual input if
                        // available, and otherwise assume a neutral
                        // position.
mavlink20.MAV_CMD_DO_SET_ROI_SYSID = 198 // Mount tracks system with specified system ID. Determination of target
                        // vehicle position may be done with
                        // GLOBAL_POSITION_INT or any other means.
                        // This command can be sent to a gimbal
                        // manager but not to a gimbal device. A
                        // gimbal device is not to react to this
                        // message.
mavlink20.MAV_CMD_DO_CONTROL_VIDEO = 200 // Control onboard camera system.
mavlink20.MAV_CMD_DO_SET_ROI = 201 // Sets the region of interest (ROI) for a sensor set or the vehicle
                        // itself. This can then be used by the
                        // vehicle's control system to control the
                        // vehicle attitude and the attitude of
                        // various sensors such as cameras.
mavlink20.MAV_CMD_DO_DIGICAM_CONFIGURE = 202 // Configure digital camera. This is a fallback message for systems that
                        // have not yet implemented PARAM_EXT_XXX
                        // messages and camera definition files (see h
                        // ttps://mavlink.io/en/services/camera_def.ht
                        // ml ).
mavlink20.MAV_CMD_DO_DIGICAM_CONTROL = 203 // Control digital camera. This is a fallback message for systems that
                        // have not yet implemented PARAM_EXT_XXX
                        // messages and camera definition files (see h
                        // ttps://mavlink.io/en/services/camera_def.ht
                        // ml ).
mavlink20.MAV_CMD_DO_MOUNT_CONFIGURE = 204 // Mission command to configure a camera or antenna mount
mavlink20.MAV_CMD_DO_MOUNT_CONTROL = 205 // Mission command to control a camera or antenna mount
mavlink20.MAV_CMD_DO_SET_CAM_TRIGG_DIST = 206 // Mission command to set camera trigger distance for this flight. The
                        // camera is triggered each time this distance
                        // is exceeded. This command can also be used
                        // to set the shutter integration time for the
                        // camera.
mavlink20.MAV_CMD_DO_FENCE_ENABLE = 207 //            Enable the geofence.           This can be used in a
                        // mission or via the command protocol.
                        // The persistence/lifetime of the setting is
                        // undefined.           Depending on flight
                        // stack implementation it may persist until
                        // superseded, or it may revert to a system
                        // default at the end of a mission.
                        // Flight stacks typically reset the setting
                        // to system defaults on reboot.
mavlink20.MAV_CMD_DO_PARACHUTE = 208 // Mission item/command to release a parachute or enable/disable auto
                        // release.
mavlink20.MAV_CMD_DO_MOTOR_TEST = 209 // Command to perform motor test.
mavlink20.MAV_CMD_DO_INVERTED_FLIGHT = 210 // Change to/from inverted flight.
mavlink20.MAV_CMD_DO_GRIPPER = 211 // Mission command to operate a gripper.
mavlink20.MAV_CMD_DO_AUTOTUNE_ENABLE = 212 // Enable/disable autotune.
mavlink20.MAV_CMD_NAV_SET_YAW_SPEED = 213 // Sets a desired vehicle turn angle and speed change.
mavlink20.MAV_CMD_DO_SET_CAM_TRIGG_INTERVAL = 214 // Mission command to set camera trigger interval for this flight. If
                        // triggering is enabled, the camera is
                        // triggered each time this interval expires.
                        // This command can also be used to set the
                        // shutter integration time for the camera.
mavlink20.MAV_CMD_DO_SET_RESUME_REPEAT_DIST = 215 // Set the distance to be repeated on mission resume
mavlink20.MAV_CMD_DO_SPRAYER = 216 // Control attached liquid sprayer
mavlink20.MAV_CMD_DO_SEND_SCRIPT_MESSAGE = 217 // Pass instructions onto scripting, a script should be checking for a
                        // new command
mavlink20.MAV_CMD_DO_AUX_FUNCTION = 218 // Execute auxiliary function
mavlink20.MAV_CMD_DO_MOUNT_CONTROL_QUAT = 220 // Mission command to control a camera or antenna mount, using a
                        // quaternion as reference.
mavlink20.MAV_CMD_DO_GUIDED_MASTER = 221 // set id of master controller
mavlink20.MAV_CMD_DO_GUIDED_LIMITS = 222 // Set limits for external control
mavlink20.MAV_CMD_DO_ENGINE_CONTROL = 223 // Control vehicle engine. This is interpreted by the vehicles engine
                        // controller to change the target engine
                        // state. It is intended for vehicles with
                        // internal combustion engines
mavlink20.MAV_CMD_DO_SET_MISSION_CURRENT = 224 //            Set the mission item with sequence number seq as the
                        // current item and emit MISSION_CURRENT
                        // (whether or not the mission number
                        // changed).           If a mission is
                        // currently being executed, the system will
                        // continue to this new mission item on the
                        // shortest path, skipping any intermediate
                        // mission items.           Note that mission
                        // jump repeat counters are not reset unless
                        // param2 is set (see MAV_CMD_DO_JUMP param2).
                        // This command may trigger a mission state-
                        // machine change on some systems: for example
                        // from MISSION_STATE_NOT_STARTED or
                        // MISSION_STATE_PAUSED to
                        // MISSION_STATE_ACTIVE.           If the
                        // system is in mission mode, on those systems
                        // this command might therefore start, restart
                        // or resume the mission.           If the
                        // system is not in mission mode this command
                        // must not trigger a switch to mission mode.
                        // The mission may be "reset" using param2.
                        // Resetting sets jump counters to initial
                        // values (to reset counters without changing
                        // the current mission item set the param1 to
                        // `-1`).           Resetting also explicitly
                        // changes a mission state of
                        // MISSION_STATE_COMPLETE to
                        // MISSION_STATE_PAUSED or
                        // MISSION_STATE_ACTIVE, potentially allowing
                        // it to resume when it is (next) in a mission
                        // mode.            The command will ACK with
                        // MAV_RESULT_FAILED if the sequence number is
                        // out of range (including if there is no
                        // mission item).
mavlink20.MAV_CMD_DO_LAST = 240 // NOP - This command is only used to mark the upper limit of the DO
                        // commands in the enumeration
mavlink20.MAV_CMD_PREFLIGHT_CALIBRATION = 241 // Trigger calibration. This command will be only accepted if in pre-
                        // flight mode. Except for Temperature
                        // Calibration, only one sensor should be set
                        // in a single message and all others should
                        // be zero.
mavlink20.MAV_CMD_PREFLIGHT_SET_SENSOR_OFFSETS = 242 // Set sensor offsets. This command will be only accepted if in pre-
                        // flight mode.
mavlink20.MAV_CMD_PREFLIGHT_UAVCAN = 243 // Trigger UAVCAN configuration (actuator ID assignment and direction
                        // mapping). Note that this maps to the legacy
                        // UAVCAN v0 function UAVCAN_ENUMERATE, which
                        // is intended to be executed just once during
                        // initial vehicle configuration (it is not a
                        // normal pre-flight command and has been
                        // poorly named).
mavlink20.MAV_CMD_PREFLIGHT_STORAGE = 245 // Request storage of different parameter values and logs. This command
                        // will be only accepted if in pre-flight
                        // mode.
mavlink20.MAV_CMD_PREFLIGHT_REBOOT_SHUTDOWN = 246 // Request the reboot or shutdown of system components.
mavlink20.MAV_CMD_DO_UPGRADE = 247 // Request a target system to start an upgrade of one (or all) of its
                        // components.           For example, the
                        // command might be sent to a companion
                        // computer to cause it to upgrade a connected
                        // flight controller.           The system
                        // doing the upgrade will report progress
                        // using the normal command protocol sequence
                        // for a long running operation.
                        // Command protocol information: https://mavli
                        // nk.io/en/services/command.html.
mavlink20.MAV_CMD_OVERRIDE_GOTO = 252 // Override current mission with command to pause mission, pause mission
                        // and move to position, continue/resume
                        // mission. When param 1 indicates that the
                        // mission is paused (MAV_GOTO_DO_HOLD), param
                        // 2 defines whether it holds in place or
                        // moves to another position.
mavlink20.MAV_CMD_OBLIQUE_SURVEY = 260 // Mission command to set a Camera Auto Mount Pivoting Oblique Survey
                        // (Replaces CAM_TRIGG_DIST for this purpose).
                        // The camera is triggered each time this
                        // distance is exceeded, then the mount moves
                        // to the next position. Params 4~6 set-up the
                        // angle limits and number of positions for
                        // oblique survey, where mount-enabled
                        // vehicles automatically roll the camera
                        // between shots to emulate an oblique camera
                        // setup (providing an increased HFOV). This
                        // command can also be used to set the shutter
                        // integration time for the camera.
mavlink20.MAV_CMD_DO_SET_STANDARD_MODE = 262 // Enable the specified standard MAVLink mode.           If the mode is
                        // not supported the vehicle should ACK with
                        // MAV_RESULT_FAILED.
mavlink20.MAV_CMD_MISSION_START = 300 // start running a mission
mavlink20.MAV_CMD_ACTUATOR_TEST = 310 // Actuator testing command. This is similar to MAV_CMD_DO_MOTOR_TEST but
                        // operates on the level of output functions,
                        // i.e. it is possible to test Motor1
                        // independent from which output it is
                        // configured on. Autopilots typically refuse
                        // this command while armed.
mavlink20.MAV_CMD_CONFIGURE_ACTUATOR = 311 // Actuator configuration command.
mavlink20.MAV_CMD_COMPONENT_ARM_DISARM = 400 // Arms / Disarms a component
mavlink20.MAV_CMD_RUN_PREARM_CHECKS = 401 // Instructs a target system to run pre-arm checks.           This allows
                        // preflight checks to be run on demand, which
                        // may be useful on systems that normally run
                        // them at low rate, or which do not trigger
                        // checks when the armable state might have
                        // changed.           This command should
                        // return MAV_RESULT_ACCEPTED if it will run
                        // the checks.           The results of the
                        // checks are usually then reported in
                        // SYS_STATUS messages (this is system-
                        // specific).           The command should
                        // return MAV_RESULT_TEMPORARILY_REJECTED if
                        // the system is already armed.
mavlink20.MAV_CMD_ILLUMINATOR_ON_OFF = 405 // Turns illuminators ON/OFF. An illuminator is a light source that is
                        // used for lighting up dark areas external to
                        // the system: e.g. a torch or searchlight (as
                        // opposed to a light source for illuminating
                        // the system itself, e.g. an indicator
                        // light).
mavlink20.MAV_CMD_DO_ILLUMINATOR_CONFIGURE = 406 // Configures illuminator settings. An illuminator is a light source that
                        // is used for lighting up dark areas external
                        // to the system: e.g. a torch or searchlight
                        // (as opposed to a light source for
                        // illuminating the system itself, e.g. an
                        // indicator light).
mavlink20.MAV_CMD_GET_HOME_POSITION = 410 // Request the home position from the vehicle.           The vehicle will
                        // ACK the command and then emit the
                        // HOME_POSITION message.
mavlink20.MAV_CMD_INJECT_FAILURE = 420 // Inject artificial failure for testing purposes. Note that autopilots
                        // should implement an additional protection
                        // before accepting this command such as a
                        // specific param setting.
mavlink20.MAV_CMD_START_RX_PAIR = 500 // Starts receiver pairing.
mavlink20.MAV_CMD_GET_MESSAGE_INTERVAL = 510 //            Request the interval between messages for a particular
                        // MAVLink message ID.           The receiver
                        // should ACK the command and then emit its
                        // response in a MESSAGE_INTERVAL message.
mavlink20.MAV_CMD_SET_MESSAGE_INTERVAL = 511 // Set the interval between messages for a particular MAVLink message ID.
                        // This interface replaces
                        // REQUEST_DATA_STREAM.
mavlink20.MAV_CMD_REQUEST_MESSAGE = 512 // Request the target system(s) emit a single instance of a specified
                        // message (i.e. a "one-shot" version of
                        // MAV_CMD_SET_MESSAGE_INTERVAL).
mavlink20.MAV_CMD_REQUEST_PROTOCOL_VERSION = 519 // Request MAVLink protocol version compatibility. All receivers should
                        // ACK the command and then emit their
                        // capabilities in an PROTOCOL_VERSION message
mavlink20.MAV_CMD_REQUEST_AUTOPILOT_CAPABILITIES = 520 // Request autopilot capabilities. The receiver should ACK the command
                        // and then emit its capabilities in an
                        // AUTOPILOT_VERSION message
mavlink20.MAV_CMD_REQUEST_CAMERA_INFORMATION = 521 // Request camera information (CAMERA_INFORMATION).
mavlink20.MAV_CMD_REQUEST_CAMERA_SETTINGS = 522 // Request camera settings (CAMERA_SETTINGS).
mavlink20.MAV_CMD_REQUEST_STORAGE_INFORMATION = 525 // Request storage information (STORAGE_INFORMATION). Use the command's
                        // target_component to target a specific
                        // component's storage.
mavlink20.MAV_CMD_STORAGE_FORMAT = 526 // Format a storage medium. Once format is complete, a
                        // STORAGE_INFORMATION message is sent. Use
                        // the command's target_component to target a
                        // specific component's storage.
mavlink20.MAV_CMD_REQUEST_CAMERA_CAPTURE_STATUS = 527 // Request camera capture status (CAMERA_CAPTURE_STATUS)
mavlink20.MAV_CMD_REQUEST_FLIGHT_INFORMATION = 528 // Request flight information (FLIGHT_INFORMATION)
mavlink20.MAV_CMD_RESET_CAMERA_SETTINGS = 529 // Reset all camera settings to Factory Default
mavlink20.MAV_CMD_SET_CAMERA_MODE = 530 // Set camera running mode. Use NaN for reserved values. GCS will send a
                        // MAV_CMD_REQUEST_VIDEO_STREAM_STATUS command
                        // after a mode change if the camera supports
                        // video streaming.
mavlink20.MAV_CMD_SET_CAMERA_ZOOM = 531 // Set camera zoom. Camera must respond with a CAMERA_SETTINGS message
                        // (on success).
mavlink20.MAV_CMD_SET_CAMERA_FOCUS = 532 // Set camera focus. Camera must respond with a CAMERA_SETTINGS message
                        // (on success).
mavlink20.MAV_CMD_SET_STORAGE_USAGE = 533 // Set that a particular storage is the preferred location for saving
                        // photos, videos, and/or other media (e.g. to
                        // set that an SD card is used for storing
                        // videos).           There can only be one
                        // preferred save location for each particular
                        // media type: setting a media usage flag will
                        // clear/reset that same flag if set on any
                        // other storage.           If no flag is set
                        // the system should use its default storage.
                        // A target system can choose to always use
                        // default storage, in which case it should
                        // ACK the command with
                        // MAV_RESULT_UNSUPPORTED.           A target
                        // system can choose to not allow a particular
                        // storage to be set as preferred storage, in
                        // which case it should ACK the command with
                        // MAV_RESULT_DENIED.
mavlink20.MAV_CMD_SET_CAMERA_SOURCE = 534 // Set camera source. Changes the camera's active sources on cameras with
                        // multiple image sensors.
mavlink20.MAV_CMD_SET_AT_S_PARAM = 550 // Allows setting an AT S command of an SiK radio.
mavlink20.MAV_CMD_JUMP_TAG = 600 // Tagged jump target. Can be jumped to with MAV_CMD_DO_JUMP_TAG.
mavlink20.MAV_CMD_DO_JUMP_TAG = 601 // Jump to the matching tag in the mission list. Repeat this action for
                        // the specified number of times. A mission
                        // should contain a single matching tag for
                        // each jump. If this is not the case then a
                        // jump to a missing tag should complete the
                        // mission, and a jump where there are
                        // multiple matching tags should always select
                        // the one with the lowest mission sequence
                        // number.
mavlink20.MAV_CMD_DO_SET_SYS_CMP_ID = 610 //            Set system and component id.           This allows moving
                        // of a system and all its components to a new
                        // system id, or moving a particular component
                        // to a new system/component id.
                        // Recipients must reject command addressed to
                        // broadcast system ID.
mavlink20.MAV_CMD_DO_GIMBAL_MANAGER_PITCHYAW = 1000 // Set gimbal manager pitch/yaw setpoints (low rate command). It is
                        // possible to set combinations of the values
                        // below. E.g. an angle as well as a desired
                        // angular rate can be used to get to this
                        // angle at a certain angular rate, or an
                        // angular rate only will result in continuous
                        // turning. NaN is to be used to signal unset.
                        // Note: only the gimbal manager will react to
                        // this command - it will be ignored by a
                        // gimbal device. Use
                        // GIMBAL_MANAGER_SET_PITCHYAW if you need to
                        // stream pitch/yaw setpoints at higher rate.
mavlink20.MAV_CMD_DO_GIMBAL_MANAGER_CONFIGURE = 1001 // Gimbal configuration to set which sysid/compid is in primary and
                        // secondary control.
mavlink20.MAV_CMD_IMAGE_START_CAPTURE = 2000 // Start image capture sequence. CAMERA_IMAGE_CAPTURED must be emitted
                        // after each capture.            Param1 (id)
                        // may be used to specify the target camera:
                        // 0: all cameras, 1 to 6: autopilot-connected
                        // cameras, 7-255: MAVLink camera component
                        // ID.           It is needed in order to
                        // target specific cameras connected to the
                        // autopilot, or specific sensors in a multi-
                        // sensor camera (neither of which have a
                        // distinct MAVLink component ID).
                        // It is also needed to specify the target
                        // camera in missions.            When used in
                        // a mission, an autopilot should execute the
                        // MAV_CMD for a specified local camera
                        // (param1 = 1-6), or resend it as a command
                        // if it is intended for a MAVLink camera
                        // (param1 = 7 - 255), setting the command's
                        // target_component as the param1 value (and
                        // setting param1 in the command to zero).
                        // If the param1 is 0 the autopilot should do
                        // both.            When sent in a command the
                        // target MAVLink address is set using
                        // target_component.           If addressed
                        // specifically to an autopilot: param1 should
                        // be used in the same way as it is for
                        // missions (though command should NACK with
                        // MAV_RESULT_DENIED if a specified local
                        // camera does not exist).           If
                        // addressed to a MAVLink camera, param 1 can
                        // be used to address all cameras (0), or to
                        // separately address 1 to 7 individual
                        // sensors. Other values should be NACKed with
                        // MAV_RESULT_DENIED.           If the command
                        // is broadcast (target_component is 0) then
                        // param 1 should be set to 0 (any other value
                        // should be NACKED with MAV_RESULT_DENIED).
                        // An autopilot would trigger any local
                        // cameras and forward the command to all
                        // channels.
mavlink20.MAV_CMD_IMAGE_STOP_CAPTURE = 2001 // Stop image capture sequence.            Param1 (id) may be used to
                        // specify the target camera: 0: all cameras,
                        // 1 to 6: autopilot-connected cameras, 7-255:
                        // MAVLink camera component ID.           It
                        // is needed in order to target specific
                        // cameras connected to the autopilot, or
                        // specific sensors in a multi-sensor camera
                        // (neither of which have a distinct MAVLink
                        // component ID).           It is also needed
                        // to specify the target camera in missions.
                        // When used in a mission, an autopilot should
                        // execute the MAV_CMD for a specified local
                        // camera (param1 = 1-6), or resend it as a
                        // command if it is intended for a MAVLink
                        // camera (param1 = 7 - 255), setting the
                        // command's target_component as the param1
                        // value (and setting param1 in the command to
                        // zero).           If the param1 is 0 the
                        // autopilot should do both.            When
                        // sent in a command the target MAVLink
                        // address is set using target_component.
                        // If addressed specifically to an autopilot:
                        // param1 should be used in the same way as it
                        // is for missions (though command should NACK
                        // with MAV_RESULT_DENIED if a specified local
                        // camera does not exist).           If
                        // addressed to a MAVLink camera, param1 can
                        // be used to address all cameras (0), or to
                        // separately address 1 to 7 individual
                        // sensors. Other values should be NACKed with
                        // MAV_RESULT_DENIED.           If the command
                        // is broadcast (target_component is 0) then
                        // param 1 should be set to 0 (any other value
                        // should be NACKED with MAV_RESULT_DENIED).
                        // An autopilot would trigger any local
                        // cameras and forward the command to all
                        // channels.
mavlink20.MAV_CMD_REQUEST_CAMERA_IMAGE_CAPTURE = 2002 // Re-request a CAMERA_IMAGE_CAPTURED message.
mavlink20.MAV_CMD_DO_TRIGGER_CONTROL = 2003 // Enable or disable on-board camera triggering system.
mavlink20.MAV_CMD_CAMERA_TRACK_POINT = 2004 // If the camera supports point visual tracking
                        // (CAMERA_CAP_FLAGS_HAS_TRACKING_POINT is
                        // set), this command allows to initiate the
                        // tracking.
mavlink20.MAV_CMD_CAMERA_TRACK_RECTANGLE = 2005 // If the camera supports rectangle visual tracking
                        // (CAMERA_CAP_FLAGS_HAS_TRACKING_RECTANGLE is
                        // set), this command allows to initiate the
                        // tracking.
mavlink20.MAV_CMD_CAMERA_STOP_TRACKING = 2010 // Stops ongoing tracking.
mavlink20.MAV_CMD_VIDEO_START_CAPTURE = 2500 // Starts video capture (recording).
mavlink20.MAV_CMD_VIDEO_STOP_CAPTURE = 2501 // Stop the current video capture (recording).
mavlink20.MAV_CMD_VIDEO_START_STREAMING = 2502 // Start video streaming
mavlink20.MAV_CMD_VIDEO_STOP_STREAMING = 2503 // Stop the given video stream
mavlink20.MAV_CMD_REQUEST_VIDEO_STREAM_INFORMATION = 2504 // Request video stream information (VIDEO_STREAM_INFORMATION)
mavlink20.MAV_CMD_REQUEST_VIDEO_STREAM_STATUS = 2505 // Request video stream status (VIDEO_STREAM_STATUS)
mavlink20.MAV_CMD_LOGGING_START = 2510 // Request to start streaming logging data over MAVLink (see also
                        // LOGGING_DATA message)
mavlink20.MAV_CMD_LOGGING_STOP = 2511 // Request to stop streaming log data over MAVLink
mavlink20.MAV_CMD_AIRFRAME_CONFIGURATION = 2520 // 
mavlink20.MAV_CMD_CONTROL_HIGH_LATENCY = 2600 // Request to start/stop transmitting over the high latency telemetry
mavlink20.MAV_CMD_PANORAMA_CREATE = 2800 // Create a panorama at the current position
mavlink20.MAV_CMD_DO_VTOL_TRANSITION = 3000 // Request VTOL transition
mavlink20.MAV_CMD_ARM_AUTHORIZATION_REQUEST = 3001 // Request authorization to arm the vehicle to a external entity, the arm
                        // authorizer is responsible to request all
                        // data that is needs from the vehicle before
                        // authorize or deny the request.
                        // If approved the COMMAND_ACK message
                        // progress field should be set with period of
                        // time that this authorization is valid in
                        // seconds.                 If the
                        // authorization is denied
                        // COMMAND_ACK.result_param2 should be set
                        // with one of the reasons in
                        // ARM_AUTH_DENIED_REASON.
mavlink20.MAV_CMD_SET_GUIDED_SUBMODE_STANDARD = 4000 // This command sets the submode to standard guided when vehicle is in
                        // guided mode. The vehicle holds position and
                        // altitude and the user can input the desired
                        // velocities along all three axes.
mavlink20.MAV_CMD_SET_GUIDED_SUBMODE_CIRCLE = 4001 // This command sets submode circle when vehicle is in guided mode.
                        // Vehicle flies along a circle facing the
                        // center of the circle. The user can input
                        // the velocity along the circle and change
                        // the radius. If no input is given the
                        // vehicle will hold position.
mavlink20.MAV_CMD_CONDITION_GATE = 4501 // Delay mission state machine until gate has been reached.
mavlink20.MAV_CMD_NAV_FENCE_RETURN_POINT = 5000 // Fence return point (there can only be one such point in a geofence
                        // definition). If rally points are supported
                        // they should be used instead.
mavlink20.MAV_CMD_NAV_FENCE_POLYGON_VERTEX_INCLUSION = 5001 // Fence vertex for an inclusion polygon (the polygon must not be self-
                        // intersecting). The vehicle must stay within
                        // this area. Minimum of 3 vertices required.
mavlink20.MAV_CMD_NAV_FENCE_POLYGON_VERTEX_EXCLUSION = 5002 // Fence vertex for an exclusion polygon (the polygon must not be self-
                        // intersecting). The vehicle must stay
                        // outside this area. Minimum of 3 vertices
                        // required.
mavlink20.MAV_CMD_NAV_FENCE_CIRCLE_INCLUSION = 5003 // Circular fence area. The vehicle must stay inside this area.
mavlink20.MAV_CMD_NAV_FENCE_CIRCLE_EXCLUSION = 5004 // Circular fence area. The vehicle must stay outside this area.
mavlink20.MAV_CMD_NAV_RALLY_POINT = 5100 // Rally point. You can have multiple rally points defined.
mavlink20.MAV_CMD_UAVCAN_GET_NODE_INFO = 5200 // Commands the vehicle to respond with a sequence of messages
                        // UAVCAN_NODE_INFO, one message per every
                        // UAVCAN node that is online. Note that some
                        // of the response messages can be lost, which
                        // the receiver can detect easily by checking
                        // whether every received UAVCAN_NODE_STATUS
                        // has a matching message UAVCAN_NODE_INFO
                        // received earlier; if not, this command
                        // should be sent again in order to request
                        // re-transmission of the node information
                        // messages.
mavlink20.MAV_CMD_DO_SET_SAFETY_SWITCH_STATE = 5300 // Change state of safety switch.
mavlink20.MAV_CMD_DO_ADSB_OUT_IDENT = 10001 // Trigger the start of an ADSB-out IDENT. This should only be used when
                        // requested to do so by an Air Traffic
                        // Controller in controlled airspace. This
                        // starts the IDENT which is then typically
                        // held for 18 seconds by the hardware per the
                        // Mode A, C, and S transponder spec.
mavlink20.MAV_CMD_LOWEHEISER_SET_STATE = 10151 // Set Loweheiser desired states
mavlink20.MAV_CMD_ODID_SET_EMERGENCY = 12900 // Used to manually set/unset emergency status for remote id.
                        // This is for compliance with MOC ASTM docs,
                        // specifically F358 section 7.7: "Emergency
                        // Status Indicator".           The
                        // requirement can also be satisfied by
                        // automatic setting of the emergency status
                        // by flight stack, and that approach is
                        // preferred.           See https://mavlink.io
                        // /en/services/opendroneid.html for more
                        // information.
mavlink20.MAV_CMD_PAYLOAD_PREPARE_DEPLOY = 30001 // Deploy payload on a Lat / Lon / Alt position. This includes the
                        // navigation to reach the required release
                        // position and velocity.
mavlink20.MAV_CMD_PAYLOAD_CONTROL_DEPLOY = 30002 // Control the payload deployment.
mavlink20.MAV_CMD_WAYPOINT_USER_1 = 31000 // User defined waypoint item. Ground Station will show the Vehicle as
                        // flying through this item.
mavlink20.MAV_CMD_WAYPOINT_USER_2 = 31001 // User defined waypoint item. Ground Station will show the Vehicle as
                        // flying through this item.
mavlink20.MAV_CMD_WAYPOINT_USER_3 = 31002 // User defined waypoint item. Ground Station will show the Vehicle as
                        // flying through this item.
mavlink20.MAV_CMD_WAYPOINT_USER_4 = 31003 // User defined waypoint item. Ground Station will show the Vehicle as
                        // flying through this item.
mavlink20.MAV_CMD_WAYPOINT_USER_5 = 31004 // User defined waypoint item. Ground Station will show the Vehicle as
                        // flying through this item.
mavlink20.MAV_CMD_SPATIAL_USER_1 = 31005 // User defined spatial item. Ground Station will not show the Vehicle as
                        // flying through this item. Example: ROI
                        // item.
mavlink20.MAV_CMD_SPATIAL_USER_2 = 31006 // User defined spatial item. Ground Station will not show the Vehicle as
                        // flying through this item. Example: ROI
                        // item.
mavlink20.MAV_CMD_SPATIAL_USER_3 = 31007 // User defined spatial item. Ground Station will not show the Vehicle as
                        // flying through this item. Example: ROI
                        // item.
mavlink20.MAV_CMD_SPATIAL_USER_4 = 31008 // User defined spatial item. Ground Station will not show the Vehicle as
                        // flying through this item. Example: ROI
                        // item.
mavlink20.MAV_CMD_SPATIAL_USER_5 = 31009 // User defined spatial item. Ground Station will not show the Vehicle as
                        // flying through this item. Example: ROI
                        // item.
mavlink20.MAV_CMD_USER_1 = 31010 // User defined command. Ground Station will not show the Vehicle as
                        // flying through this item. Example:
                        // MAV_CMD_DO_SET_PARAMETER item.
mavlink20.MAV_CMD_USER_2 = 31011 // User defined command. Ground Station will not show the Vehicle as
                        // flying through this item. Example:
                        // MAV_CMD_DO_SET_PARAMETER item.
mavlink20.MAV_CMD_USER_3 = 31012 // User defined command. Ground Station will not show the Vehicle as
                        // flying through this item. Example:
                        // MAV_CMD_DO_SET_PARAMETER item.
mavlink20.MAV_CMD_USER_4 = 31013 // User defined command. Ground Station will not show the Vehicle as
                        // flying through this item. Example:
                        // MAV_CMD_DO_SET_PARAMETER item.
mavlink20.MAV_CMD_USER_5 = 31014 // User defined command. Ground Station will not show the Vehicle as
                        // flying through this item. Example:
                        // MAV_CMD_DO_SET_PARAMETER item.
mavlink20.MAV_CMD_CAN_FORWARD = 32000 // Request forwarding of CAN packets from the given CAN bus to this
                        // component. CAN Frames are sent using
                        // CAN_FRAME and CANFD_FRAME messages
mavlink20.MAV_CMD_REQUEST_OPERATOR_CONTROL = 32100 // Request GCS control of a system (or of a specific component in a
                        // system).            A controlled system
                        // should only accept MAVLink commands and
                        // command-like messages that are sent by its
                        // controlling GCS, or from other components
                        // with the same system id.           Commands
                        // from other systems should be rejected with
                        // MAV_RESULT_FAILED (except for this command,
                        // which may be acknowledged with
                        // MAV_RESULT_ACCEPTED if control is granted).
                        // Command-like messages should be ignored (or
                        // rejected if that is supported by their
                        // associated protocol).            GCS
                        // control of the whole system is managed via
                        // a single component that we will refer to
                        // here as the "system manager component".
                        // This component streams the CONTROL_STATUS
                        // message and sets the
                        // GCS_CONTROL_STATUS_FLAGS_SYSTEM_MANAGER
                        // flag.           Other components in the
                        // system should monitor for the
                        // CONTROL_STATUS message with this flag, and
                        // set their controlling GCS to match its
                        // published system id.           A GCS that
                        // wants to control the system should also
                        // monitor for the same message and flag, and
                        // address the
                        // MAV_CMD_REQUEST_OPERATOR_CONTROL to its
                        // component id.           Note that
                        // integrators are required to ensure that
                        // there is only one system manager component
                        // in the system (i.e. one component emitting
                        // the message with
                        // GCS_CONTROL_STATUS_FLAGS_SYSTEM_MANAGER
                        // set).               The
                        // MAV_CMD_REQUEST_OPERATOR_CONTROL command is
                        // sent by a GCS to the system manager
                        // component to request or release control of
                        // a system, specifying whether subsequent
                        // takeover requests from another GCS are
                        // automatically granted, or require
                        // permission.            The system manager
                        // component should grant control to the GCS
                        // if the system does not require takeover
                        // permission (or is uncontrolled) and ACK the
                        // request with MAV_RESULT_ACCEPTED.
                        // The system manager component should then
                        // stream CONTROL_STATUS indicating its
                        // controlling system: all other components
                        // with the same system id should monitor this
                        // message and set their own controlling GCS
                        // to match that of the system manager
                        // component.            If the system manager
                        // component cannot grant control (because
                        // takeover requires permission), the request
                        // should be rejected with MAV_RESULT_FAILED.
                        // The system manager component should then
                        // send this same command to the current
                        // owning GCS in order to notify of the
                        // request.           The owning GCS would ACK
                        // with MAV_RESULT_ACCEPTED, and might choose
                        // to release control of the vehicle, or re-
                        // request control with the takeover bit set
                        // to allow permission.            In case it
                        // choses to re-request control with takeover
                        // bit set to allow permission, requestor GCS
                        // will only have 10 seconds to get control,
                        // otherwise owning GCS will re-request
                        // control with takeover bit set to disallow
                        // permission, and requestor GCS will need
                        // repeat the request if still interested in
                        // getting control.           Note that the
                        // pilots of both GCS should co-ordinate safe
                        // handover offline.                      Note
                        // that in most systems the only controlled
                        // component will be the "system manager
                        // component", and that will be the autopilot.
                        // However separate GCS control of a
                        // particular component is also permitted, if
                        // supported by the component.           In
                        // this case the GCS will address
                        // MAV_CMD_REQUEST_OPERATOR_CONTROL to the
                        // specific component it wants to control.
                        // The component will then stream
                        // CONTROL_STATUS for its controlling GCS (it
                        // must not set
                        // GCS_CONTROL_STATUS_FLAGS_SYSTEM_MANAGER).
                        // The component should fall back to the
                        // system GCS (if any) when it is not directly
                        // controlled, and may stop emitting
                        // CONTROL_STATUS.           The flow is
                        // otherwise the same as for requesting
                        // control over the whole system.
mavlink20.MAV_CMD_RESET_MPPT = 40001 // Mission command to reset Maximum Power Point Tracker (MPPT)
mavlink20.MAV_CMD_PAYLOAD_CONTROL = 40002 // Mission command to perform a power cycle on payload
mavlink20.MAV_CMD_POWER_OFF_INITIATED = 42000 // A system wide power-off event has been initiated.
mavlink20.MAV_CMD_SOLO_BTN_FLY_CLICK = 42001 // FLY button has been clicked.
mavlink20.MAV_CMD_SOLO_BTN_FLY_HOLD = 42002 // FLY button has been held for 1.5 seconds.
mavlink20.MAV_CMD_SOLO_BTN_PAUSE_CLICK = 42003 // PAUSE button has been clicked.
mavlink20.MAV_CMD_FIXED_MAG_CAL = 42004 // Magnetometer calibration based on fixed position         in earth
                        // field given by inclination, declination and
                        // intensity.
mavlink20.MAV_CMD_FIXED_MAG_CAL_FIELD = 42005 // Magnetometer calibration based on fixed expected field values.
mavlink20.MAV_CMD_FIXED_MAG_CAL_YAW = 42006 // Magnetometer calibration based on provided known yaw. This allows for
                        // fast calibration using WMM field tables in
                        // the vehicle, given only the known yaw of
                        // the vehicle. If Latitude and longitude are
                        // both zero then use the current vehicle
                        // location.
mavlink20.MAV_CMD_SET_EKF_SOURCE_SET = 42007 // Set EKF sensor source set.
mavlink20.MAV_CMD_DO_START_MAG_CAL = 42424 // Initiate a magnetometer calibration.
mavlink20.MAV_CMD_DO_ACCEPT_MAG_CAL = 42425 // Accept a magnetometer calibration.
mavlink20.MAV_CMD_DO_CANCEL_MAG_CAL = 42426 // Cancel a running magnetometer calibration.
mavlink20.MAV_CMD_SET_FACTORY_TEST_MODE = 42427 // Command autopilot to get into factory test/diagnostic mode.
mavlink20.MAV_CMD_DO_SEND_BANNER = 42428 // Reply with the version banner.
mavlink20.MAV_CMD_ACCELCAL_VEHICLE_POS = 42429 // Used when doing accelerometer calibration. When sent to the GCS tells
                        // it what position to put the vehicle in.
                        // When sent to the vehicle says what position
                        // the vehicle is in.
mavlink20.MAV_CMD_GIMBAL_RESET = 42501 // Causes the gimbal to reset and boot as if it was just powered on.
mavlink20.MAV_CMD_GIMBAL_AXIS_CALIBRATION_STATUS = 42502 // Reports progress and success or failure of gimbal axis calibration
                        // procedure.
mavlink20.MAV_CMD_GIMBAL_REQUEST_AXIS_CALIBRATION = 42503 // Starts commutation calibration on the gimbal.
mavlink20.MAV_CMD_GIMBAL_FULL_RESET = 42505 // Erases gimbal application and parameters.
mavlink20.MAV_CMD_DO_WINCH = 42600 // Command to operate winch.
mavlink20.MAV_CMD_FLASH_BOOTLOADER = 42650 // Update the bootloader
mavlink20.MAV_CMD_BATTERY_RESET = 42651 // Reset battery capacity for batteries that accumulate consumed battery
                        // via integration.
mavlink20.MAV_CMD_DEBUG_TRAP = 42700 // Issue a trap signal to the autopilot process, presumably to enter the
                        // debugger.
mavlink20.MAV_CMD_SCRIPTING = 42701 // Control onboard scripting.
mavlink20.MAV_CMD_NAV_SCRIPT_TIME = 42702 // Scripting command as NAV command with wait for completion.
mavlink20.MAV_CMD_NAV_ATTITUDE_TIME = 42703 // Maintain an attitude for a specified time.
mavlink20.MAV_CMD_GUIDED_CHANGE_SPEED = 43000 // Change flight speed at a given rate. This slews the vehicle at a
                        // controllable rate between it's previous
                        // speed and the new one. (affects GUIDED
                        // only. Outside GUIDED, aircraft ignores
                        // these commands. Designed for onboard
                        // companion-computer command-and-control, not
                        // normally operator/GCS control.)
mavlink20.MAV_CMD_GUIDED_CHANGE_ALTITUDE = 43001 // Change target altitude at a given rate. This slews the vehicle at a
                        // controllable rate between it's previous
                        // altitude and the new one. (affects GUIDED
                        // only. Outside GUIDED, aircraft ignores
                        // these commands. Designed for onboard
                        // companion-computer command-and-control, not
                        // normally operator/GCS control.)
mavlink20.MAV_CMD_GUIDED_CHANGE_HEADING = 43002 // Change to target heading at a given rate, overriding previous
                        // heading/s. This slews the vehicle at a
                        // controllable rate between it's previous
                        // heading and the new one. (affects GUIDED
                        // only. Exiting GUIDED returns aircraft to
                        // normal behaviour defined elsewhere.
                        // Designed for onboard companion-computer
                        // command-and-control, not normally
                        // operator/GCS control.)
mavlink20.MAV_CMD_EXTERNAL_POSITION_ESTIMATE = 43003 // Provide an external position estimate for use when dead-reckoning.
                        // This is meant to be used for occasional
                        // position resets that may be provided by a
                        // external system such as a remote pilot
                        // using landmarks over a video link.
mavlink20.MAV_CMD_EXTERNAL_WIND_ESTIMATE = 43004 // Set an external estimate of wind direction and speed.           This
                        // might be used to provide an initial wind
                        // estimate to the estimator (EKF) in the case
                        // where the vehicle is wind dead-reckoning,
                        // extending the time when operating without
                        // GPS before before position drift builds to
                        // an unsafe level. For this use case the
                        // command might reasonably be sent every few
                        // minutes when operating at altitude, and the
                        // value is cleared if the estimator resets
                        // itself.
mavlink20.MAV_CMD_SET_HAGL = 43005 // Provide a value for height above ground level. This can be used for
                        // things like fixed wing and VTOL landing.
mavlink20.MAV_CMD_STORM32_DO_GIMBAL_MANAGER_CONTROL_PITCHYAW = 60002 // Command to a gimbal manager to control the gimbal tilt and pan angles.
                        // It is possible to set combinations of the
                        // values below. E.g. an angle as well as a
                        // desired angular rate can be used to get to
                        // this angle at a certain angular rate, or an
                        // angular rate only will result in continuous
                        // turning. NaN is to be used to signal unset.
                        // A gimbal device is never to react to this
                        // command.
mavlink20.MAV_CMD_STORM32_DO_GIMBAL_MANAGER_SETUP = 60010 // Command to configure a gimbal manager. A gimbal device is never to
                        // react to this command. The selected profile
                        // is reported in the
                        // STORM32_GIMBAL_MANAGER_STATUS message.
mavlink20.MAV_CMD_QSHOT_DO_CONFIGURE = 60020 // Command to set the shot manager mode.
mavlink20.MAV_CMD_PRS_SET_ARM = 60050 // AVSS defined command. Set PRS arm statuses.
mavlink20.MAV_CMD_PRS_GET_ARM = 60051 // AVSS defined command. Gets PRS arm statuses
mavlink20.MAV_CMD_PRS_GET_BATTERY = 60052 // AVSS defined command.  Get the PRS battery voltage in millivolts
mavlink20.MAV_CMD_PRS_GET_ERR = 60053 // AVSS defined command. Get the PRS error statuses.
mavlink20.MAV_CMD_PRS_SET_ARM_ALTI = 60070 // AVSS defined command. Set the ATS arming altitude in meters.
mavlink20.MAV_CMD_PRS_GET_ARM_ALTI = 60071 // AVSS defined command. Get the ATS arming altitude in meters.
mavlink20.MAV_CMD_PRS_SHUTDOWN = 60072 // AVSS defined command. Shuts down the PRS system.
mavlink20.MAV_CMD_ENUM_END = 60073 // 

// SCRIPTING_CMD
mavlink20.SCRIPTING_CMD_REPL_START = 0 // Start a REPL session.
mavlink20.SCRIPTING_CMD_REPL_STOP = 1 // End a REPL session.
mavlink20.SCRIPTING_CMD_STOP = 2 // Stop execution of scripts.
mavlink20.SCRIPTING_CMD_STOP_AND_RESTART = 3 // Stop execution of scripts and restart.
mavlink20.SCRIPTING_CMD_ENUM_END = 4 // 

// SECURE_COMMAND_OP
mavlink20.SECURE_COMMAND_GET_SESSION_KEY = 0 // Get an 8 byte session key which is used for remote secure updates
                        // which operate on flight controller data
                        // such as bootloader public keys. Return data
                        // will be 8 bytes on success. The session key
                        // remains valid until either the flight
                        // controller reboots or another
                        // SECURE_COMMAND_GET_SESSION_KEY is run.
mavlink20.SECURE_COMMAND_GET_REMOTEID_SESSION_KEY = 1 // Get an 8 byte session key which is used for remote secure updates
                        // which operate on RemoteID module data.
                        // Return data will be 8 bytes on success. The
                        // session key remains valid until either the
                        // remote ID module reboots or another
                        // SECURE_COMMAND_GET_REMOTEID_SESSION_KEY is
                        // run.
mavlink20.SECURE_COMMAND_REMOVE_PUBLIC_KEYS = 2 // Remove range of public keys from the bootloader. Command data consists
                        // of two bytes, first byte if index of first
                        // public key to remove. Second byte is the
                        // number of keys to remove. If all keys are
                        // removed then secure boot is disabled and
                        // insecure firmware can be loaded.
mavlink20.SECURE_COMMAND_GET_PUBLIC_KEYS = 3 // Get current public keys from the bootloader. Command data consists of
                        // two bytes, first byte is index of first
                        // public key to fetch, 2nd byte is number of
                        // keys to fetch. Total data needs to fit in
                        // data portion of reply (max 6 keys for 32
                        // byte keys). Reply data has the index of the
                        // first key in the first byte, followed by
                        // the keys. Returned keys may be less than
                        // the number of keys requested if there are
                        // less keys installed than requested.
mavlink20.SECURE_COMMAND_SET_PUBLIC_KEYS = 4 // Set current public keys in the bootloader. Data consists of a one byte
                        // public key index followed by the public
                        // keys. With 32 byte keys this allows for up
                        // to 6 keys to be set in one request. Keys
                        // outside of the range that is being set will
                        // remain unchanged.
mavlink20.SECURE_COMMAND_GET_REMOTEID_CONFIG = 5 // Get config data for remote ID module. This command should be sent to
                        // the component ID of the flight controller
                        // which will forward it to the RemoteID
                        // module either over mavlink or DroneCAN.
                        // Data format is specific to the RemoteID
                        // implementation, see RemoteID firmware
                        // documentation for details.
mavlink20.SECURE_COMMAND_SET_REMOTEID_CONFIG = 6 // Set config data for remote ID module. This command should be sent to
                        // the component ID of the flight controller
                        // which will forward it to the RemoteID
                        // module either over mavlink or DroneCAN.
                        // Data format is specific to the RemoteID
                        // implementation, see RemoteID firmware
                        // documentation for details.
mavlink20.SECURE_COMMAND_FLASH_BOOTLOADER = 7 // Flash bootloader from local storage. Data is the filename to use for
                        // the bootloader. This is intended to be used
                        // with MAVFtp to upload a new bootloader to a
                        // microSD before flashing.
mavlink20.SECURE_COMMAND_OP_ENUM_END = 8 // 

// LIMITS_STATE
mavlink20.LIMITS_INIT = 0 // Pre-initialization.
mavlink20.LIMITS_DISABLED = 1 // Disabled.
mavlink20.LIMITS_ENABLED = 2 // Checking limits.
mavlink20.LIMITS_TRIGGERED = 3 // A limit has been breached.
mavlink20.LIMITS_RECOVERING = 4 // Taking action e.g. Return/RTL.
mavlink20.LIMITS_RECOVERED = 5 // We're no longer in breach of a limit.
mavlink20.LIMITS_STATE_ENUM_END = 6 // 

// LIMIT_MODULE
mavlink20.LIMIT_GPSLOCK = 1 // Pre-initialization.
mavlink20.LIMIT_GEOFENCE = 2 // Disabled.
mavlink20.LIMIT_ALTITUDE = 4 // Checking limits.
mavlink20.LIMIT_MODULE_ENUM_END = 5 // 

// RALLY_FLAGS
mavlink20.FAVORABLE_WIND = 1 // Flag set when requiring favorable winds for landing.
mavlink20.LAND_IMMEDIATELY = 2 // Flag set when plane is to immediately descend to break altitude and
                        // land without GCS intervention. Flag not set
                        // when plane is to loiter at Rally point
                        // until commanded to land.
mavlink20.ALT_FRAME_VALID = 4 // True if the following altitude frame value is valid.
mavlink20.ALT_FRAME = 24 // 2 bit value representing altitude frame. 0: absolute, 1: relative
                        // home, 2: relative origin, 3: relative
                        // terrain
mavlink20.RALLY_FLAGS_ENUM_END = 25 // 

// CAMERA_STATUS_TYPES
mavlink20.CAMERA_STATUS_TYPE_HEARTBEAT = 0 // Camera heartbeat, announce camera component ID at 1Hz.
mavlink20.CAMERA_STATUS_TYPE_TRIGGER = 1 // Camera image triggered.
mavlink20.CAMERA_STATUS_TYPE_DISCONNECT = 2 // Camera connection lost.
mavlink20.CAMERA_STATUS_TYPE_ERROR = 3 // Camera unknown error.
mavlink20.CAMERA_STATUS_TYPE_LOWBATT = 4 // Camera battery low. Parameter p1 shows reported voltage.
mavlink20.CAMERA_STATUS_TYPE_LOWSTORE = 5 // Camera storage low. Parameter p1 shows reported shots remaining.
mavlink20.CAMERA_STATUS_TYPE_LOWSTOREV = 6 // Camera storage low. Parameter p1 shows reported video minutes
                        // remaining.
mavlink20.CAMERA_STATUS_TYPES_ENUM_END = 7 // 

// CAMERA_FEEDBACK_FLAGS
mavlink20.CAMERA_FEEDBACK_PHOTO = 0 // Shooting photos, not video.
mavlink20.CAMERA_FEEDBACK_VIDEO = 1 // Shooting video, not stills.
mavlink20.CAMERA_FEEDBACK_BADEXPOSURE = 2 // Unable to achieve requested exposure (e.g. shutter speed too low).
mavlink20.CAMERA_FEEDBACK_CLOSEDLOOP = 3 // Closed loop feedback from camera, we know for sure it has successfully
                        // taken a picture.
mavlink20.CAMERA_FEEDBACK_OPENLOOP = 4 // Open loop camera, an image trigger has been requested but we can't
                        // know for sure it has successfully taken a
                        // picture.
mavlink20.CAMERA_FEEDBACK_FLAGS_ENUM_END = 5 // 

// MAV_MODE_GIMBAL
mavlink20.MAV_MODE_GIMBAL_UNINITIALIZED = 0 // Gimbal is powered on but has not started initializing yet.
mavlink20.MAV_MODE_GIMBAL_CALIBRATING_PITCH = 1 // Gimbal is currently running calibration on the pitch axis.
mavlink20.MAV_MODE_GIMBAL_CALIBRATING_ROLL = 2 // Gimbal is currently running calibration on the roll axis.
mavlink20.MAV_MODE_GIMBAL_CALIBRATING_YAW = 3 // Gimbal is currently running calibration on the yaw axis.
mavlink20.MAV_MODE_GIMBAL_INITIALIZED = 4 // Gimbal has finished calibrating and initializing, but is relaxed
                        // pending reception of first rate command
                        // from copter.
mavlink20.MAV_MODE_GIMBAL_ACTIVE = 5 // Gimbal is actively stabilizing.
mavlink20.MAV_MODE_GIMBAL_RATE_CMD_TIMEOUT = 6 // Gimbal is relaxed because it missed more than 10 expected rate command
                        // messages in a row. Gimbal will move back to
                        // active mode when it receives a new rate
                        // command.
mavlink20.MAV_MODE_GIMBAL_ENUM_END = 7 // 

// GIMBAL_AXIS
mavlink20.GIMBAL_AXIS_YAW = 0 // Gimbal yaw axis.
mavlink20.GIMBAL_AXIS_PITCH = 1 // Gimbal pitch axis.
mavlink20.GIMBAL_AXIS_ROLL = 2 // Gimbal roll axis.
mavlink20.GIMBAL_AXIS_ENUM_END = 3 // 

// GIMBAL_AXIS_CALIBRATION_STATUS
mavlink20.GIMBAL_AXIS_CALIBRATION_STATUS_IN_PROGRESS = 0 // Axis calibration is in progress.
mavlink20.GIMBAL_AXIS_CALIBRATION_STATUS_SUCCEEDED = 1 // Axis calibration succeeded.
mavlink20.GIMBAL_AXIS_CALIBRATION_STATUS_FAILED = 2 // Axis calibration failed.
mavlink20.GIMBAL_AXIS_CALIBRATION_STATUS_ENUM_END = 3 // 

// GIMBAL_AXIS_CALIBRATION_REQUIRED
mavlink20.GIMBAL_AXIS_CALIBRATION_REQUIRED_UNKNOWN = 0 // Whether or not this axis requires calibration is unknown at this time.
mavlink20.GIMBAL_AXIS_CALIBRATION_REQUIRED_TRUE = 1 // This axis requires calibration.
mavlink20.GIMBAL_AXIS_CALIBRATION_REQUIRED_FALSE = 2 // This axis does not require calibration.
mavlink20.GIMBAL_AXIS_CALIBRATION_REQUIRED_ENUM_END = 3 // 

// GOPRO_HEARTBEAT_STATUS
mavlink20.GOPRO_HEARTBEAT_STATUS_DISCONNECTED = 0 // No GoPro connected.
mavlink20.GOPRO_HEARTBEAT_STATUS_INCOMPATIBLE = 1 // The detected GoPro is not HeroBus compatible.
mavlink20.GOPRO_HEARTBEAT_STATUS_CONNECTED = 2 // A HeroBus compatible GoPro is connected.
mavlink20.GOPRO_HEARTBEAT_STATUS_ERROR = 3 // An unrecoverable error was encountered with the connected GoPro, it
                        // may require a power cycle.
mavlink20.GOPRO_HEARTBEAT_STATUS_ENUM_END = 4 // 

// GOPRO_HEARTBEAT_FLAGS
mavlink20.GOPRO_FLAG_RECORDING = 1 // GoPro is currently recording.
mavlink20.GOPRO_HEARTBEAT_FLAGS_ENUM_END = 2 // 

// GOPRO_REQUEST_STATUS
mavlink20.GOPRO_REQUEST_SUCCESS = 0 // The write message with ID indicated succeeded.
mavlink20.GOPRO_REQUEST_FAILED = 1 // The write message with ID indicated failed.
mavlink20.GOPRO_REQUEST_STATUS_ENUM_END = 2 // 

// GOPRO_COMMAND
mavlink20.GOPRO_COMMAND_POWER = 0 // (Get/Set).
mavlink20.GOPRO_COMMAND_CAPTURE_MODE = 1 // (Get/Set).
mavlink20.GOPRO_COMMAND_SHUTTER = 2 // (___/Set).
mavlink20.GOPRO_COMMAND_BATTERY = 3 // (Get/___).
mavlink20.GOPRO_COMMAND_MODEL = 4 // (Get/___).
mavlink20.GOPRO_COMMAND_VIDEO_SETTINGS = 5 // (Get/Set).
mavlink20.GOPRO_COMMAND_LOW_LIGHT = 6 // (Get/Set).
mavlink20.GOPRO_COMMAND_PHOTO_RESOLUTION = 7 // (Get/Set).
mavlink20.GOPRO_COMMAND_PHOTO_BURST_RATE = 8 // (Get/Set).
mavlink20.GOPRO_COMMAND_PROTUNE = 9 // (Get/Set).
mavlink20.GOPRO_COMMAND_PROTUNE_WHITE_BALANCE = 10 // (Get/Set) Hero 3+ Only.
mavlink20.GOPRO_COMMAND_PROTUNE_COLOUR = 11 // (Get/Set) Hero 3+ Only.
mavlink20.GOPRO_COMMAND_PROTUNE_GAIN = 12 // (Get/Set) Hero 3+ Only.
mavlink20.GOPRO_COMMAND_PROTUNE_SHARPNESS = 13 // (Get/Set) Hero 3+ Only.
mavlink20.GOPRO_COMMAND_PROTUNE_EXPOSURE = 14 // (Get/Set) Hero 3+ Only.
mavlink20.GOPRO_COMMAND_TIME = 15 // (Get/Set).
mavlink20.GOPRO_COMMAND_CHARGING = 16 // (Get/Set).
mavlink20.GOPRO_COMMAND_ENUM_END = 17 // 

// GOPRO_CAPTURE_MODE
mavlink20.GOPRO_CAPTURE_MODE_VIDEO = 0 // Video mode.
mavlink20.GOPRO_CAPTURE_MODE_PHOTO = 1 // Photo mode.
mavlink20.GOPRO_CAPTURE_MODE_BURST = 2 // Burst mode, Hero 3+ only.
mavlink20.GOPRO_CAPTURE_MODE_TIME_LAPSE = 3 // Time lapse mode, Hero 3+ only.
mavlink20.GOPRO_CAPTURE_MODE_MULTI_SHOT = 4 // Multi shot mode, Hero 4 only.
mavlink20.GOPRO_CAPTURE_MODE_PLAYBACK = 5 // Playback mode, Hero 4 only, silver only except when LCD or HDMI is
                        // connected to black.
mavlink20.GOPRO_CAPTURE_MODE_SETUP = 6 // Playback mode, Hero 4 only.
mavlink20.GOPRO_CAPTURE_MODE_UNKNOWN = 255 // Mode not yet known.
mavlink20.GOPRO_CAPTURE_MODE_ENUM_END = 256 // 

// GOPRO_RESOLUTION
mavlink20.GOPRO_RESOLUTION_480p = 0 // 848 x 480 (480p).
mavlink20.GOPRO_RESOLUTION_720p = 1 // 1280 x 720 (720p).
mavlink20.GOPRO_RESOLUTION_960p = 2 // 1280 x 960 (960p).
mavlink20.GOPRO_RESOLUTION_1080p = 3 // 1920 x 1080 (1080p).
mavlink20.GOPRO_RESOLUTION_1440p = 4 // 1920 x 1440 (1440p).
mavlink20.GOPRO_RESOLUTION_2_7k_17_9 = 5 // 2704 x 1440 (2.7k-17:9).
mavlink20.GOPRO_RESOLUTION_2_7k_16_9 = 6 // 2704 x 1524 (2.7k-16:9).
mavlink20.GOPRO_RESOLUTION_2_7k_4_3 = 7 // 2704 x 2028 (2.7k-4:3).
mavlink20.GOPRO_RESOLUTION_4k_16_9 = 8 // 3840 x 2160 (4k-16:9).
mavlink20.GOPRO_RESOLUTION_4k_17_9 = 9 // 4096 x 2160 (4k-17:9).
mavlink20.GOPRO_RESOLUTION_720p_SUPERVIEW = 10 // 1280 x 720 (720p-SuperView).
mavlink20.GOPRO_RESOLUTION_1080p_SUPERVIEW = 11 // 1920 x 1080 (1080p-SuperView).
mavlink20.GOPRO_RESOLUTION_2_7k_SUPERVIEW = 12 // 2704 x 1520 (2.7k-SuperView).
mavlink20.GOPRO_RESOLUTION_4k_SUPERVIEW = 13 // 3840 x 2160 (4k-SuperView).
mavlink20.GOPRO_RESOLUTION_ENUM_END = 14 // 

// GOPRO_FRAME_RATE
mavlink20.GOPRO_FRAME_RATE_12 = 0 // 12 FPS.
mavlink20.GOPRO_FRAME_RATE_15 = 1 // 15 FPS.
mavlink20.GOPRO_FRAME_RATE_24 = 2 // 24 FPS.
mavlink20.GOPRO_FRAME_RATE_25 = 3 // 25 FPS.
mavlink20.GOPRO_FRAME_RATE_30 = 4 // 30 FPS.
mavlink20.GOPRO_FRAME_RATE_48 = 5 // 48 FPS.
mavlink20.GOPRO_FRAME_RATE_50 = 6 // 50 FPS.
mavlink20.GOPRO_FRAME_RATE_60 = 7 // 60 FPS.
mavlink20.GOPRO_FRAME_RATE_80 = 8 // 80 FPS.
mavlink20.GOPRO_FRAME_RATE_90 = 9 // 90 FPS.
mavlink20.GOPRO_FRAME_RATE_100 = 10 // 100 FPS.
mavlink20.GOPRO_FRAME_RATE_120 = 11 // 120 FPS.
mavlink20.GOPRO_FRAME_RATE_240 = 12 // 240 FPS.
mavlink20.GOPRO_FRAME_RATE_12_5 = 13 // 12.5 FPS.
mavlink20.GOPRO_FRAME_RATE_ENUM_END = 14 // 

// GOPRO_FIELD_OF_VIEW
mavlink20.GOPRO_FIELD_OF_VIEW_WIDE = 0 // 0x00: Wide.
mavlink20.GOPRO_FIELD_OF_VIEW_MEDIUM = 1 // 0x01: Medium.
mavlink20.GOPRO_FIELD_OF_VIEW_NARROW = 2 // 0x02: Narrow.
mavlink20.GOPRO_FIELD_OF_VIEW_ENUM_END = 3 // 

// GOPRO_VIDEO_SETTINGS_FLAGS
mavlink20.GOPRO_VIDEO_SETTINGS_TV_MODE = 1 // 0=NTSC, 1=PAL.
mavlink20.GOPRO_VIDEO_SETTINGS_FLAGS_ENUM_END = 2 // 

// GOPRO_PHOTO_RESOLUTION
mavlink20.GOPRO_PHOTO_RESOLUTION_5MP_MEDIUM = 0 // 5MP Medium.
mavlink20.GOPRO_PHOTO_RESOLUTION_7MP_MEDIUM = 1 // 7MP Medium.
mavlink20.GOPRO_PHOTO_RESOLUTION_7MP_WIDE = 2 // 7MP Wide.
mavlink20.GOPRO_PHOTO_RESOLUTION_10MP_WIDE = 3 // 10MP Wide.
mavlink20.GOPRO_PHOTO_RESOLUTION_12MP_WIDE = 4 // 12MP Wide.
mavlink20.GOPRO_PHOTO_RESOLUTION_ENUM_END = 5 // 

// GOPRO_PROTUNE_WHITE_BALANCE
mavlink20.GOPRO_PROTUNE_WHITE_BALANCE_AUTO = 0 // Auto.
mavlink20.GOPRO_PROTUNE_WHITE_BALANCE_3000K = 1 // 3000K.
mavlink20.GOPRO_PROTUNE_WHITE_BALANCE_5500K = 2 // 5500K.
mavlink20.GOPRO_PROTUNE_WHITE_BALANCE_6500K = 3 // 6500K.
mavlink20.GOPRO_PROTUNE_WHITE_BALANCE_RAW = 4 // Camera Raw.
mavlink20.GOPRO_PROTUNE_WHITE_BALANCE_ENUM_END = 5 // 

// GOPRO_PROTUNE_COLOUR
mavlink20.GOPRO_PROTUNE_COLOUR_STANDARD = 0 // Auto.
mavlink20.GOPRO_PROTUNE_COLOUR_NEUTRAL = 1 // Neutral.
mavlink20.GOPRO_PROTUNE_COLOUR_ENUM_END = 2 // 

// GOPRO_PROTUNE_GAIN
mavlink20.GOPRO_PROTUNE_GAIN_400 = 0 // ISO 400.
mavlink20.GOPRO_PROTUNE_GAIN_800 = 1 // ISO 800 (Only Hero 4).
mavlink20.GOPRO_PROTUNE_GAIN_1600 = 2 // ISO 1600.
mavlink20.GOPRO_PROTUNE_GAIN_3200 = 3 // ISO 3200 (Only Hero 4).
mavlink20.GOPRO_PROTUNE_GAIN_6400 = 4 // ISO 6400.
mavlink20.GOPRO_PROTUNE_GAIN_ENUM_END = 5 // 

// GOPRO_PROTUNE_SHARPNESS
mavlink20.GOPRO_PROTUNE_SHARPNESS_LOW = 0 // Low Sharpness.
mavlink20.GOPRO_PROTUNE_SHARPNESS_MEDIUM = 1 // Medium Sharpness.
mavlink20.GOPRO_PROTUNE_SHARPNESS_HIGH = 2 // High Sharpness.
mavlink20.GOPRO_PROTUNE_SHARPNESS_ENUM_END = 3 // 

// GOPRO_PROTUNE_EXPOSURE
mavlink20.GOPRO_PROTUNE_EXPOSURE_NEG_5_0 = 0 // -5.0 EV (Hero 3+ Only).
mavlink20.GOPRO_PROTUNE_EXPOSURE_NEG_4_5 = 1 // -4.5 EV (Hero 3+ Only).
mavlink20.GOPRO_PROTUNE_EXPOSURE_NEG_4_0 = 2 // -4.0 EV (Hero 3+ Only).
mavlink20.GOPRO_PROTUNE_EXPOSURE_NEG_3_5 = 3 // -3.5 EV (Hero 3+ Only).
mavlink20.GOPRO_PROTUNE_EXPOSURE_NEG_3_0 = 4 // -3.0 EV (Hero 3+ Only).
mavlink20.GOPRO_PROTUNE_EXPOSURE_NEG_2_5 = 5 // -2.5 EV (Hero 3+ Only).
mavlink20.GOPRO_PROTUNE_EXPOSURE_NEG_2_0 = 6 // -2.0 EV.
mavlink20.GOPRO_PROTUNE_EXPOSURE_NEG_1_5 = 7 // -1.5 EV.
mavlink20.GOPRO_PROTUNE_EXPOSURE_NEG_1_0 = 8 // -1.0 EV.
mavlink20.GOPRO_PROTUNE_EXPOSURE_NEG_0_5 = 9 // -0.5 EV.
mavlink20.GOPRO_PROTUNE_EXPOSURE_ZERO = 10 // 0.0 EV.
mavlink20.GOPRO_PROTUNE_EXPOSURE_POS_0_5 = 11 // +0.5 EV.
mavlink20.GOPRO_PROTUNE_EXPOSURE_POS_1_0 = 12 // +1.0 EV.
mavlink20.GOPRO_PROTUNE_EXPOSURE_POS_1_5 = 13 // +1.5 EV.
mavlink20.GOPRO_PROTUNE_EXPOSURE_POS_2_0 = 14 // +2.0 EV.
mavlink20.GOPRO_PROTUNE_EXPOSURE_POS_2_5 = 15 // +2.5 EV (Hero 3+ Only).
mavlink20.GOPRO_PROTUNE_EXPOSURE_POS_3_0 = 16 // +3.0 EV (Hero 3+ Only).
mavlink20.GOPRO_PROTUNE_EXPOSURE_POS_3_5 = 17 // +3.5 EV (Hero 3+ Only).
mavlink20.GOPRO_PROTUNE_EXPOSURE_POS_4_0 = 18 // +4.0 EV (Hero 3+ Only).
mavlink20.GOPRO_PROTUNE_EXPOSURE_POS_4_5 = 19 // +4.5 EV (Hero 3+ Only).
mavlink20.GOPRO_PROTUNE_EXPOSURE_POS_5_0 = 20 // +5.0 EV (Hero 3+ Only).
mavlink20.GOPRO_PROTUNE_EXPOSURE_ENUM_END = 21 // 

// GOPRO_CHARGING
mavlink20.GOPRO_CHARGING_DISABLED = 0 // Charging disabled.
mavlink20.GOPRO_CHARGING_ENABLED = 1 // Charging enabled.
mavlink20.GOPRO_CHARGING_ENUM_END = 2 // 

// GOPRO_MODEL
mavlink20.GOPRO_MODEL_UNKNOWN = 0 // Unknown gopro model.
mavlink20.GOPRO_MODEL_HERO_3_PLUS_SILVER = 1 // Hero 3+ Silver (HeroBus not supported by GoPro).
mavlink20.GOPRO_MODEL_HERO_3_PLUS_BLACK = 2 // Hero 3+ Black.
mavlink20.GOPRO_MODEL_HERO_4_SILVER = 3 // Hero 4 Silver.
mavlink20.GOPRO_MODEL_HERO_4_BLACK = 4 // Hero 4 Black.
mavlink20.GOPRO_MODEL_ENUM_END = 5 // 

// GOPRO_BURST_RATE
mavlink20.GOPRO_BURST_RATE_3_IN_1_SECOND = 0 // 3 Shots / 1 Second.
mavlink20.GOPRO_BURST_RATE_5_IN_1_SECOND = 1 // 5 Shots / 1 Second.
mavlink20.GOPRO_BURST_RATE_10_IN_1_SECOND = 2 // 10 Shots / 1 Second.
mavlink20.GOPRO_BURST_RATE_10_IN_2_SECOND = 3 // 10 Shots / 2 Second.
mavlink20.GOPRO_BURST_RATE_10_IN_3_SECOND = 4 // 10 Shots / 3 Second (Hero 4 Only).
mavlink20.GOPRO_BURST_RATE_30_IN_1_SECOND = 5 // 30 Shots / 1 Second.
mavlink20.GOPRO_BURST_RATE_30_IN_2_SECOND = 6 // 30 Shots / 2 Second.
mavlink20.GOPRO_BURST_RATE_30_IN_3_SECOND = 7 // 30 Shots / 3 Second.
mavlink20.GOPRO_BURST_RATE_30_IN_6_SECOND = 8 // 30 Shots / 6 Second.
mavlink20.GOPRO_BURST_RATE_ENUM_END = 9 // 

// MAV_CMD_DO_AUX_FUNCTION_SWITCH_LEVEL
mavlink20.MAV_CMD_DO_AUX_FUNCTION_SWITCH_LEVEL_LOW = 0 // Switch Low.
mavlink20.MAV_CMD_DO_AUX_FUNCTION_SWITCH_LEVEL_MIDDLE = 1 // Switch Middle.
mavlink20.MAV_CMD_DO_AUX_FUNCTION_SWITCH_LEVEL_HIGH = 2 // Switch High.
mavlink20.MAV_CMD_DO_AUX_FUNCTION_SWITCH_LEVEL_ENUM_END = 3 // 

// LED_CONTROL_PATTERN
mavlink20.LED_CONTROL_PATTERN_OFF = 0 // LED patterns off (return control to regular vehicle control).
mavlink20.LED_CONTROL_PATTERN_FIRMWAREUPDATE = 1 // LEDs show pattern during firmware update.
mavlink20.LED_CONTROL_PATTERN_CUSTOM = 255 // Custom Pattern using custom bytes fields.
mavlink20.LED_CONTROL_PATTERN_ENUM_END = 256 // 

// EKF_STATUS_FLAGS
mavlink20.EKF_ATTITUDE = 1 // Set if EKF's attitude estimate is good.
mavlink20.EKF_VELOCITY_HORIZ = 2 // Set if EKF's horizontal velocity estimate is good.
mavlink20.EKF_VELOCITY_VERT = 4 // Set if EKF's vertical velocity estimate is good.
mavlink20.EKF_POS_HORIZ_REL = 8 // Set if EKF's horizontal position (relative) estimate is good.
mavlink20.EKF_POS_HORIZ_ABS = 16 // Set if EKF's horizontal position (absolute) estimate is good.
mavlink20.EKF_POS_VERT_ABS = 32 // Set if EKF's vertical position (absolute) estimate is good.
mavlink20.EKF_POS_VERT_AGL = 64 // Set if EKF's vertical position (above ground) estimate is good.
mavlink20.EKF_CONST_POS_MODE = 128 // EKF is in constant position mode and does not know it's absolute or
                        // relative position.
mavlink20.EKF_PRED_POS_HORIZ_REL = 256 // Set if EKF's predicted horizontal position (relative) estimate is
                        // good.
mavlink20.EKF_PRED_POS_HORIZ_ABS = 512 // Set if EKF's predicted horizontal position (absolute) estimate is
                        // good.
mavlink20.EKF_UNINITIALIZED = 1024 // Set if EKF has never been healthy.
mavlink20.EKF_GPS_GLITCHING = 32768 // Set if EKF believes the GPS input data is faulty.
mavlink20.EKF_STATUS_FLAGS_ENUM_END = 32769 // 

// PID_TUNING_AXIS
mavlink20.PID_TUNING_ROLL = 1 // 
mavlink20.PID_TUNING_PITCH = 2 // 
mavlink20.PID_TUNING_YAW = 3 // 
mavlink20.PID_TUNING_ACCZ = 4 // 
mavlink20.PID_TUNING_STEER = 5 // 
mavlink20.PID_TUNING_LANDING = 6 // 
mavlink20.PID_TUNING_AXIS_ENUM_END = 7 // 

// MAV_REMOTE_LOG_DATA_BLOCK_COMMANDS
mavlink20.MAV_REMOTE_LOG_DATA_BLOCK_STOP = 2147483645 // UAV to stop sending DataFlash blocks.
mavlink20.MAV_REMOTE_LOG_DATA_BLOCK_START = 2147483646 // UAV to start sending DataFlash blocks.
mavlink20.MAV_REMOTE_LOG_DATA_BLOCK_COMMANDS_ENUM_END = 2147483647 // 

// MAV_REMOTE_LOG_DATA_BLOCK_STATUSES
mavlink20.MAV_REMOTE_LOG_DATA_BLOCK_NACK = 0 // This block has NOT been received.
mavlink20.MAV_REMOTE_LOG_DATA_BLOCK_ACK = 1 // This block has been received.
mavlink20.MAV_REMOTE_LOG_DATA_BLOCK_STATUSES_ENUM_END = 2 // 

// DEVICE_OP_BUSTYPE
mavlink20.DEVICE_OP_BUSTYPE_I2C = 0 // I2C Device operation.
mavlink20.DEVICE_OP_BUSTYPE_SPI = 1 // SPI Device operation.
mavlink20.DEVICE_OP_BUSTYPE_ENUM_END = 2 // 

// DEEPSTALL_STAGE
mavlink20.DEEPSTALL_STAGE_FLY_TO_LANDING = 0 // Flying to the landing point.
mavlink20.DEEPSTALL_STAGE_ESTIMATE_WIND = 1 // Building an estimate of the wind.
mavlink20.DEEPSTALL_STAGE_WAIT_FOR_BREAKOUT = 2 // Waiting to breakout of the loiter to fly the approach.
mavlink20.DEEPSTALL_STAGE_FLY_TO_ARC = 3 // Flying to the first arc point to turn around to the landing point.
mavlink20.DEEPSTALL_STAGE_ARC = 4 // Turning around back to the deepstall landing point.
mavlink20.DEEPSTALL_STAGE_APPROACH = 5 // Approaching the landing point.
mavlink20.DEEPSTALL_STAGE_LAND = 6 // Stalling and steering towards the land point.
mavlink20.DEEPSTALL_STAGE_ENUM_END = 7 // 

// PLANE_MODE
mavlink20.PLANE_MODE_MANUAL = 0 // 
mavlink20.PLANE_MODE_CIRCLE = 1 // 
mavlink20.PLANE_MODE_STABILIZE = 2 // 
mavlink20.PLANE_MODE_TRAINING = 3 // 
mavlink20.PLANE_MODE_ACRO = 4 // 
mavlink20.PLANE_MODE_FLY_BY_WIRE_A = 5 // 
mavlink20.PLANE_MODE_FLY_BY_WIRE_B = 6 // 
mavlink20.PLANE_MODE_CRUISE = 7 // 
mavlink20.PLANE_MODE_AUTOTUNE = 8 // 
mavlink20.PLANE_MODE_AUTO = 10 // 
mavlink20.PLANE_MODE_RTL = 11 // 
mavlink20.PLANE_MODE_LOITER = 12 // 
mavlink20.PLANE_MODE_TAKEOFF = 13 // 
mavlink20.PLANE_MODE_AVOID_ADSB = 14 // 
mavlink20.PLANE_MODE_GUIDED = 15 // 
mavlink20.PLANE_MODE_INITIALIZING = 16 // 
mavlink20.PLANE_MODE_QSTABILIZE = 17 // 
mavlink20.PLANE_MODE_QHOVER = 18 // 
mavlink20.PLANE_MODE_QLOITER = 19 // 
mavlink20.PLANE_MODE_QLAND = 20 // 
mavlink20.PLANE_MODE_QRTL = 21 // 
mavlink20.PLANE_MODE_QAUTOTUNE = 22 // 
mavlink20.PLANE_MODE_QACRO = 23 // 
mavlink20.PLANE_MODE_THERMAL = 24 // 
mavlink20.PLANE_MODE_ENUM_END = 25 // 

// COPTER_MODE
mavlink20.COPTER_MODE_STABILIZE = 0 // 
mavlink20.COPTER_MODE_ACRO = 1 // 
mavlink20.COPTER_MODE_ALT_HOLD = 2 // 
mavlink20.COPTER_MODE_AUTO = 3 // 
mavlink20.COPTER_MODE_GUIDED = 4 // 
mavlink20.COPTER_MODE_LOITER = 5 // 
mavlink20.COPTER_MODE_RTL = 6 // 
mavlink20.COPTER_MODE_CIRCLE = 7 // 
mavlink20.COPTER_MODE_LAND = 9 // 
mavlink20.COPTER_MODE_DRIFT = 11 // 
mavlink20.COPTER_MODE_SPORT = 13 // 
mavlink20.COPTER_MODE_FLIP = 14 // 
mavlink20.COPTER_MODE_AUTOTUNE = 15 // 
mavlink20.COPTER_MODE_POSHOLD = 16 // 
mavlink20.COPTER_MODE_BRAKE = 17 // 
mavlink20.COPTER_MODE_THROW = 18 // 
mavlink20.COPTER_MODE_AVOID_ADSB = 19 // 
mavlink20.COPTER_MODE_GUIDED_NOGPS = 20 // 
mavlink20.COPTER_MODE_SMART_RTL = 21 // 
mavlink20.COPTER_MODE_FLOWHOLD = 22 // 
mavlink20.COPTER_MODE_FOLLOW = 23 // 
mavlink20.COPTER_MODE_ZIGZAG = 24 // 
mavlink20.COPTER_MODE_SYSTEMID = 25 // 
mavlink20.COPTER_MODE_AUTOROTATE = 26 // 
mavlink20.COPTER_MODE_AUTO_RTL = 27 // 
mavlink20.COPTER_MODE_ENUM_END = 28 // 

// SUB_MODE
mavlink20.SUB_MODE_STABILIZE = 0 // 
mavlink20.SUB_MODE_ACRO = 1 // 
mavlink20.SUB_MODE_ALT_HOLD = 2 // 
mavlink20.SUB_MODE_AUTO = 3 // 
mavlink20.SUB_MODE_GUIDED = 4 // 
mavlink20.SUB_MODE_CIRCLE = 7 // 
mavlink20.SUB_MODE_SURFACE = 9 // 
mavlink20.SUB_MODE_POSHOLD = 16 // 
mavlink20.SUB_MODE_MANUAL = 19 // 
mavlink20.SUB_MODE_ENUM_END = 20 // 

// ROVER_MODE
mavlink20.ROVER_MODE_MANUAL = 0 // 
mavlink20.ROVER_MODE_ACRO = 1 // 
mavlink20.ROVER_MODE_STEERING = 3 // 
mavlink20.ROVER_MODE_HOLD = 4 // 
mavlink20.ROVER_MODE_LOITER = 5 // 
mavlink20.ROVER_MODE_FOLLOW = 6 // 
mavlink20.ROVER_MODE_SIMPLE = 7 // 
mavlink20.ROVER_MODE_AUTO = 10 // 
mavlink20.ROVER_MODE_RTL = 11 // 
mavlink20.ROVER_MODE_SMART_RTL = 12 // 
mavlink20.ROVER_MODE_GUIDED = 15 // 
mavlink20.ROVER_MODE_INITIALIZING = 16 // 
mavlink20.ROVER_MODE_ENUM_END = 17 // 

// TRACKER_MODE
mavlink20.TRACKER_MODE_MANUAL = 0 // 
mavlink20.TRACKER_MODE_STOP = 1 // 
mavlink20.TRACKER_MODE_SCAN = 2 // 
mavlink20.TRACKER_MODE_SERVO_TEST = 3 // 
mavlink20.TRACKER_MODE_AUTO = 10 // 
mavlink20.TRACKER_MODE_INITIALIZING = 16 // 
mavlink20.TRACKER_MODE_ENUM_END = 17 // 

// OSD_PARAM_CONFIG_TYPE
mavlink20.OSD_PARAM_NONE = 0 // 
mavlink20.OSD_PARAM_SERIAL_PROTOCOL = 1 // 
mavlink20.OSD_PARAM_SERVO_FUNCTION = 2 // 
mavlink20.OSD_PARAM_AUX_FUNCTION = 3 // 
mavlink20.OSD_PARAM_FLIGHT_MODE = 4 // 
mavlink20.OSD_PARAM_FAILSAFE_ACTION = 5 // 
mavlink20.OSD_PARAM_FAILSAFE_ACTION_1 = 6 // 
mavlink20.OSD_PARAM_FAILSAFE_ACTION_2 = 7 // 
mavlink20.OSD_PARAM_NUM_TYPES = 8 // 
mavlink20.OSD_PARAM_CONFIG_TYPE_ENUM_END = 9 // 

// OSD_PARAM_CONFIG_ERROR
mavlink20.OSD_PARAM_SUCCESS = 0 // 
mavlink20.OSD_PARAM_INVALID_SCREEN = 1 // 
mavlink20.OSD_PARAM_INVALID_PARAMETER_INDEX = 2 // 
mavlink20.OSD_PARAM_INVALID_PARAMETER = 3 // 
mavlink20.OSD_PARAM_CONFIG_ERROR_ENUM_END = 4 // 

// GSM_LINK_TYPE
mavlink20.GSM_LINK_TYPE_NONE = 0 // no service
mavlink20.GSM_LINK_TYPE_UNKNOWN = 1 // link type unknown
mavlink20.GSM_LINK_TYPE_2G = 2 // 2G (GSM/GRPS/EDGE) link
mavlink20.GSM_LINK_TYPE_3G = 3 // 3G link (WCDMA/HSDPA/HSPA)
mavlink20.GSM_LINK_TYPE_4G = 4 // 4G link (LTE)
mavlink20.GSM_LINK_TYPE_ENUM_END = 5 // 

// GSM_MODEM_TYPE
mavlink20.GSM_MODEM_TYPE_UNKNOWN = 0 // not specified
mavlink20.GSM_MODEM_TYPE_HUAWEI_E3372 = 1 // HUAWEI LTE USB Stick E3372
mavlink20.GSM_MODEM_TYPE_ENUM_END = 2 // 

// FIRMWARE_VERSION_TYPE
mavlink20.FIRMWARE_VERSION_TYPE_DEV = 0 // development release
mavlink20.FIRMWARE_VERSION_TYPE_ALPHA = 64 // alpha release
mavlink20.FIRMWARE_VERSION_TYPE_BETA = 128 // beta release
mavlink20.FIRMWARE_VERSION_TYPE_RC = 192 // release candidate
mavlink20.FIRMWARE_VERSION_TYPE_OFFICIAL = 255 // official stable release
mavlink20.FIRMWARE_VERSION_TYPE_ENUM_END = 256 // 

// HL_FAILURE_FLAG
mavlink20.HL_FAILURE_FLAG_GPS = 1 // GPS failure.
mavlink20.HL_FAILURE_FLAG_DIFFERENTIAL_PRESSURE = 2 // Differential pressure sensor failure.
mavlink20.HL_FAILURE_FLAG_ABSOLUTE_PRESSURE = 4 // Absolute pressure sensor failure.
mavlink20.HL_FAILURE_FLAG_3D_ACCEL = 8 // Accelerometer sensor failure.
mavlink20.HL_FAILURE_FLAG_3D_GYRO = 16 // Gyroscope sensor failure.
mavlink20.HL_FAILURE_FLAG_3D_MAG = 32 // Magnetometer sensor failure.
mavlink20.HL_FAILURE_FLAG_TERRAIN = 64 // Terrain subsystem failure.
mavlink20.HL_FAILURE_FLAG_BATTERY = 128 // Battery failure/critical low battery.
mavlink20.HL_FAILURE_FLAG_RC_RECEIVER = 256 // RC receiver failure/no RC connection.
mavlink20.HL_FAILURE_FLAG_OFFBOARD_LINK = 512 // Offboard link failure.
mavlink20.HL_FAILURE_FLAG_ENGINE = 1024 // Engine failure.
mavlink20.HL_FAILURE_FLAG_GEOFENCE = 2048 // Geofence violation.
mavlink20.HL_FAILURE_FLAG_ESTIMATOR = 4096 // Estimator failure, for example measurement rejection or large
                        // variances.
mavlink20.HL_FAILURE_FLAG_MISSION = 8192 // Mission failure.
mavlink20.HL_FAILURE_FLAG_ENUM_END = 8193 // 

// MAV_GOTO
mavlink20.MAV_GOTO_DO_HOLD = 0 // Hold at the current position.
mavlink20.MAV_GOTO_DO_CONTINUE = 1 // Continue with the next item in mission execution.
mavlink20.MAV_GOTO_HOLD_AT_CURRENT_POSITION = 2 // Hold at the current position of the system
mavlink20.MAV_GOTO_HOLD_AT_SPECIFIED_POSITION = 3 // Hold at the position specified in the parameters of the DO_HOLD action
mavlink20.MAV_GOTO_ENUM_END = 4 // 

// MAV_MODE
mavlink20.MAV_MODE_PREFLIGHT = 0 // System is not ready to fly, booting, calibrating, etc. No flag is set.
mavlink20.MAV_MODE_MANUAL_DISARMED = 64 // System is allowed to be active, under manual (RC) control, no
                        // stabilization
mavlink20.MAV_MODE_TEST_DISARMED = 66 // UNDEFINED mode. This solely depends on the autopilot - use with
                        // caution, intended for developers only.
mavlink20.MAV_MODE_STABILIZE_DISARMED = 80 // System is allowed to be active, under assisted RC control.
mavlink20.MAV_MODE_GUIDED_DISARMED = 88 // System is allowed to be active, under autonomous control, manual
                        // setpoint
mavlink20.MAV_MODE_AUTO_DISARMED = 92 // System is allowed to be active, under autonomous control and
                        // navigation (the trajectory is decided
                        // onboard and not pre-programmed by
                        // waypoints)
mavlink20.MAV_MODE_MANUAL_ARMED = 192 // System is allowed to be active, under manual (RC) control, no
                        // stabilization
mavlink20.MAV_MODE_TEST_ARMED = 194 // UNDEFINED mode. This solely depends on the autopilot - use with
                        // caution, intended for developers only.
mavlink20.MAV_MODE_STABILIZE_ARMED = 208 // System is allowed to be active, under assisted RC control.
mavlink20.MAV_MODE_GUIDED_ARMED = 216 // System is allowed to be active, under autonomous control, manual
                        // setpoint
mavlink20.MAV_MODE_AUTO_ARMED = 220 // System is allowed to be active, under autonomous control and
                        // navigation (the trajectory is decided
                        // onboard and not pre-programmed by
                        // waypoints)
mavlink20.MAV_MODE_ENUM_END = 221 // 

// MAV_SYS_STATUS_SENSOR
mavlink20.MAV_SYS_STATUS_SENSOR_3D_GYRO = 1 // 0x01 3D gyro
mavlink20.MAV_SYS_STATUS_SENSOR_3D_ACCEL = 2 // 0x02 3D accelerometer
mavlink20.MAV_SYS_STATUS_SENSOR_3D_MAG = 4 // 0x04 3D magnetometer
mavlink20.MAV_SYS_STATUS_SENSOR_ABSOLUTE_PRESSURE = 8 // 0x08 absolute pressure
mavlink20.MAV_SYS_STATUS_SENSOR_DIFFERENTIAL_PRESSURE = 16 // 0x10 differential pressure
mavlink20.MAV_SYS_STATUS_SENSOR_GPS = 32 // 0x20 GPS
mavlink20.MAV_SYS_STATUS_SENSOR_OPTICAL_FLOW = 64 // 0x40 optical flow
mavlink20.MAV_SYS_STATUS_SENSOR_VISION_POSITION = 128 // 0x80 computer vision position
mavlink20.MAV_SYS_STATUS_SENSOR_LASER_POSITION = 256 // 0x100 laser based position
mavlink20.MAV_SYS_STATUS_SENSOR_EXTERNAL_GROUND_TRUTH = 512 // 0x200 external ground truth (Vicon or Leica)
mavlink20.MAV_SYS_STATUS_SENSOR_ANGULAR_RATE_CONTROL = 1024 // 0x400 3D angular rate control
mavlink20.MAV_SYS_STATUS_SENSOR_ATTITUDE_STABILIZATION = 2048 // 0x800 attitude stabilization
mavlink20.MAV_SYS_STATUS_SENSOR_YAW_POSITION = 4096 // 0x1000 yaw position
mavlink20.MAV_SYS_STATUS_SENSOR_Z_ALTITUDE_CONTROL = 8192 // 0x2000 z/altitude control
mavlink20.MAV_SYS_STATUS_SENSOR_XY_POSITION_CONTROL = 16384 // 0x4000 x/y position control
mavlink20.MAV_SYS_STATUS_SENSOR_MOTOR_OUTPUTS = 32768 // 0x8000 motor outputs / control
mavlink20.MAV_SYS_STATUS_SENSOR_RC_RECEIVER = 65536 // 0x10000 RC receiver
mavlink20.MAV_SYS_STATUS_SENSOR_3D_GYRO2 = 131072 // 0x20000 2nd 3D gyro
mavlink20.MAV_SYS_STATUS_SENSOR_3D_ACCEL2 = 262144 // 0x40000 2nd 3D accelerometer
mavlink20.MAV_SYS_STATUS_SENSOR_3D_MAG2 = 524288 // 0x80000 2nd 3D magnetometer
mavlink20.MAV_SYS_STATUS_GEOFENCE = 1048576 // 0x100000 geofence
mavlink20.MAV_SYS_STATUS_AHRS = 2097152 // 0x200000 AHRS subsystem health
mavlink20.MAV_SYS_STATUS_TERRAIN = 4194304 // 0x400000 Terrain subsystem health
mavlink20.MAV_SYS_STATUS_REVERSE_MOTOR = 8388608 // 0x800000 Motors are reversed
mavlink20.MAV_SYS_STATUS_LOGGING = 16777216 // 0x1000000 Logging
mavlink20.MAV_SYS_STATUS_SENSOR_BATTERY = 33554432 // 0x2000000 Battery
mavlink20.MAV_SYS_STATUS_SENSOR_PROXIMITY = 67108864 // 0x4000000 Proximity
mavlink20.MAV_SYS_STATUS_SENSOR_SATCOM = 134217728 // 0x8000000 Satellite Communication
mavlink20.MAV_SYS_STATUS_PREARM_CHECK = 268435456 // 0x10000000 pre-arm check status. Always healthy when armed
mavlink20.MAV_SYS_STATUS_OBSTACLE_AVOIDANCE = 536870912 // 0x20000000 Avoidance/collision prevention
mavlink20.MAV_SYS_STATUS_SENSOR_PROPULSION = 1073741824 // 0x40000000 propulsion (actuator, esc, motor or propellor)
mavlink20.MAV_SYS_STATUS_EXTENSION_USED = 2147483648 // 0x80000000 Extended bit-field are used for further sensor status bits
                        // (needs to be set in
                        // onboard_control_sensors_present only)
mavlink20.MAV_SYS_STATUS_SENSOR_ENUM_END = 2147483649 // 

// MAV_SYS_STATUS_SENSOR_EXTENDED
mavlink20.MAV_SYS_STATUS_RECOVERY_SYSTEM = 1 // 0x01 Recovery system (parachute, balloon, retracts etc)
mavlink20.MAV_SYS_STATUS_SENSOR_EXTENDED_ENUM_END = 2 // 

// MAV_FRAME
mavlink20.MAV_FRAME_GLOBAL = 0 // Global (WGS84) coordinate frame + altitude relative to mean sea level
                        // (MSL).
mavlink20.MAV_FRAME_LOCAL_NED = 1 // NED local tangent frame (x: North, y: East, z: Down) with origin fixed
                        // relative to earth.
mavlink20.MAV_FRAME_MISSION = 2 // NOT a coordinate frame, indicates a mission command.
mavlink20.MAV_FRAME_GLOBAL_RELATIVE_ALT = 3 //            Global (WGS84) coordinate frame + altitude relative to the
                        // home position.
mavlink20.MAV_FRAME_LOCAL_ENU = 4 // ENU local tangent frame (x: East, y: North, z: Up) with origin fixed
                        // relative to earth.
mavlink20.MAV_FRAME_GLOBAL_INT = 5 // Global (WGS84) coordinate frame (scaled) + altitude relative to mean
                        // sea level (MSL).
mavlink20.MAV_FRAME_GLOBAL_RELATIVE_ALT_INT = 6 // Global (WGS84) coordinate frame (scaled) + altitude relative to the
                        // home position.
mavlink20.MAV_FRAME_LOCAL_OFFSET_NED = 7 // NED local tangent frame (x: North, y: East, z: Down) with origin that
                        // travels with the vehicle.
mavlink20.MAV_FRAME_BODY_NED = 8 // Same as MAV_FRAME_LOCAL_NED when used to represent position values.
                        // Same as MAV_FRAME_BODY_FRD when used with
                        // velocity/acceleration values.
mavlink20.MAV_FRAME_BODY_OFFSET_NED = 9 // This is the same as MAV_FRAME_BODY_FRD.
mavlink20.MAV_FRAME_GLOBAL_TERRAIN_ALT = 10 // Global (WGS84) coordinate frame with AGL altitude (altitude at ground
                        // level).
mavlink20.MAV_FRAME_GLOBAL_TERRAIN_ALT_INT = 11 // Global (WGS84) coordinate frame (scaled) with AGL altitude (altitude
                        // at ground level).
mavlink20.MAV_FRAME_BODY_FRD = 12 // FRD local frame aligned to the vehicle's attitude (x: Forward, y:
                        // Right, z: Down) with an origin that travels
                        // with vehicle.
mavlink20.MAV_FRAME_RESERVED_13 = 13 // MAV_FRAME_BODY_FLU - Body fixed frame of reference, Z-up (x: Forward,
                        // y: Left, z: Up).
mavlink20.MAV_FRAME_RESERVED_14 = 14 // MAV_FRAME_MOCAP_NED - Odometry local coordinate frame of data given by
                        // a motion capture system, Z-down (x: North,
                        // y: East, z: Down).
mavlink20.MAV_FRAME_RESERVED_15 = 15 // MAV_FRAME_MOCAP_ENU - Odometry local coordinate frame of data given by
                        // a motion capture system, Z-up (x: East, y:
                        // North, z: Up).
mavlink20.MAV_FRAME_RESERVED_16 = 16 // MAV_FRAME_VISION_NED - Odometry local coordinate frame of data given
                        // by a vision estimation system, Z-down (x:
                        // North, y: East, z: Down).
mavlink20.MAV_FRAME_RESERVED_17 = 17 // MAV_FRAME_VISION_ENU - Odometry local coordinate frame of data given
                        // by a vision estimation system, Z-up (x:
                        // East, y: North, z: Up).
mavlink20.MAV_FRAME_RESERVED_18 = 18 // MAV_FRAME_ESTIM_NED - Odometry local coordinate frame of data given by
                        // an estimator running onboard the vehicle,
                        // Z-down (x: North, y: East, z: Down).
mavlink20.MAV_FRAME_RESERVED_19 = 19 // MAV_FRAME_ESTIM_ENU - Odometry local coordinate frame of data given by
                        // an estimator running onboard the vehicle,
                        // Z-up (x: East, y: North, z: Up).
mavlink20.MAV_FRAME_LOCAL_FRD = 20 // FRD local tangent frame (x: Forward, y: Right, z: Down) with origin
                        // fixed relative to earth. The forward axis
                        // is aligned to the front of the vehicle in
                        // the horizontal plane.
mavlink20.MAV_FRAME_LOCAL_FLU = 21 // FLU local tangent frame (x: Forward, y: Left, z: Up) with origin fixed
                        // relative to earth. The forward axis is
                        // aligned to the front of the vehicle in the
                        // horizontal plane.
mavlink20.MAV_FRAME_ENUM_END = 22 // 

// MAVLINK_DATA_STREAM_TYPE
mavlink20.MAVLINK_DATA_STREAM_IMG_JPEG = 0 // 
mavlink20.MAVLINK_DATA_STREAM_IMG_BMP = 1 // 
mavlink20.MAVLINK_DATA_STREAM_IMG_RAW8U = 2 // 
mavlink20.MAVLINK_DATA_STREAM_IMG_RAW32U = 3 // 
mavlink20.MAVLINK_DATA_STREAM_IMG_PGM = 4 // 
mavlink20.MAVLINK_DATA_STREAM_IMG_PNG = 5 // 
mavlink20.MAVLINK_DATA_STREAM_TYPE_ENUM_END = 6 // 

// FENCE_ACTION
mavlink20.FENCE_ACTION_NONE = 0 // Disable fenced mode. If used in a plan this would mean the next fence
                        // is disabled.
mavlink20.FENCE_ACTION_GUIDED = 1 // Fly to geofence MAV_CMD_NAV_FENCE_RETURN_POINT in GUIDED mode. Note:
                        // This action is only supported by ArduPlane,
                        // and may not be supported in all versions.
mavlink20.FENCE_ACTION_REPORT = 2 // Report fence breach, but don't take action
mavlink20.FENCE_ACTION_GUIDED_THR_PASS = 3 // Fly to geofence MAV_CMD_NAV_FENCE_RETURN_POINT with manual throttle
                        // control in GUIDED mode. Note: This action
                        // is only supported by ArduPlane, and may not
                        // be supported in all versions.
mavlink20.FENCE_ACTION_RTL = 4 // Return/RTL mode.
mavlink20.FENCE_ACTION_HOLD = 5 // Hold at current location.
mavlink20.FENCE_ACTION_TERMINATE = 6 // Termination failsafe. Motors are shut down (some flight stacks may
                        // trigger other failsafe actions).
mavlink20.FENCE_ACTION_LAND = 7 // Land at current location.
mavlink20.FENCE_ACTION_ENUM_END = 8 // 

// FENCE_BREACH
mavlink20.FENCE_BREACH_NONE = 0 // No last fence breach
mavlink20.FENCE_BREACH_MINALT = 1 // Breached minimum altitude
mavlink20.FENCE_BREACH_MAXALT = 2 // Breached maximum altitude
mavlink20.FENCE_BREACH_BOUNDARY = 3 // Breached fence boundary
mavlink20.FENCE_BREACH_ENUM_END = 4 // 

// FENCE_MITIGATE
mavlink20.FENCE_MITIGATE_UNKNOWN = 0 // Unknown
mavlink20.FENCE_MITIGATE_NONE = 1 // No actions being taken
mavlink20.FENCE_MITIGATE_VEL_LIMIT = 2 // Velocity limiting active to prevent breach
mavlink20.FENCE_MITIGATE_ENUM_END = 3 // 

// FENCE_TYPE
mavlink20.FENCE_TYPE_ALL = 0 // All fence types
mavlink20.FENCE_TYPE_ALT_MAX = 1 // Maximum altitude fence
mavlink20.FENCE_TYPE_CIRCLE = 2 // Circle fence
mavlink20.FENCE_TYPE_POLYGON = 4 // Polygon fence
mavlink20.FENCE_TYPE_ALT_MIN = 8 // Minimum altitude fence
mavlink20.FENCE_TYPE_ENUM_END = 9 // 

// MAV_MOUNT_MODE
mavlink20.MAV_MOUNT_MODE_RETRACT = 0 // Load and keep safe position (Roll,Pitch,Yaw) from permanent memory and
                        // stop stabilization
mavlink20.MAV_MOUNT_MODE_NEUTRAL = 1 // Load and keep neutral position (Roll,Pitch,Yaw) from permanent memory.
mavlink20.MAV_MOUNT_MODE_MAVLINK_TARGETING = 2 // Load neutral position and start MAVLink Roll,Pitch,Yaw control with
                        // stabilization
mavlink20.MAV_MOUNT_MODE_RC_TARGETING = 3 // Load neutral position and start RC Roll,Pitch,Yaw control with
                        // stabilization
mavlink20.MAV_MOUNT_MODE_GPS_POINT = 4 // Load neutral position and start to point to Lat,Lon,Alt
mavlink20.MAV_MOUNT_MODE_SYSID_TARGET = 5 // Gimbal tracks system with specified system ID
mavlink20.MAV_MOUNT_MODE_HOME_LOCATION = 6 // Gimbal tracks home position
mavlink20.MAV_MOUNT_MODE_ENUM_END = 7 // 

// GIMBAL_DEVICE_CAP_FLAGS
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_RETRACT = 1 // Gimbal device supports a retracted position.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_NEUTRAL = 2 // Gimbal device supports a horizontal, forward looking position,
                        // stabilized.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_ROLL_AXIS = 4 // Gimbal device supports rotating around roll axis.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_ROLL_FOLLOW = 8 // Gimbal device supports to follow a roll angle relative to the vehicle.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_ROLL_LOCK = 16 // Gimbal device supports locking to a roll angle (generally that's the
                        // default with roll stabilized).
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_PITCH_AXIS = 32 // Gimbal device supports rotating around pitch axis.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_PITCH_FOLLOW = 64 // Gimbal device supports to follow a pitch angle relative to the
                        // vehicle.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_PITCH_LOCK = 128 // Gimbal device supports locking to a pitch angle (generally that's the
                        // default with pitch stabilized).
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_YAW_AXIS = 256 // Gimbal device supports rotating around yaw axis.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_YAW_FOLLOW = 512 // Gimbal device supports to follow a yaw angle relative to the vehicle
                        // (generally that's the default).
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_YAW_LOCK = 1024 // Gimbal device supports locking to an absolute heading, i.e., yaw angle
                        // relative to North (earth frame, often this
                        // is an option available).
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_SUPPORTS_INFINITE_YAW = 2048 // Gimbal device supports yawing/panning infinitely (e.g. using slip
                        // disk).
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_SUPPORTS_YAW_IN_EARTH_FRAME = 4096 // Gimbal device supports yaw angles and angular velocities relative to
                        // North (earth frame). This usually requires
                        // support by an autopilot via
                        // AUTOPILOT_STATE_FOR_GIMBAL_DEVICE. Support
                        // can go on and off during runtime, which is
                        // reported by the flag GIMBAL_DEVICE_FLAGS_CA
                        // N_ACCEPT_YAW_IN_EARTH_FRAME.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_HAS_RC_INPUTS = 8192 // Gimbal device supports radio control inputs as an alternative input
                        // for controlling the gimbal orientation.
mavlink20.GIMBAL_DEVICE_CAP_FLAGS_ENUM_END = 8193 // 

// GIMBAL_MANAGER_CAP_FLAGS
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_RETRACT = 1 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_RETRACT.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_NEUTRAL = 2 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_NEUTRAL.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_ROLL_AXIS = 4 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_ROLL_AXIS.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_ROLL_FOLLOW = 8 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_ROLL_FOLLOW.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_ROLL_LOCK = 16 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_ROLL_LOCK.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_PITCH_AXIS = 32 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_PITCH_AXIS.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_PITCH_FOLLOW = 64 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_PITCH_FOLLOW.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_PITCH_LOCK = 128 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_PITCH_LOCK.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_YAW_AXIS = 256 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_YAW_AXIS.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_YAW_FOLLOW = 512 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_YAW_FOLLOW.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_YAW_LOCK = 1024 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_YAW_LOCK.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_SUPPORTS_INFINITE_YAW = 2048 // Based on GIMBAL_DEVICE_CAP_FLAGS_SUPPORTS_INFINITE_YAW.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_SUPPORTS_YAW_IN_EARTH_FRAME = 4096 // Based on GIMBAL_DEVICE_CAP_FLAGS_SUPPORTS_YAW_IN_EARTH_FRAME.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_HAS_RC_INPUTS = 8192 // Based on GIMBAL_DEVICE_CAP_FLAGS_HAS_RC_INPUTS.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_CAN_POINT_LOCATION_LOCAL = 65536 // Gimbal manager supports to point to a local position.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_CAN_POINT_LOCATION_GLOBAL = 131072 // Gimbal manager supports to point to a global latitude, longitude,
                        // altitude position.
mavlink20.GIMBAL_MANAGER_CAP_FLAGS_ENUM_END = 131073 // 

// GIMBAL_DEVICE_FLAGS
mavlink20.GIMBAL_DEVICE_FLAGS_RETRACT = 1 // Set to retracted safe position (no stabilization), takes precedence
                        // over all other flags.
mavlink20.GIMBAL_DEVICE_FLAGS_NEUTRAL = 2 // Set to neutral/default position, taking precedence over all other
                        // flags except RETRACT. Neutral is commonly
                        // forward-facing and horizontal
                        // (roll=pitch=yaw=0) but may be any
                        // orientation.
mavlink20.GIMBAL_DEVICE_FLAGS_ROLL_LOCK = 4 // Lock roll angle to absolute angle relative to horizon (not relative to
                        // vehicle). This is generally the default
                        // with a stabilizing gimbal.
mavlink20.GIMBAL_DEVICE_FLAGS_PITCH_LOCK = 8 // Lock pitch angle to absolute angle relative to horizon (not relative
                        // to vehicle). This is generally the default
                        // with a stabilizing gimbal.
mavlink20.GIMBAL_DEVICE_FLAGS_YAW_LOCK = 16 // Lock yaw angle to absolute angle relative to North (not relative to
                        // vehicle). If this flag is set, the yaw
                        // angle and z component of angular velocity
                        // are relative to North (earth frame, x-axis
                        // pointing North), else they are relative to
                        // the vehicle heading (vehicle frame, earth
                        // frame rotated so that the x-axis is
                        // pointing forward).
mavlink20.GIMBAL_DEVICE_FLAGS_YAW_IN_VEHICLE_FRAME = 32 // Yaw angle and z component of angular velocity are relative to the
                        // vehicle heading (vehicle frame, earth frame
                        // rotated such that the x-axis is pointing
                        // forward).
mavlink20.GIMBAL_DEVICE_FLAGS_YAW_IN_EARTH_FRAME = 64 // Yaw angle and z component of angular velocity are relative to North
                        // (earth frame, x-axis is pointing North).
mavlink20.GIMBAL_DEVICE_FLAGS_ACCEPTS_YAW_IN_EARTH_FRAME = 128 // Gimbal device can accept yaw angle inputs relative to North (earth
                        // frame). This flag is only for reporting
                        // (attempts to set this flag are ignored).
mavlink20.GIMBAL_DEVICE_FLAGS_RC_EXCLUSIVE = 256 // The gimbal orientation is set exclusively by the RC signals feed to
                        // the gimbal's radio control inputs. MAVLink
                        // messages for setting the gimbal orientation
                        // (GIMBAL_DEVICE_SET_ATTITUDE) are ignored.
mavlink20.GIMBAL_DEVICE_FLAGS_RC_MIXED = 512 // The gimbal orientation is determined by combining/mixing the RC
                        // signals feed to the gimbal's radio control
                        // inputs and the MAVLink messages for setting
                        // the gimbal orientation
                        // (GIMBAL_DEVICE_SET_ATTITUDE). How these two
                        // controls are combined or mixed is not
                        // defined by the protocol but is up to the
                        // implementation.
mavlink20.GIMBAL_DEVICE_FLAGS_ENUM_END = 513 // 

// GIMBAL_MANAGER_FLAGS
mavlink20.GIMBAL_MANAGER_FLAGS_RETRACT = 1 // Based on GIMBAL_DEVICE_FLAGS_RETRACT.
mavlink20.GIMBAL_MANAGER_FLAGS_NEUTRAL = 2 // Based on GIMBAL_DEVICE_FLAGS_NEUTRAL.
mavlink20.GIMBAL_MANAGER_FLAGS_ROLL_LOCK = 4 // Based on GIMBAL_DEVICE_FLAGS_ROLL_LOCK.
mavlink20.GIMBAL_MANAGER_FLAGS_PITCH_LOCK = 8 // Based on GIMBAL_DEVICE_FLAGS_PITCH_LOCK.
mavlink20.GIMBAL_MANAGER_FLAGS_YAW_LOCK = 16 // Based on GIMBAL_DEVICE_FLAGS_YAW_LOCK.
mavlink20.GIMBAL_MANAGER_FLAGS_YAW_IN_VEHICLE_FRAME = 32 // Based on GIMBAL_DEVICE_FLAGS_YAW_IN_VEHICLE_FRAME.
mavlink20.GIMBAL_MANAGER_FLAGS_YAW_IN_EARTH_FRAME = 64 // Based on GIMBAL_DEVICE_FLAGS_YAW_IN_EARTH_FRAME.
mavlink20.GIMBAL_MANAGER_FLAGS_ACCEPTS_YAW_IN_EARTH_FRAME = 128 // Based on GIMBAL_DEVICE_FLAGS_ACCEPTS_YAW_IN_EARTH_FRAME.
mavlink20.GIMBAL_MANAGER_FLAGS_RC_EXCLUSIVE = 256 // Based on GIMBAL_DEVICE_FLAGS_RC_EXCLUSIVE.
mavlink20.GIMBAL_MANAGER_FLAGS_RC_MIXED = 512 // Based on GIMBAL_DEVICE_FLAGS_RC_MIXED.
mavlink20.GIMBAL_MANAGER_FLAGS_ENUM_END = 513 // 

// GIMBAL_DEVICE_ERROR_FLAGS
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_AT_ROLL_LIMIT = 1 // Gimbal device is limited by hardware roll limit.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_AT_PITCH_LIMIT = 2 // Gimbal device is limited by hardware pitch limit.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_AT_YAW_LIMIT = 4 // Gimbal device is limited by hardware yaw limit.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_ENCODER_ERROR = 8 // There is an error with the gimbal encoders.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_POWER_ERROR = 16 // There is an error with the gimbal power source.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_MOTOR_ERROR = 32 // There is an error with the gimbal motors.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_SOFTWARE_ERROR = 64 // There is an error with the gimbal's software.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_COMMS_ERROR = 128 // There is an error with the gimbal's communication.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_CALIBRATION_RUNNING = 256 // Gimbal device is currently calibrating.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_NO_MANAGER = 512 // Gimbal device is not assigned to a gimbal manager.
mavlink20.GIMBAL_DEVICE_ERROR_FLAGS_ENUM_END = 513 // 

// GRIPPER_ACTIONS
mavlink20.GRIPPER_ACTION_RELEASE = 0 // Gripper release cargo.
mavlink20.GRIPPER_ACTION_GRAB = 1 // Gripper grab onto cargo.
mavlink20.GRIPPER_ACTIONS_ENUM_END = 2 // 

// WINCH_ACTIONS
mavlink20.WINCH_RELAXED = 0 // Allow motor to freewheel.
mavlink20.WINCH_RELATIVE_LENGTH_CONTROL = 1 // Wind or unwind specified length of line, optionally using specified
                        // rate.
mavlink20.WINCH_RATE_CONTROL = 2 // Wind or unwind line at specified rate.
mavlink20.WINCH_LOCK = 3 // Perform the locking sequence to relieve motor while in the fully
                        // retracted position. Only action and
                        // instance command parameters are used,
                        // others are ignored.
mavlink20.WINCH_DELIVER = 4 // Sequence of drop, slow down, touch down, reel up, lock. Only action
                        // and instance command parameters are used,
                        // others are ignored.
mavlink20.WINCH_HOLD = 5 // Engage motor and hold current position. Only action and instance
                        // command parameters are used, others are
                        // ignored.
mavlink20.WINCH_RETRACT = 6 // Return the reel to the fully retracted position. Only action and
                        // instance command parameters are used,
                        // others are ignored.
mavlink20.WINCH_LOAD_LINE = 7 // Load the reel with line. The winch will calculate the total loaded
                        // length and stop when the tension exceeds a
                        // threshold. Only action and instance command
                        // parameters are used, others are ignored.
mavlink20.WINCH_ABANDON_LINE = 8 // Spool out the entire length of the line. Only action and instance
                        // command parameters are used, others are
                        // ignored.
mavlink20.WINCH_LOAD_PAYLOAD = 9 // Spools out just enough to present the hook to the user to load the
                        // payload. Only action and instance command
                        // parameters are used, others are ignored
mavlink20.WINCH_ACTIONS_ENUM_END = 10 // 

// UAVCAN_NODE_HEALTH
mavlink20.UAVCAN_NODE_HEALTH_OK = 0 // The node is functioning properly.
mavlink20.UAVCAN_NODE_HEALTH_WARNING = 1 // A critical parameter went out of range or the node has encountered a
                        // minor failure.
mavlink20.UAVCAN_NODE_HEALTH_ERROR = 2 // The node has encountered a major failure.
mavlink20.UAVCAN_NODE_HEALTH_CRITICAL = 3 // The node has suffered a fatal malfunction.
mavlink20.UAVCAN_NODE_HEALTH_ENUM_END = 4 // 

// UAVCAN_NODE_MODE
mavlink20.UAVCAN_NODE_MODE_OPERATIONAL = 0 // The node is performing its primary functions.
mavlink20.UAVCAN_NODE_MODE_INITIALIZATION = 1 // The node is initializing; this mode is entered immediately after
                        // startup.
mavlink20.UAVCAN_NODE_MODE_MAINTENANCE = 2 // The node is under maintenance.
mavlink20.UAVCAN_NODE_MODE_SOFTWARE_UPDATE = 3 // The node is in the process of updating its software.
mavlink20.UAVCAN_NODE_MODE_OFFLINE = 7 // The node is no longer available online.
mavlink20.UAVCAN_NODE_MODE_ENUM_END = 8 // 

// ESC_CONNECTION_TYPE
mavlink20.ESC_CONNECTION_TYPE_PPM = 0 // Traditional PPM ESC.
mavlink20.ESC_CONNECTION_TYPE_SERIAL = 1 // Serial Bus connected ESC.
mavlink20.ESC_CONNECTION_TYPE_ONESHOT = 2 // One Shot PPM ESC.
mavlink20.ESC_CONNECTION_TYPE_I2C = 3 // I2C ESC.
mavlink20.ESC_CONNECTION_TYPE_CAN = 4 // CAN-Bus ESC.
mavlink20.ESC_CONNECTION_TYPE_DSHOT = 5 // DShot ESC.
mavlink20.ESC_CONNECTION_TYPE_ENUM_END = 6 // 

// ESC_FAILURE_FLAGS
mavlink20.ESC_FAILURE_NONE = 0 // No ESC failure.
mavlink20.ESC_FAILURE_OVER_CURRENT = 1 // Over current failure.
mavlink20.ESC_FAILURE_OVER_VOLTAGE = 2 // Over voltage failure.
mavlink20.ESC_FAILURE_OVER_TEMPERATURE = 4 // Over temperature failure.
mavlink20.ESC_FAILURE_OVER_RPM = 8 // Over RPM failure.
mavlink20.ESC_FAILURE_INCONSISTENT_CMD = 16 // Inconsistent command failure i.e. out of bounds.
mavlink20.ESC_FAILURE_MOTOR_STUCK = 32 // Motor stuck failure.
mavlink20.ESC_FAILURE_GENERIC = 64 // Generic ESC failure.
mavlink20.ESC_FAILURE_FLAGS_ENUM_END = 65 // 

// STORAGE_STATUS
mavlink20.STORAGE_STATUS_EMPTY = 0 // Storage is missing (no microSD card loaded for example.)
mavlink20.STORAGE_STATUS_UNFORMATTED = 1 // Storage present but unformatted.
mavlink20.STORAGE_STATUS_READY = 2 // Storage present and ready.
mavlink20.STORAGE_STATUS_NOT_SUPPORTED = 3 // Camera does not supply storage status information. Capacity
                        // information in STORAGE_INFORMATION fields
                        // will be ignored.
mavlink20.STORAGE_STATUS_ENUM_END = 4 // 

// STORAGE_TYPE
mavlink20.STORAGE_TYPE_UNKNOWN = 0 // Storage type is not known.
mavlink20.STORAGE_TYPE_USB_STICK = 1 // Storage type is USB device.
mavlink20.STORAGE_TYPE_SD = 2 // Storage type is SD card.
mavlink20.STORAGE_TYPE_MICROSD = 3 // Storage type is microSD card.
mavlink20.STORAGE_TYPE_CF = 4 // Storage type is CFast.
mavlink20.STORAGE_TYPE_CFE = 5 // Storage type is CFexpress.
mavlink20.STORAGE_TYPE_XQD = 6 // Storage type is XQD.
mavlink20.STORAGE_TYPE_HD = 7 // Storage type is HD mass storage type.
mavlink20.STORAGE_TYPE_OTHER = 254 // Storage type is other, not listed type.
mavlink20.STORAGE_TYPE_ENUM_END = 255 // 

// STORAGE_USAGE_FLAG
mavlink20.STORAGE_USAGE_FLAG_SET = 1 // Always set to 1 (indicates STORAGE_INFORMATION.storage_usage is
                        // supported).
mavlink20.STORAGE_USAGE_FLAG_PHOTO = 2 // Storage for saving photos.
mavlink20.STORAGE_USAGE_FLAG_VIDEO = 4 // Storage for saving videos.
mavlink20.STORAGE_USAGE_FLAG_LOGS = 8 // Storage for saving logs.
mavlink20.STORAGE_USAGE_FLAG_ENUM_END = 9 // 

// ORBIT_YAW_BEHAVIOUR
mavlink20.ORBIT_YAW_BEHAVIOUR_HOLD_FRONT_TO_CIRCLE_CENTER = 0 // Vehicle front points to the center (default).
mavlink20.ORBIT_YAW_BEHAVIOUR_HOLD_INITIAL_HEADING = 1 // Vehicle front holds heading when message received.
mavlink20.ORBIT_YAW_BEHAVIOUR_UNCONTROLLED = 2 // Yaw uncontrolled.
mavlink20.ORBIT_YAW_BEHAVIOUR_HOLD_FRONT_TANGENT_TO_CIRCLE = 3 // Vehicle front follows flight path (tangential to circle).
mavlink20.ORBIT_YAW_BEHAVIOUR_RC_CONTROLLED = 4 // Yaw controlled by RC input.
mavlink20.ORBIT_YAW_BEHAVIOUR_UNCHANGED = 5 // Vehicle uses current yaw behaviour (unchanged). The vehicle-default
                        // yaw behaviour is used if this value is
                        // specified when orbit is first commanded.
mavlink20.ORBIT_YAW_BEHAVIOUR_ENUM_END = 6 // 

// WIFI_CONFIG_AP_RESPONSE
mavlink20.WIFI_CONFIG_AP_RESPONSE_UNDEFINED = 0 // Undefined response. Likely an indicative of a system that doesn't
                        // support this request.
mavlink20.WIFI_CONFIG_AP_RESPONSE_ACCEPTED = 1 // Changes accepted.
mavlink20.WIFI_CONFIG_AP_RESPONSE_REJECTED = 2 // Changes rejected.
mavlink20.WIFI_CONFIG_AP_RESPONSE_MODE_ERROR = 3 // Invalid Mode.
mavlink20.WIFI_CONFIG_AP_RESPONSE_SSID_ERROR = 4 // Invalid SSID.
mavlink20.WIFI_CONFIG_AP_RESPONSE_PASSWORD_ERROR = 5 // Invalid Password.
mavlink20.WIFI_CONFIG_AP_RESPONSE_ENUM_END = 6 // 

// CELLULAR_CONFIG_RESPONSE
mavlink20.CELLULAR_CONFIG_RESPONSE_ACCEPTED = 0 // Changes accepted.
mavlink20.CELLULAR_CONFIG_RESPONSE_APN_ERROR = 1 // Invalid APN.
mavlink20.CELLULAR_CONFIG_RESPONSE_PIN_ERROR = 2 // Invalid PIN.
mavlink20.CELLULAR_CONFIG_RESPONSE_REJECTED = 3 // Changes rejected.
mavlink20.CELLULAR_CONFIG_BLOCKED_PUK_REQUIRED = 4 // PUK is required to unblock SIM card.
mavlink20.CELLULAR_CONFIG_RESPONSE_ENUM_END = 5 // 

// WIFI_CONFIG_AP_MODE
mavlink20.WIFI_CONFIG_AP_MODE_UNDEFINED = 0 // WiFi mode is undefined.
mavlink20.WIFI_CONFIG_AP_MODE_AP = 1 // WiFi configured as an access point.
mavlink20.WIFI_CONFIG_AP_MODE_STATION = 2 // WiFi configured as a station connected to an existing local WiFi
                        // network.
mavlink20.WIFI_CONFIG_AP_MODE_DISABLED = 3 // WiFi disabled.
mavlink20.WIFI_CONFIG_AP_MODE_ENUM_END = 4 // 

// COMP_METADATA_TYPE
mavlink20.COMP_METADATA_TYPE_GENERAL = 0 // General information about the component. General metadata includes
                        // information about other metadata types
                        // supported by the component. Files of this
                        // type must be supported, and must be
                        // downloadable from vehicle using a MAVLink
                        // FTP URI.
mavlink20.COMP_METADATA_TYPE_PARAMETER = 1 // Parameter meta data.
mavlink20.COMP_METADATA_TYPE_COMMANDS = 2 // Meta data that specifies which commands and command parameters the
                        // vehicle supports. (WIP)
mavlink20.COMP_METADATA_TYPE_PERIPHERALS = 3 // Meta data that specifies external non-MAVLink peripherals.
mavlink20.COMP_METADATA_TYPE_EVENTS = 4 // Meta data for the events interface.
mavlink20.COMP_METADATA_TYPE_ACTUATORS = 5 // Meta data for actuator configuration (motors, servos and vehicle
                        // geometry) and testing.
mavlink20.COMP_METADATA_TYPE_ENUM_END = 6 // 

// ACTUATOR_CONFIGURATION
mavlink20.ACTUATOR_CONFIGURATION_NONE = 0 // Do nothing.
mavlink20.ACTUATOR_CONFIGURATION_BEEP = 1 // Command the actuator to beep now.
mavlink20.ACTUATOR_CONFIGURATION_3D_MODE_ON = 2 // Permanently set the actuator (ESC) to 3D mode (reversible thrust).
mavlink20.ACTUATOR_CONFIGURATION_3D_MODE_OFF = 3 // Permanently set the actuator (ESC) to non 3D mode (non-reversible
                        // thrust).
mavlink20.ACTUATOR_CONFIGURATION_SPIN_DIRECTION1 = 4 // Permanently set the actuator (ESC) to spin direction 1 (which can be
                        // clockwise or counter-clockwise).
mavlink20.ACTUATOR_CONFIGURATION_SPIN_DIRECTION2 = 5 // Permanently set the actuator (ESC) to spin direction 2 (opposite of
                        // direction 1).
mavlink20.ACTUATOR_CONFIGURATION_ENUM_END = 6 // 

// ACTUATOR_OUTPUT_FUNCTION
mavlink20.ACTUATOR_OUTPUT_FUNCTION_NONE = 0 // No function (disabled).
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR1 = 1 // Motor 1
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR2 = 2 // Motor 2
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR3 = 3 // Motor 3
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR4 = 4 // Motor 4
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR5 = 5 // Motor 5
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR6 = 6 // Motor 6
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR7 = 7 // Motor 7
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR8 = 8 // Motor 8
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR9 = 9 // Motor 9
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR10 = 10 // Motor 10
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR11 = 11 // Motor 11
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR12 = 12 // Motor 12
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR13 = 13 // Motor 13
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR14 = 14 // Motor 14
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR15 = 15 // Motor 15
mavlink20.ACTUATOR_OUTPUT_FUNCTION_MOTOR16 = 16 // Motor 16
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO1 = 33 // Servo 1
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO2 = 34 // Servo 2
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO3 = 35 // Servo 3
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO4 = 36 // Servo 4
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO5 = 37 // Servo 5
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO6 = 38 // Servo 6
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO7 = 39 // Servo 7
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO8 = 40 // Servo 8
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO9 = 41 // Servo 9
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO10 = 42 // Servo 10
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO11 = 43 // Servo 11
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO12 = 44 // Servo 12
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO13 = 45 // Servo 13
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO14 = 46 // Servo 14
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO15 = 47 // Servo 15
mavlink20.ACTUATOR_OUTPUT_FUNCTION_SERVO16 = 48 // Servo 16
mavlink20.ACTUATOR_OUTPUT_FUNCTION_ENUM_END = 49 // 

// AUTOTUNE_AXIS
mavlink20.AUTOTUNE_AXIS_DEFAULT = 0 // Flight stack tunes axis according to its default settings.
mavlink20.AUTOTUNE_AXIS_ROLL = 1 // Autotune roll axis.
mavlink20.AUTOTUNE_AXIS_PITCH = 2 // Autotune pitch axis.
mavlink20.AUTOTUNE_AXIS_YAW = 4 // Autotune yaw axis.
mavlink20.AUTOTUNE_AXIS_ENUM_END = 5 // 

// PREFLIGHT_STORAGE_PARAMETER_ACTION
mavlink20.PARAM_READ_PERSISTENT = 0 // Read all parameters from persistent storage. Replaces values in
                        // volatile storage.
mavlink20.PARAM_WRITE_PERSISTENT = 1 // Write all parameter values to persistent storage (flash/EEPROM)
mavlink20.PARAM_RESET_CONFIG_DEFAULT = 2 // Reset all user configurable parameters to their default value
                        // (including airframe selection, sensor
                        // calibration data, safety settings, and so
                        // on). Does not reset values that contain
                        // operation counters and vehicle computed
                        // statistics.
mavlink20.PARAM_RESET_SENSOR_DEFAULT = 3 // Reset only sensor calibration parameters to factory defaults (or
                        // firmware default if not available)
mavlink20.PARAM_RESET_ALL_DEFAULT = 4 // Reset all parameters, including operation counters, to default values
mavlink20.PREFLIGHT_STORAGE_PARAMETER_ACTION_ENUM_END = 5 // 

// PREFLIGHT_STORAGE_MISSION_ACTION
mavlink20.MISSION_READ_PERSISTENT = 0 // Read current mission data from persistent storage
mavlink20.MISSION_WRITE_PERSISTENT = 1 // Write current mission data to persistent storage
mavlink20.MISSION_RESET_DEFAULT = 2 // Erase all mission data stored on the vehicle (both persistent and
                        // volatile storage)
mavlink20.PREFLIGHT_STORAGE_MISSION_ACTION_ENUM_END = 3 // 

// MAV_DATA_STREAM
mavlink20.MAV_DATA_STREAM_ALL = 0 // Enable all data streams
mavlink20.MAV_DATA_STREAM_RAW_SENSORS = 1 // Enable IMU_RAW, GPS_RAW, GPS_STATUS packets.
mavlink20.MAV_DATA_STREAM_EXTENDED_STATUS = 2 // Enable GPS_STATUS, CONTROL_STATUS, AUX_STATUS
mavlink20.MAV_DATA_STREAM_RC_CHANNELS = 3 // Enable RC_CHANNELS_SCALED, RC_CHANNELS_RAW, SERVO_OUTPUT_RAW
mavlink20.MAV_DATA_STREAM_RAW_CONTROLLER = 4 // Enable ATTITUDE_CONTROLLER_OUTPUT, POSITION_CONTROLLER_OUTPUT,
                        // NAV_CONTROLLER_OUTPUT.
mavlink20.MAV_DATA_STREAM_POSITION = 6 // Enable LOCAL_POSITION, GLOBAL_POSITION_INT messages.
mavlink20.MAV_DATA_STREAM_EXTRA1 = 10 // Dependent on the autopilot
mavlink20.MAV_DATA_STREAM_EXTRA2 = 11 // Dependent on the autopilot
mavlink20.MAV_DATA_STREAM_EXTRA3 = 12 // Dependent on the autopilot
mavlink20.MAV_DATA_STREAM_ENUM_END = 13 // 

// MAV_ROI
mavlink20.MAV_ROI_NONE = 0 // No region of interest.
mavlink20.MAV_ROI_WPNEXT = 1 // Point toward next waypoint, with optional pitch/roll/yaw offset.
mavlink20.MAV_ROI_WPINDEX = 2 // Point toward given waypoint.
mavlink20.MAV_ROI_LOCATION = 3 // Point toward fixed location.
mavlink20.MAV_ROI_TARGET = 4 // Point toward of given id.
mavlink20.MAV_ROI_ENUM_END = 5 // 

// MAV_PARAM_TYPE
mavlink20.MAV_PARAM_TYPE_UINT8 = 1 // 8-bit unsigned integer
mavlink20.MAV_PARAM_TYPE_INT8 = 2 // 8-bit signed integer
mavlink20.MAV_PARAM_TYPE_UINT16 = 3 // 16-bit unsigned integer
mavlink20.MAV_PARAM_TYPE_INT16 = 4 // 16-bit signed integer
mavlink20.MAV_PARAM_TYPE_UINT32 = 5 // 32-bit unsigned integer
mavlink20.MAV_PARAM_TYPE_INT32 = 6 // 32-bit signed integer
mavlink20.MAV_PARAM_TYPE_UINT64 = 7 // 64-bit unsigned integer
mavlink20.MAV_PARAM_TYPE_INT64 = 8 // 64-bit signed integer
mavlink20.MAV_PARAM_TYPE_REAL32 = 9 // 32-bit floating-point
mavlink20.MAV_PARAM_TYPE_REAL64 = 10 // 64-bit floating-point
mavlink20.MAV_PARAM_TYPE_ENUM_END = 11 // 

// MAV_PARAM_EXT_TYPE
mavlink20.MAV_PARAM_EXT_TYPE_UINT8 = 1 // 8-bit unsigned integer
mavlink20.MAV_PARAM_EXT_TYPE_INT8 = 2 // 8-bit signed integer
mavlink20.MAV_PARAM_EXT_TYPE_UINT16 = 3 // 16-bit unsigned integer
mavlink20.MAV_PARAM_EXT_TYPE_INT16 = 4 // 16-bit signed integer
mavlink20.MAV_PARAM_EXT_TYPE_UINT32 = 5 // 32-bit unsigned integer
mavlink20.MAV_PARAM_EXT_TYPE_INT32 = 6 // 32-bit signed integer
mavlink20.MAV_PARAM_EXT_TYPE_UINT64 = 7 // 64-bit unsigned integer
mavlink20.MAV_PARAM_EXT_TYPE_INT64 = 8 // 64-bit signed integer
mavlink20.MAV_PARAM_EXT_TYPE_REAL32 = 9 // 32-bit floating-point
mavlink20.MAV_PARAM_EXT_TYPE_REAL64 = 10 // 64-bit floating-point
mavlink20.MAV_PARAM_EXT_TYPE_CUSTOM = 11 // Custom Type
mavlink20.MAV_PARAM_EXT_TYPE_ENUM_END = 12 // 

// MAV_RESULT
mavlink20.MAV_RESULT_ACCEPTED = 0 // Command is valid (is supported and has valid parameters), and was
                        // executed.
mavlink20.MAV_RESULT_TEMPORARILY_REJECTED = 1 // Command is valid, but cannot be executed at this time. This is used to
                        // indicate a problem that should be fixed
                        // just by waiting (e.g. a state machine is
                        // busy, can't arm because have not got GPS
                        // lock, etc.). Retrying later should work.
mavlink20.MAV_RESULT_DENIED = 2 // Command is invalid (is supported but has invalid parameters). Retrying
                        // same command and parameters will not work.
mavlink20.MAV_RESULT_UNSUPPORTED = 3 // Command is not supported (unknown).
mavlink20.MAV_RESULT_FAILED = 4 // Command is valid, but execution has failed. This is used to indicate
                        // any non-temporary or unexpected problem,
                        // i.e. any problem that must be fixed before
                        // the command can succeed/be retried. For
                        // example, attempting to write a file when
                        // out of memory, attempting to arm when
                        // sensors are not calibrated, etc.
mavlink20.MAV_RESULT_IN_PROGRESS = 5 // Command is valid and is being executed. This will be followed by
                        // further progress updates, i.e. the
                        // component may send further COMMAND_ACK
                        // messages with result MAV_RESULT_IN_PROGRESS
                        // (at a rate decided by the implementation),
                        // and must terminate by sending a COMMAND_ACK
                        // message with final result of the operation.
                        // The COMMAND_ACK.progress field can be used
                        // to indicate the progress of the operation.
mavlink20.MAV_RESULT_CANCELLED = 6 // Command has been cancelled (as a result of receiving a COMMAND_CANCEL
                        // message).
mavlink20.MAV_RESULT_COMMAND_LONG_ONLY = 7 // Command is only accepted when sent as a COMMAND_LONG.
mavlink20.MAV_RESULT_COMMAND_INT_ONLY = 8 // Command is only accepted when sent as a COMMAND_INT.
mavlink20.MAV_RESULT_COMMAND_UNSUPPORTED_MAV_FRAME = 9 // Command is invalid because a frame is required and the specified frame
                        // is not supported.
mavlink20.MAV_RESULT_ENUM_END = 10 // 

// MAV_MISSION_RESULT
mavlink20.MAV_MISSION_ACCEPTED = 0 // mission accepted OK
mavlink20.MAV_MISSION_ERROR = 1 // Generic error / not accepting mission commands at all right now.
mavlink20.MAV_MISSION_UNSUPPORTED_FRAME = 2 // Coordinate frame is not supported.
mavlink20.MAV_MISSION_UNSUPPORTED = 3 // Command is not supported.
mavlink20.MAV_MISSION_NO_SPACE = 4 // Mission items exceed storage space.
mavlink20.MAV_MISSION_INVALID = 5 // One of the parameters has an invalid value.
mavlink20.MAV_MISSION_INVALID_PARAM1 = 6 // param1 has an invalid value.
mavlink20.MAV_MISSION_INVALID_PARAM2 = 7 // param2 has an invalid value.
mavlink20.MAV_MISSION_INVALID_PARAM3 = 8 // param3 has an invalid value.
mavlink20.MAV_MISSION_INVALID_PARAM4 = 9 // param4 has an invalid value.
mavlink20.MAV_MISSION_INVALID_PARAM5_X = 10 // x / param5 has an invalid value.
mavlink20.MAV_MISSION_INVALID_PARAM6_Y = 11 // y / param6 has an invalid value.
mavlink20.MAV_MISSION_INVALID_PARAM7 = 12 // z / param7 has an invalid value.
mavlink20.MAV_MISSION_INVALID_SEQUENCE = 13 // Mission item received out of sequence
mavlink20.MAV_MISSION_DENIED = 14 // Not accepting any mission commands from this communication partner.
mavlink20.MAV_MISSION_OPERATION_CANCELLED = 15 // Current mission operation cancelled (e.g. mission upload, mission
                        // download).
mavlink20.MAV_MISSION_RESULT_ENUM_END = 16 // 

// MAV_SEVERITY
mavlink20.MAV_SEVERITY_EMERGENCY = 0 // System is unusable. This is a "panic" condition.
mavlink20.MAV_SEVERITY_ALERT = 1 // Action should be taken immediately. Indicates error in non-critical
                        // systems.
mavlink20.MAV_SEVERITY_CRITICAL = 2 // Action must be taken immediately. Indicates failure in a primary
                        // system.
mavlink20.MAV_SEVERITY_ERROR = 3 // Indicates an error in secondary/redundant systems.
mavlink20.MAV_SEVERITY_WARNING = 4 // Indicates about a possible future error if this is not resolved within
                        // a given timeframe. Example would be a low
                        // battery warning.
mavlink20.MAV_SEVERITY_NOTICE = 5 // An unusual event has occurred, though not an error condition. This
                        // should be investigated for the root cause.
mavlink20.MAV_SEVERITY_INFO = 6 // Normal operational messages. Useful for logging. No action is required
                        // for these messages.
mavlink20.MAV_SEVERITY_DEBUG = 7 // Useful non-operational messages that can assist in debugging. These
                        // should not occur during normal operation.
mavlink20.MAV_SEVERITY_ENUM_END = 8 // 

// MAV_POWER_STATUS
mavlink20.MAV_POWER_STATUS_BRICK_VALID = 1 // main brick power supply valid
mavlink20.MAV_POWER_STATUS_SERVO_VALID = 2 // main servo power supply valid for FMU
mavlink20.MAV_POWER_STATUS_USB_CONNECTED = 4 // USB power is connected
mavlink20.MAV_POWER_STATUS_PERIPH_OVERCURRENT = 8 // peripheral supply is in over-current state
mavlink20.MAV_POWER_STATUS_PERIPH_HIPOWER_OVERCURRENT = 16 // hi-power peripheral supply is in over-current state
mavlink20.MAV_POWER_STATUS_CHANGED = 32 // Power status has changed since boot
mavlink20.MAV_POWER_STATUS_ENUM_END = 33 // 

// SERIAL_CONTROL_DEV
mavlink20.SERIAL_CONTROL_DEV_TELEM1 = 0 // First telemetry port
mavlink20.SERIAL_CONTROL_DEV_TELEM2 = 1 // Second telemetry port
mavlink20.SERIAL_CONTROL_DEV_GPS1 = 2 // First GPS port
mavlink20.SERIAL_CONTROL_DEV_GPS2 = 3 // Second GPS port
mavlink20.SERIAL_CONTROL_DEV_SHELL = 10 // system shell
mavlink20.SERIAL_CONTROL_SERIAL0 = 100 // SERIAL0
mavlink20.SERIAL_CONTROL_SERIAL1 = 101 // SERIAL1
mavlink20.SERIAL_CONTROL_SERIAL2 = 102 // SERIAL2
mavlink20.SERIAL_CONTROL_SERIAL3 = 103 // SERIAL3
mavlink20.SERIAL_CONTROL_SERIAL4 = 104 // SERIAL4
mavlink20.SERIAL_CONTROL_SERIAL5 = 105 // SERIAL5
mavlink20.SERIAL_CONTROL_SERIAL6 = 106 // SERIAL6
mavlink20.SERIAL_CONTROL_SERIAL7 = 107 // SERIAL7
mavlink20.SERIAL_CONTROL_SERIAL8 = 108 // SERIAL8
mavlink20.SERIAL_CONTROL_SERIAL9 = 109 // SERIAL9
mavlink20.SERIAL_CONTROL_DEV_ENUM_END = 110 // 

// SERIAL_CONTROL_FLAG
mavlink20.SERIAL_CONTROL_FLAG_REPLY = 1 // Set if this is a reply
mavlink20.SERIAL_CONTROL_FLAG_RESPOND = 2 // Set if the sender wants the receiver to send a response as another
                        // SERIAL_CONTROL message
mavlink20.SERIAL_CONTROL_FLAG_EXCLUSIVE = 4 // Set if access to the serial port should be removed from whatever
                        // driver is currently using it, giving
                        // exclusive access to the SERIAL_CONTROL
                        // protocol. The port can be handed back by
                        // sending a request without this flag set
mavlink20.SERIAL_CONTROL_FLAG_BLOCKING = 8 // Block on writes to the serial port
mavlink20.SERIAL_CONTROL_FLAG_MULTI = 16 // Send multiple replies until port is drained
mavlink20.SERIAL_CONTROL_FLAG_ENUM_END = 17 // 

// MAV_DISTANCE_SENSOR
mavlink20.MAV_DISTANCE_SENSOR_LASER = 0 // Laser rangefinder, e.g. LightWare SF02/F or PulsedLight units
mavlink20.MAV_DISTANCE_SENSOR_ULTRASOUND = 1 // Ultrasound rangefinder, e.g. MaxBotix units
mavlink20.MAV_DISTANCE_SENSOR_INFRARED = 2 // Infrared rangefinder, e.g. Sharp units
mavlink20.MAV_DISTANCE_SENSOR_RADAR = 3 // Radar type, e.g. uLanding units
mavlink20.MAV_DISTANCE_SENSOR_UNKNOWN = 4 // Broken or unknown type, e.g. analog units
mavlink20.MAV_DISTANCE_SENSOR_ENUM_END = 5 // 

// MAV_SENSOR_ORIENTATION
mavlink20.MAV_SENSOR_ROTATION_NONE = 0 // Roll: 0, Pitch: 0, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_YAW_45 = 1 // Roll: 0, Pitch: 0, Yaw: 45
mavlink20.MAV_SENSOR_ROTATION_YAW_90 = 2 // Roll: 0, Pitch: 0, Yaw: 90
mavlink20.MAV_SENSOR_ROTATION_YAW_135 = 3 // Roll: 0, Pitch: 0, Yaw: 135
mavlink20.MAV_SENSOR_ROTATION_YAW_180 = 4 // Roll: 0, Pitch: 0, Yaw: 180
mavlink20.MAV_SENSOR_ROTATION_YAW_225 = 5 // Roll: 0, Pitch: 0, Yaw: 225
mavlink20.MAV_SENSOR_ROTATION_YAW_270 = 6 // Roll: 0, Pitch: 0, Yaw: 270
mavlink20.MAV_SENSOR_ROTATION_YAW_315 = 7 // Roll: 0, Pitch: 0, Yaw: 315
mavlink20.MAV_SENSOR_ROTATION_ROLL_180 = 8 // Roll: 180, Pitch: 0, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_180_YAW_45 = 9 // Roll: 180, Pitch: 0, Yaw: 45
mavlink20.MAV_SENSOR_ROTATION_ROLL_180_YAW_90 = 10 // Roll: 180, Pitch: 0, Yaw: 90
mavlink20.MAV_SENSOR_ROTATION_ROLL_180_YAW_135 = 11 // Roll: 180, Pitch: 0, Yaw: 135
mavlink20.MAV_SENSOR_ROTATION_PITCH_180 = 12 // Roll: 0, Pitch: 180, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_180_YAW_225 = 13 // Roll: 180, Pitch: 0, Yaw: 225
mavlink20.MAV_SENSOR_ROTATION_ROLL_180_YAW_270 = 14 // Roll: 180, Pitch: 0, Yaw: 270
mavlink20.MAV_SENSOR_ROTATION_ROLL_180_YAW_315 = 15 // Roll: 180, Pitch: 0, Yaw: 315
mavlink20.MAV_SENSOR_ROTATION_ROLL_90 = 16 // Roll: 90, Pitch: 0, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_YAW_45 = 17 // Roll: 90, Pitch: 0, Yaw: 45
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_YAW_90 = 18 // Roll: 90, Pitch: 0, Yaw: 90
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_YAW_135 = 19 // Roll: 90, Pitch: 0, Yaw: 135
mavlink20.MAV_SENSOR_ROTATION_ROLL_270 = 20 // Roll: 270, Pitch: 0, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_270_YAW_45 = 21 // Roll: 270, Pitch: 0, Yaw: 45
mavlink20.MAV_SENSOR_ROTATION_ROLL_270_YAW_90 = 22 // Roll: 270, Pitch: 0, Yaw: 90
mavlink20.MAV_SENSOR_ROTATION_ROLL_270_YAW_135 = 23 // Roll: 270, Pitch: 0, Yaw: 135
mavlink20.MAV_SENSOR_ROTATION_PITCH_90 = 24 // Roll: 0, Pitch: 90, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_PITCH_270 = 25 // Roll: 0, Pitch: 270, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_PITCH_180_YAW_90 = 26 // Roll: 0, Pitch: 180, Yaw: 90
mavlink20.MAV_SENSOR_ROTATION_PITCH_180_YAW_270 = 27 // Roll: 0, Pitch: 180, Yaw: 270
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_PITCH_90 = 28 // Roll: 90, Pitch: 90, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_180_PITCH_90 = 29 // Roll: 180, Pitch: 90, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_270_PITCH_90 = 30 // Roll: 270, Pitch: 90, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_PITCH_180 = 31 // Roll: 90, Pitch: 180, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_270_PITCH_180 = 32 // Roll: 270, Pitch: 180, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_PITCH_270 = 33 // Roll: 90, Pitch: 270, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_180_PITCH_270 = 34 // Roll: 180, Pitch: 270, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_270_PITCH_270 = 35 // Roll: 270, Pitch: 270, Yaw: 0
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_PITCH_180_YAW_90 = 36 // Roll: 90, Pitch: 180, Yaw: 90
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_YAW_270 = 37 // Roll: 90, Pitch: 0, Yaw: 270
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_PITCH_68_YAW_293 = 38 // Roll: 90, Pitch: 68, Yaw: 293
mavlink20.MAV_SENSOR_ROTATION_PITCH_315 = 39 // Pitch: 315
mavlink20.MAV_SENSOR_ROTATION_ROLL_90_PITCH_315 = 40 // Roll: 90, Pitch: 315
mavlink20.MAV_SENSOR_ROTATION_CUSTOM = 100 // Custom orientation
mavlink20.MAV_SENSOR_ORIENTATION_ENUM_END = 101 // 

// MAV_PROTOCOL_CAPABILITY
mavlink20.MAV_PROTOCOL_CAPABILITY_MISSION_FLOAT = 1 // Autopilot supports the MISSION_ITEM float message type.           Note
                        // that MISSION_ITEM is deprecated, and
                        // autopilots should use MISSION_INT instead.
mavlink20.MAV_PROTOCOL_CAPABILITY_PARAM_FLOAT = 2 // Autopilot supports the new param float message type.
mavlink20.MAV_PROTOCOL_CAPABILITY_MISSION_INT = 4 // Autopilot supports MISSION_ITEM_INT scaled integer message type.
                        // Note that this flag must always be set if
                        // missions are supported, because missions
                        // must always use MISSION_ITEM_INT (rather
                        // than MISSION_ITEM, which is deprecated).
mavlink20.MAV_PROTOCOL_CAPABILITY_COMMAND_INT = 8 // Autopilot supports COMMAND_INT scaled integer message type.
mavlink20.MAV_PROTOCOL_CAPABILITY_PARAM_ENCODE_BYTEWISE = 16 // Parameter protocol uses byte-wise encoding of parameter values into
                        // param_value (float) fields: https://mavlink
                        // .io/en/services/parameter.html#parameter-
                        // encoding.           Note that either this
                        // flag or
                        // MAV_PROTOCOL_CAPABILITY_PARAM_ENCODE_C_CAST
                        // should be set if the parameter protocol is
                        // supported.
mavlink20.MAV_PROTOCOL_CAPABILITY_FTP = 32 // Autopilot supports the File Transfer Protocol v1:
                        // https://mavlink.io/en/services/ftp.html.
mavlink20.MAV_PROTOCOL_CAPABILITY_SET_ATTITUDE_TARGET = 64 // Autopilot supports commanding attitude offboard.
mavlink20.MAV_PROTOCOL_CAPABILITY_SET_POSITION_TARGET_LOCAL_NED = 128 // Autopilot supports commanding position and velocity targets in local
                        // NED frame.
mavlink20.MAV_PROTOCOL_CAPABILITY_SET_POSITION_TARGET_GLOBAL_INT = 256 // Autopilot supports commanding position and velocity targets in global
                        // scaled integers.
mavlink20.MAV_PROTOCOL_CAPABILITY_TERRAIN = 512 // Autopilot supports terrain protocol / data handling.
mavlink20.MAV_PROTOCOL_CAPABILITY_RESERVED3 = 1024 // Reserved for future use.
mavlink20.MAV_PROTOCOL_CAPABILITY_FLIGHT_TERMINATION = 2048 // Autopilot supports the MAV_CMD_DO_FLIGHTTERMINATION command (flight
                        // termination).
mavlink20.MAV_PROTOCOL_CAPABILITY_COMPASS_CALIBRATION = 4096 // Autopilot supports onboard compass calibration.
mavlink20.MAV_PROTOCOL_CAPABILITY_MAVLINK2 = 8192 // Autopilot supports MAVLink version 2.
mavlink20.MAV_PROTOCOL_CAPABILITY_MISSION_FENCE = 16384 // Autopilot supports mission fence protocol.
mavlink20.MAV_PROTOCOL_CAPABILITY_MISSION_RALLY = 32768 // Autopilot supports mission rally point protocol.
mavlink20.MAV_PROTOCOL_CAPABILITY_RESERVED2 = 65536 // Reserved for future use.
mavlink20.MAV_PROTOCOL_CAPABILITY_PARAM_ENCODE_C_CAST = 131072 // Parameter protocol uses C-cast of parameter values to set the
                        // param_value (float) fields: https://mavlink
                        // .io/en/services/parameter.html#parameter-
                        // encoding.           Note that either this
                        // flag or MAV_PROTOCOL_CAPABILITY_PARAM_ENCOD
                        // E_BYTEWISE should be set if the parameter
                        // protocol is supported.
mavlink20.MAV_PROTOCOL_CAPABILITY_COMPONENT_IMPLEMENTS_GIMBAL_MANAGER = 262144 // This component implements/is a gimbal manager. This means the
                        // GIMBAL_MANAGER_INFORMATION, and other
                        // messages can be requested.
mavlink20.MAV_PROTOCOL_CAPABILITY_COMPONENT_ACCEPTS_GCS_CONTROL = 524288 // Component supports locking control to a particular GCS independent of
                        // its system (via
                        // MAV_CMD_REQUEST_OPERATOR_CONTROL).
mavlink20.MAV_PROTOCOL_CAPABILITY_ENUM_END = 524289 // 

// MAV_MISSION_TYPE
mavlink20.MAV_MISSION_TYPE_MISSION = 0 // Items are mission commands for main mission.
mavlink20.MAV_MISSION_TYPE_FENCE = 1 // Specifies GeoFence area(s). Items are MAV_CMD_NAV_FENCE_ GeoFence
                        // items.
mavlink20.MAV_MISSION_TYPE_RALLY = 2 // Specifies the rally points for the vehicle. Rally points are
                        // alternative RTL points. Items are
                        // MAV_CMD_NAV_RALLY_POINT rally point items.
mavlink20.MAV_MISSION_TYPE_ALL = 255 // Only used in MISSION_CLEAR_ALL to clear all mission types.
mavlink20.MAV_MISSION_TYPE_ENUM_END = 256 // 

// MAV_ESTIMATOR_TYPE
mavlink20.MAV_ESTIMATOR_TYPE_UNKNOWN = 0 // Unknown type of the estimator.
mavlink20.MAV_ESTIMATOR_TYPE_NAIVE = 1 // This is a naive estimator without any real covariance feedback.
mavlink20.MAV_ESTIMATOR_TYPE_VISION = 2 // Computer vision based estimate. Might be up to scale.
mavlink20.MAV_ESTIMATOR_TYPE_VIO = 3 // Visual-inertial estimate.
mavlink20.MAV_ESTIMATOR_TYPE_GPS = 4 // Plain GPS estimate.
mavlink20.MAV_ESTIMATOR_TYPE_GPS_INS = 5 // Estimator integrating GPS and inertial sensing.
mavlink20.MAV_ESTIMATOR_TYPE_MOCAP = 6 // Estimate from external motion capturing system.
mavlink20.MAV_ESTIMATOR_TYPE_LIDAR = 7 // Estimator based on lidar sensor input.
mavlink20.MAV_ESTIMATOR_TYPE_AUTOPILOT = 8 // Estimator on autopilot.
mavlink20.MAV_ESTIMATOR_TYPE_ENUM_END = 9 // 

// MAV_BATTERY_TYPE
mavlink20.MAV_BATTERY_TYPE_UNKNOWN = 0 // Not specified.
mavlink20.MAV_BATTERY_TYPE_LIPO = 1 // Lithium polymer battery
mavlink20.MAV_BATTERY_TYPE_LIFE = 2 // Lithium-iron-phosphate battery
mavlink20.MAV_BATTERY_TYPE_LION = 3 // Lithium-ION battery
mavlink20.MAV_BATTERY_TYPE_NIMH = 4 // Nickel metal hydride battery
mavlink20.MAV_BATTERY_TYPE_ENUM_END = 5 // 

// MAV_BATTERY_FUNCTION
mavlink20.MAV_BATTERY_FUNCTION_UNKNOWN = 0 // Battery function is unknown
mavlink20.MAV_BATTERY_FUNCTION_ALL = 1 // Battery supports all flight systems
mavlink20.MAV_BATTERY_FUNCTION_PROPULSION = 2 // Battery for the propulsion system
mavlink20.MAV_BATTERY_FUNCTION_AVIONICS = 3 // Avionics battery
mavlink20.MAV_BATTERY_FUNCTION_PAYLOAD = 4 // Payload battery
mavlink20.MAV_BATTERY_FUNCTION_ENUM_END = 5 // 

// MAV_BATTERY_CHARGE_STATE
mavlink20.MAV_BATTERY_CHARGE_STATE_UNDEFINED = 0 // Low battery state is not provided
mavlink20.MAV_BATTERY_CHARGE_STATE_OK = 1 // Battery is not in low state. Normal operation.
mavlink20.MAV_BATTERY_CHARGE_STATE_LOW = 2 // Battery state is low, warn and monitor close.
mavlink20.MAV_BATTERY_CHARGE_STATE_CRITICAL = 3 // Battery state is critical, return or abort immediately.
mavlink20.MAV_BATTERY_CHARGE_STATE_EMERGENCY = 4 // Battery state is too low for ordinary abort sequence. Perform fastest
                        // possible emergency stop to prevent damage.
mavlink20.MAV_BATTERY_CHARGE_STATE_FAILED = 5 // Battery failed, damage unavoidable. Possible causes (faults) are
                        // listed in MAV_BATTERY_FAULT.
mavlink20.MAV_BATTERY_CHARGE_STATE_UNHEALTHY = 6 // Battery is diagnosed to be defective or an error occurred, usage is
                        // discouraged / prohibited. Possible causes
                        // (faults) are listed in MAV_BATTERY_FAULT.
mavlink20.MAV_BATTERY_CHARGE_STATE_CHARGING = 7 // Battery is charging.
mavlink20.MAV_BATTERY_CHARGE_STATE_ENUM_END = 8 // 

// MAV_BATTERY_MODE
mavlink20.MAV_BATTERY_MODE_UNKNOWN = 0 // Battery mode not supported/unknown battery mode/normal operation.
mavlink20.MAV_BATTERY_MODE_AUTO_DISCHARGING = 1 // Battery is auto discharging (towards storage level).
mavlink20.MAV_BATTERY_MODE_HOT_SWAP = 2 // Battery in hot-swap mode (current limited to prevent spikes that might
                        // damage sensitive electrical circuits).
mavlink20.MAV_BATTERY_MODE_ENUM_END = 3 // 

// MAV_BATTERY_FAULT
mavlink20.MAV_BATTERY_FAULT_DEEP_DISCHARGE = 1 // Battery has deep discharged.
mavlink20.MAV_BATTERY_FAULT_SPIKES = 2 // Voltage spikes.
mavlink20.MAV_BATTERY_FAULT_CELL_FAIL = 4 // One or more cells have failed. Battery should also report
                        // MAV_BATTERY_CHARGE_STATE_FAILE (and should
                        // not be used).
mavlink20.MAV_BATTERY_FAULT_OVER_CURRENT = 8 // Over-current fault.
mavlink20.MAV_BATTERY_FAULT_OVER_TEMPERATURE = 16 // Over-temperature fault.
mavlink20.MAV_BATTERY_FAULT_UNDER_TEMPERATURE = 32 // Under-temperature fault.
mavlink20.MAV_BATTERY_FAULT_INCOMPATIBLE_VOLTAGE = 64 // Vehicle voltage is not compatible with this battery (batteries on same
                        // power rail should have similar voltage).
mavlink20.MAV_BATTERY_FAULT_INCOMPATIBLE_FIRMWARE = 128 // Battery firmware is not compatible with current autopilot firmware.
mavlink20.BATTERY_FAULT_INCOMPATIBLE_CELLS_CONFIGURATION = 256 // Battery is not compatible due to cell configuration (e.g. 5s1p when
                        // vehicle requires 6s).
mavlink20.MAV_BATTERY_FAULT_ENUM_END = 257 // 

// MAV_FUEL_TYPE
mavlink20.MAV_FUEL_TYPE_UNKNOWN = 0 // Not specified. Fuel levels are normalized (i.e. maximum is 1, and
                        // other levels are relative to 1).
mavlink20.MAV_FUEL_TYPE_LIQUID = 1 // A generic liquid fuel. Fuel levels are in millilitres (ml). Fuel rates
                        // are in millilitres/second.
mavlink20.MAV_FUEL_TYPE_GAS = 2 // A gas tank. Fuel levels are in kilo-Pascal (kPa), and flow rates are
                        // in milliliters per second (ml/s).
mavlink20.MAV_FUEL_TYPE_ENUM_END = 3 // 

// MAV_GENERATOR_STATUS_FLAG
mavlink20.MAV_GENERATOR_STATUS_FLAG_OFF = 1 // Generator is off.
mavlink20.MAV_GENERATOR_STATUS_FLAG_READY = 2 // Generator is ready to start generating power.
mavlink20.MAV_GENERATOR_STATUS_FLAG_GENERATING = 4 // Generator is generating power.
mavlink20.MAV_GENERATOR_STATUS_FLAG_CHARGING = 8 // Generator is charging the batteries (generating enough power to charge
                        // and provide the load).
mavlink20.MAV_GENERATOR_STATUS_FLAG_REDUCED_POWER = 16 // Generator is operating at a reduced maximum power.
mavlink20.MAV_GENERATOR_STATUS_FLAG_MAXPOWER = 32 // Generator is providing the maximum output.
mavlink20.MAV_GENERATOR_STATUS_FLAG_OVERTEMP_WARNING = 64 // Generator is near the maximum operating temperature, cooling is
                        // insufficient.
mavlink20.MAV_GENERATOR_STATUS_FLAG_OVERTEMP_FAULT = 128 // Generator hit the maximum operating temperature and shutdown.
mavlink20.MAV_GENERATOR_STATUS_FLAG_ELECTRONICS_OVERTEMP_WARNING = 256 // Power electronics are near the maximum operating temperature, cooling
                        // is insufficient.
mavlink20.MAV_GENERATOR_STATUS_FLAG_ELECTRONICS_OVERTEMP_FAULT = 512 // Power electronics hit the maximum operating temperature and shutdown.
mavlink20.MAV_GENERATOR_STATUS_FLAG_ELECTRONICS_FAULT = 1024 // Power electronics experienced a fault and shutdown.
mavlink20.MAV_GENERATOR_STATUS_FLAG_POWERSOURCE_FAULT = 2048 // The power source supplying the generator failed e.g. mechanical
                        // generator stopped, tether is no longer
                        // providing power, solar cell is in shade,
                        // hydrogen reaction no longer happening.
mavlink20.MAV_GENERATOR_STATUS_FLAG_COMMUNICATION_WARNING = 4096 // Generator controller having communication problems.
mavlink20.MAV_GENERATOR_STATUS_FLAG_COOLING_WARNING = 8192 // Power electronic or generator cooling system error.
mavlink20.MAV_GENERATOR_STATUS_FLAG_POWER_RAIL_FAULT = 16384 // Generator controller power rail experienced a fault.
mavlink20.MAV_GENERATOR_STATUS_FLAG_OVERCURRENT_FAULT = 32768 // Generator controller exceeded the overcurrent threshold and shutdown
                        // to prevent damage.
mavlink20.MAV_GENERATOR_STATUS_FLAG_BATTERY_OVERCHARGE_CURRENT_FAULT = 65536 // Generator controller detected a high current going into the batteries
                        // and shutdown to prevent battery damage.
mavlink20.MAV_GENERATOR_STATUS_FLAG_OVERVOLTAGE_FAULT = 131072 // Generator controller exceeded it's overvoltage threshold and shutdown
                        // to prevent it exceeding the voltage rating.
mavlink20.MAV_GENERATOR_STATUS_FLAG_BATTERY_UNDERVOLT_FAULT = 262144 // Batteries are under voltage (generator will not start).
mavlink20.MAV_GENERATOR_STATUS_FLAG_START_INHIBITED = 524288 // Generator start is inhibited by e.g. a safety switch.
mavlink20.MAV_GENERATOR_STATUS_FLAG_MAINTENANCE_REQUIRED = 1048576 // Generator requires maintenance.
mavlink20.MAV_GENERATOR_STATUS_FLAG_WARMING_UP = 2097152 // Generator is not ready to generate yet.
mavlink20.MAV_GENERATOR_STATUS_FLAG_IDLE = 4194304 // Generator is idle.
mavlink20.MAV_GENERATOR_STATUS_FLAG_ENUM_END = 4194305 // 

// MAV_VTOL_STATE
mavlink20.MAV_VTOL_STATE_UNDEFINED = 0 // MAV is not configured as VTOL
mavlink20.MAV_VTOL_STATE_TRANSITION_TO_FW = 1 // VTOL is in transition from multicopter to fixed-wing
mavlink20.MAV_VTOL_STATE_TRANSITION_TO_MC = 2 // VTOL is in transition from fixed-wing to multicopter
mavlink20.MAV_VTOL_STATE_MC = 3 // VTOL is in multicopter state
mavlink20.MAV_VTOL_STATE_FW = 4 // VTOL is in fixed-wing state
mavlink20.MAV_VTOL_STATE_ENUM_END = 5 // 

// MAV_LANDED_STATE
mavlink20.MAV_LANDED_STATE_UNDEFINED = 0 // MAV landed state is unknown
mavlink20.MAV_LANDED_STATE_ON_GROUND = 1 // MAV is landed (on ground)
mavlink20.MAV_LANDED_STATE_IN_AIR = 2 // MAV is in air
mavlink20.MAV_LANDED_STATE_TAKEOFF = 3 // MAV currently taking off
mavlink20.MAV_LANDED_STATE_LANDING = 4 // MAV currently landing
mavlink20.MAV_LANDED_STATE_ENUM_END = 5 // 

// ADSB_ALTITUDE_TYPE
mavlink20.ADSB_ALTITUDE_TYPE_PRESSURE_QNH = 0 // Altitude reported from a Baro source using QNH reference
mavlink20.ADSB_ALTITUDE_TYPE_GEOMETRIC = 1 // Altitude reported from a GNSS source
mavlink20.ADSB_ALTITUDE_TYPE_ENUM_END = 2 // 

// ADSB_EMITTER_TYPE
mavlink20.ADSB_EMITTER_TYPE_NO_INFO = 0 // 
mavlink20.ADSB_EMITTER_TYPE_LIGHT = 1 // 
mavlink20.ADSB_EMITTER_TYPE_SMALL = 2 // 
mavlink20.ADSB_EMITTER_TYPE_LARGE = 3 // 
mavlink20.ADSB_EMITTER_TYPE_HIGH_VORTEX_LARGE = 4 // 
mavlink20.ADSB_EMITTER_TYPE_HEAVY = 5 // 
mavlink20.ADSB_EMITTER_TYPE_HIGHLY_MANUV = 6 // 
mavlink20.ADSB_EMITTER_TYPE_ROTOCRAFT = 7 // 
mavlink20.ADSB_EMITTER_TYPE_UNASSIGNED = 8 // 
mavlink20.ADSB_EMITTER_TYPE_GLIDER = 9 // 
mavlink20.ADSB_EMITTER_TYPE_LIGHTER_AIR = 10 // 
mavlink20.ADSB_EMITTER_TYPE_PARACHUTE = 11 // 
mavlink20.ADSB_EMITTER_TYPE_ULTRA_LIGHT = 12 // 
mavlink20.ADSB_EMITTER_TYPE_UNASSIGNED2 = 13 // 
mavlink20.ADSB_EMITTER_TYPE_UAV = 14 // 
mavlink20.ADSB_EMITTER_TYPE_SPACE = 15 // 
mavlink20.ADSB_EMITTER_TYPE_UNASSGINED3 = 16 // 
mavlink20.ADSB_EMITTER_TYPE_EMERGENCY_SURFACE = 17 // 
mavlink20.ADSB_EMITTER_TYPE_SERVICE_SURFACE = 18 // 
mavlink20.ADSB_EMITTER_TYPE_POINT_OBSTACLE = 19 // 
mavlink20.ADSB_EMITTER_TYPE_ENUM_END = 20 // 

// ADSB_FLAGS
mavlink20.ADSB_FLAGS_VALID_COORDS = 1 // 
mavlink20.ADSB_FLAGS_VALID_ALTITUDE = 2 // 
mavlink20.ADSB_FLAGS_VALID_HEADING = 4 // 
mavlink20.ADSB_FLAGS_VALID_VELOCITY = 8 // 
mavlink20.ADSB_FLAGS_VALID_CALLSIGN = 16 // 
mavlink20.ADSB_FLAGS_VALID_SQUAWK = 32 // 
mavlink20.ADSB_FLAGS_SIMULATED = 64 // 
mavlink20.ADSB_FLAGS_VERTICAL_VELOCITY_VALID = 128 // 
mavlink20.ADSB_FLAGS_BARO_VALID = 256 // 
mavlink20.ADSB_FLAGS_SOURCE_UAT = 32768 // 
mavlink20.ADSB_FLAGS_ENUM_END = 32769 // 

// MAV_DO_REPOSITION_FLAGS
mavlink20.MAV_DO_REPOSITION_FLAGS_CHANGE_MODE = 1 // The aircraft should immediately transition into guided. This should
                        // not be set for follow me applications
mavlink20.MAV_DO_REPOSITION_FLAGS_ENUM_END = 2 // 

// SPEED_TYPE
mavlink20.SPEED_TYPE_AIRSPEED = 0 // Airspeed
mavlink20.SPEED_TYPE_GROUNDSPEED = 1 // Groundspeed
mavlink20.SPEED_TYPE_CLIMB_SPEED = 2 // Climb speed
mavlink20.SPEED_TYPE_DESCENT_SPEED = 3 // Descent speed
mavlink20.SPEED_TYPE_ENUM_END = 4 // 

// ESTIMATOR_STATUS_FLAGS
mavlink20.ESTIMATOR_ATTITUDE = 1 // True if the attitude estimate is good
mavlink20.ESTIMATOR_VELOCITY_HORIZ = 2 // True if the horizontal velocity estimate is good
mavlink20.ESTIMATOR_VELOCITY_VERT = 4 // True if the  vertical velocity estimate is good
mavlink20.ESTIMATOR_POS_HORIZ_REL = 8 // True if the horizontal position (relative) estimate is good
mavlink20.ESTIMATOR_POS_HORIZ_ABS = 16 // True if the horizontal position (absolute) estimate is good
mavlink20.ESTIMATOR_POS_VERT_ABS = 32 // True if the vertical position (absolute) estimate is good
mavlink20.ESTIMATOR_POS_VERT_AGL = 64 // True if the vertical position (above ground) estimate is good
mavlink20.ESTIMATOR_CONST_POS_MODE = 128 // True if the EKF is in a constant position mode and is not using
                        // external measurements (eg GPS or optical
                        // flow)
mavlink20.ESTIMATOR_PRED_POS_HORIZ_REL = 256 // True if the EKF has sufficient data to enter a mode that will provide
                        // a (relative) position estimate
mavlink20.ESTIMATOR_PRED_POS_HORIZ_ABS = 512 // True if the EKF has sufficient data to enter a mode that will provide
                        // a (absolute) position estimate
mavlink20.ESTIMATOR_GPS_GLITCH = 1024 // True if the EKF has detected a GPS glitch
mavlink20.ESTIMATOR_ACCEL_ERROR = 2048 // True if the EKF has detected bad accelerometer data
mavlink20.ESTIMATOR_STATUS_FLAGS_ENUM_END = 2049 // 

// MOTOR_TEST_ORDER
mavlink20.MOTOR_TEST_ORDER_DEFAULT = 0 // Default autopilot motor test method.
mavlink20.MOTOR_TEST_ORDER_SEQUENCE = 1 // Motor numbers are specified as their index in a predefined vehicle-
                        // specific sequence.
mavlink20.MOTOR_TEST_ORDER_BOARD = 2 // Motor numbers are specified as the output as labeled on the board.
mavlink20.MOTOR_TEST_ORDER_ENUM_END = 3 // 

// MOTOR_TEST_THROTTLE_TYPE
mavlink20.MOTOR_TEST_THROTTLE_PERCENT = 0 // Throttle as a percentage (0 ~ 100)
mavlink20.MOTOR_TEST_THROTTLE_PWM = 1 // Throttle as an absolute PWM value (normally in range of 1000~2000).
mavlink20.MOTOR_TEST_THROTTLE_PILOT = 2 // Throttle pass-through from pilot's transmitter.
mavlink20.MOTOR_TEST_COMPASS_CAL = 3 // Per-motor compass calibration test.
mavlink20.MOTOR_TEST_THROTTLE_TYPE_ENUM_END = 4 // 

// GPS_INPUT_IGNORE_FLAGS
mavlink20.GPS_INPUT_IGNORE_FLAG_ALT = 1 // ignore altitude field
mavlink20.GPS_INPUT_IGNORE_FLAG_HDOP = 2 // ignore hdop field
mavlink20.GPS_INPUT_IGNORE_FLAG_VDOP = 4 // ignore vdop field
mavlink20.GPS_INPUT_IGNORE_FLAG_VEL_HORIZ = 8 // ignore horizontal velocity field (vn and ve)
mavlink20.GPS_INPUT_IGNORE_FLAG_VEL_VERT = 16 // ignore vertical velocity field (vd)
mavlink20.GPS_INPUT_IGNORE_FLAG_SPEED_ACCURACY = 32 // ignore speed accuracy field
mavlink20.GPS_INPUT_IGNORE_FLAG_HORIZONTAL_ACCURACY = 64 // ignore horizontal accuracy field
mavlink20.GPS_INPUT_IGNORE_FLAG_VERTICAL_ACCURACY = 128 // ignore vertical accuracy field
mavlink20.GPS_INPUT_IGNORE_FLAGS_ENUM_END = 129 // 

// MAV_COLLISION_ACTION
mavlink20.MAV_COLLISION_ACTION_NONE = 0 // Ignore any potential collisions
mavlink20.MAV_COLLISION_ACTION_REPORT = 1 // Report potential collision
mavlink20.MAV_COLLISION_ACTION_ASCEND_OR_DESCEND = 2 // Ascend or Descend to avoid threat
mavlink20.MAV_COLLISION_ACTION_MOVE_HORIZONTALLY = 3 // Move horizontally to avoid threat
mavlink20.MAV_COLLISION_ACTION_MOVE_PERPENDICULAR = 4 // Aircraft to move perpendicular to the collision's velocity vector
mavlink20.MAV_COLLISION_ACTION_RTL = 5 // Aircraft to fly directly back to its launch point
mavlink20.MAV_COLLISION_ACTION_HOVER = 6 // Aircraft to stop in place
mavlink20.MAV_COLLISION_ACTION_ENUM_END = 7 // 

// MAV_COLLISION_THREAT_LEVEL
mavlink20.MAV_COLLISION_THREAT_LEVEL_NONE = 0 // Not a threat
mavlink20.MAV_COLLISION_THREAT_LEVEL_LOW = 1 // Craft is mildly concerned about this threat
mavlink20.MAV_COLLISION_THREAT_LEVEL_HIGH = 2 // Craft is panicking, and may take actions to avoid threat
mavlink20.MAV_COLLISION_THREAT_LEVEL_ENUM_END = 3 // 

// MAV_COLLISION_SRC
mavlink20.MAV_COLLISION_SRC_ADSB = 0 // ID field references ADSB_VEHICLE packets
mavlink20.MAV_COLLISION_SRC_MAVLINK_GPS_GLOBAL_INT = 1 // ID field references MAVLink SRC ID
mavlink20.MAV_COLLISION_SRC_ENUM_END = 2 // 

// GPS_FIX_TYPE
mavlink20.GPS_FIX_TYPE_NO_GPS = 0 // No GPS connected
mavlink20.GPS_FIX_TYPE_NO_FIX = 1 // No position information, GPS is connected
mavlink20.GPS_FIX_TYPE_2D_FIX = 2 // 2D position
mavlink20.GPS_FIX_TYPE_3D_FIX = 3 // 3D position
mavlink20.GPS_FIX_TYPE_DGPS = 4 // DGPS/SBAS aided 3D position
mavlink20.GPS_FIX_TYPE_RTK_FLOAT = 5 // RTK float, 3D position
mavlink20.GPS_FIX_TYPE_RTK_FIXED = 6 // RTK Fixed, 3D position
mavlink20.GPS_FIX_TYPE_STATIC = 7 // Static fixed, typically used for base stations
mavlink20.GPS_FIX_TYPE_PPP = 8 // PPP, 3D position.
mavlink20.GPS_FIX_TYPE_ENUM_END = 9 // 

// RTK_BASELINE_COORDINATE_SYSTEM
mavlink20.RTK_BASELINE_COORDINATE_SYSTEM_ECEF = 0 // Earth-centered, Earth-fixed
mavlink20.RTK_BASELINE_COORDINATE_SYSTEM_NED = 1 // RTK basestation centered, north, east, down
mavlink20.RTK_BASELINE_COORDINATE_SYSTEM_ENUM_END = 2 // 

// LANDING_TARGET_TYPE
mavlink20.LANDING_TARGET_TYPE_LIGHT_BEACON = 0 // Landing target signaled by light beacon (ex: IR-LOCK)
mavlink20.LANDING_TARGET_TYPE_RADIO_BEACON = 1 // Landing target signaled by radio beacon (ex: ILS, NDB)
mavlink20.LANDING_TARGET_TYPE_VISION_FIDUCIAL = 2 // Landing target represented by a fiducial marker (ex: ARTag)
mavlink20.LANDING_TARGET_TYPE_VISION_OTHER = 3 // Landing target represented by a pre-defined visual shape/feature (ex:
                        // X-marker, H-marker, square)
mavlink20.LANDING_TARGET_TYPE_ENUM_END = 4 // 

// VTOL_TRANSITION_HEADING
mavlink20.VTOL_TRANSITION_HEADING_VEHICLE_DEFAULT = 0 // Respect the heading configuration of the vehicle.
mavlink20.VTOL_TRANSITION_HEADING_NEXT_WAYPOINT = 1 // Use the heading pointing towards the next waypoint.
mavlink20.VTOL_TRANSITION_HEADING_TAKEOFF = 2 // Use the heading on takeoff (while sitting on the ground).
mavlink20.VTOL_TRANSITION_HEADING_SPECIFIED = 3 // Use the specified heading in parameter 4.
mavlink20.VTOL_TRANSITION_HEADING_ANY = 4 // Use the current heading when reaching takeoff altitude (potentially
                        // facing the wind when weather-vaning is
                        // active).
mavlink20.VTOL_TRANSITION_HEADING_ENUM_END = 5 // 

// CAMERA_CAP_FLAGS
mavlink20.CAMERA_CAP_FLAGS_CAPTURE_VIDEO = 1 // Camera is able to record video
mavlink20.CAMERA_CAP_FLAGS_CAPTURE_IMAGE = 2 // Camera is able to capture images
mavlink20.CAMERA_CAP_FLAGS_HAS_MODES = 4 // Camera has separate Video and Image/Photo modes
                        // (MAV_CMD_SET_CAMERA_MODE)
mavlink20.CAMERA_CAP_FLAGS_CAN_CAPTURE_IMAGE_IN_VIDEO_MODE = 8 // Camera can capture images while in video mode
mavlink20.CAMERA_CAP_FLAGS_CAN_CAPTURE_VIDEO_IN_IMAGE_MODE = 16 // Camera can capture videos while in Photo/Image mode
mavlink20.CAMERA_CAP_FLAGS_HAS_IMAGE_SURVEY_MODE = 32 // Camera has image survey mode (MAV_CMD_SET_CAMERA_MODE)
mavlink20.CAMERA_CAP_FLAGS_HAS_BASIC_ZOOM = 64 // Camera has basic zoom control (MAV_CMD_SET_CAMERA_ZOOM)
mavlink20.CAMERA_CAP_FLAGS_HAS_BASIC_FOCUS = 128 // Camera has basic focus control (MAV_CMD_SET_CAMERA_FOCUS)
mavlink20.CAMERA_CAP_FLAGS_HAS_VIDEO_STREAM = 256 // Camera has video streaming capabilities (request
                        // VIDEO_STREAM_INFORMATION with
                        // MAV_CMD_REQUEST_MESSAGE for video streaming
                        // info)
mavlink20.CAMERA_CAP_FLAGS_HAS_TRACKING_POINT = 512 // Camera supports tracking of a point on the camera view.
mavlink20.CAMERA_CAP_FLAGS_HAS_TRACKING_RECTANGLE = 1024 // Camera supports tracking of a selection rectangle on the camera view.
mavlink20.CAMERA_CAP_FLAGS_HAS_TRACKING_GEO_STATUS = 2048 // Camera supports tracking geo status (CAMERA_TRACKING_GEO_STATUS).
mavlink20.CAMERA_CAP_FLAGS_HAS_THERMAL_RANGE = 4096 // Camera supports absolute thermal range (request CAMERA_THERMAL_RANGE
                        // with MAV_CMD_REQUEST_MESSAGE).
mavlink20.CAMERA_CAP_FLAGS_ENUM_END = 4097 // 

// VIDEO_STREAM_STATUS_FLAGS
mavlink20.VIDEO_STREAM_STATUS_FLAGS_RUNNING = 1 // Stream is active (running)
mavlink20.VIDEO_STREAM_STATUS_FLAGS_THERMAL = 2 // Stream is thermal imaging
mavlink20.VIDEO_STREAM_STATUS_FLAGS_THERMAL_RANGE_ENABLED = 4 // Stream can report absolute thermal range (see CAMERA_THERMAL_RANGE).
mavlink20.VIDEO_STREAM_STATUS_FLAGS_ENUM_END = 5 // 

// VIDEO_STREAM_TYPE
mavlink20.VIDEO_STREAM_TYPE_RTSP = 0 // Stream is RTSP
mavlink20.VIDEO_STREAM_TYPE_RTPUDP = 1 // Stream is RTP UDP (URI gives the port number)
mavlink20.VIDEO_STREAM_TYPE_TCP_MPEG = 2 // Stream is MPEG on TCP
mavlink20.VIDEO_STREAM_TYPE_MPEG_TS = 3 // Stream is MPEG TS (URI gives the port number)
mavlink20.VIDEO_STREAM_TYPE_ENUM_END = 4 // 

// VIDEO_STREAM_ENCODING
mavlink20.VIDEO_STREAM_ENCODING_UNKNOWN = 0 // Stream encoding is unknown
mavlink20.VIDEO_STREAM_ENCODING_H264 = 1 // Stream encoding is H.264
mavlink20.VIDEO_STREAM_ENCODING_H265 = 2 // Stream encoding is H.265
mavlink20.VIDEO_STREAM_ENCODING_ENUM_END = 3 // 

// CAMERA_TRACKING_STATUS_FLAGS
mavlink20.CAMERA_TRACKING_STATUS_FLAGS_IDLE = 0 // Camera is not tracking
mavlink20.CAMERA_TRACKING_STATUS_FLAGS_ACTIVE = 1 // Camera is tracking
mavlink20.CAMERA_TRACKING_STATUS_FLAGS_ERROR = 2 // Camera tracking in error state
mavlink20.CAMERA_TRACKING_STATUS_FLAGS_ENUM_END = 3 // 

// CAMERA_TRACKING_MODE
mavlink20.CAMERA_TRACKING_MODE_NONE = 0 // Not tracking
mavlink20.CAMERA_TRACKING_MODE_POINT = 1 // Target is a point
mavlink20.CAMERA_TRACKING_MODE_RECTANGLE = 2 // Target is a rectangle
mavlink20.CAMERA_TRACKING_MODE_ENUM_END = 3 // 

// CAMERA_TRACKING_TARGET_DATA
mavlink20.CAMERA_TRACKING_TARGET_DATA_NONE = 0 // No target data
mavlink20.CAMERA_TRACKING_TARGET_DATA_EMBEDDED = 1 // Target data embedded in image data (proprietary)
mavlink20.CAMERA_TRACKING_TARGET_DATA_RENDERED = 2 // Target data rendered in image
mavlink20.CAMERA_TRACKING_TARGET_DATA_IN_STATUS = 4 // Target data within status message (Point or Rectangle)
mavlink20.CAMERA_TRACKING_TARGET_DATA_ENUM_END = 5 // 

// CAMERA_ZOOM_TYPE
mavlink20.ZOOM_TYPE_STEP = 0 // Zoom one step increment (-1 for wide, 1 for tele)
mavlink20.ZOOM_TYPE_CONTINUOUS = 1 // Continuous zoom up/down until stopped (-1 for wide, 1 for tele, 0 to
                        // stop zooming)
mavlink20.ZOOM_TYPE_RANGE = 2 // Zoom value as proportion of full camera range (a percentage value
                        // between 0.0 and 100.0)
mavlink20.ZOOM_TYPE_FOCAL_LENGTH = 3 // Zoom value/variable focal length in millimetres. Note that there is no
                        // message to get the valid zoom range of the
                        // camera, so this can type can only be used
                        // for cameras where the zoom range is known
                        // (implying that this cannot reliably be used
                        // in a GCS for an arbitrary camera)
mavlink20.ZOOM_TYPE_HORIZONTAL_FOV = 4 // Zoom value as horizontal field of view in degrees.
mavlink20.CAMERA_ZOOM_TYPE_ENUM_END = 5 // 

// SET_FOCUS_TYPE
mavlink20.FOCUS_TYPE_STEP = 0 // Focus one step increment (-1 for focusing in, 1 for focusing out
                        // towards infinity).
mavlink20.FOCUS_TYPE_CONTINUOUS = 1 // Continuous focus up/down until stopped (-1 for focusing in, 1 for
                        // focusing out towards infinity, 0 to stop
                        // focusing)
mavlink20.FOCUS_TYPE_RANGE = 2 // Focus value as proportion of full camera focus range (a value between
                        // 0.0 and 100.0)
mavlink20.FOCUS_TYPE_METERS = 3 // Focus value in metres. Note that there is no message to get the valid
                        // focus range of the camera, so this can type
                        // can only be used for cameras where the
                        // range is known (implying that this cannot
                        // reliably be used in a GCS for an arbitrary
                        // camera).
mavlink20.FOCUS_TYPE_AUTO = 4 // Focus automatically.
mavlink20.FOCUS_TYPE_AUTO_SINGLE = 5 // Single auto focus. Mainly used for still pictures. Usually abbreviated
                        // as AF-S.
mavlink20.FOCUS_TYPE_AUTO_CONTINUOUS = 6 // Continuous auto focus. Mainly used for dynamic scenes. Abbreviated as
                        // AF-C.
mavlink20.SET_FOCUS_TYPE_ENUM_END = 7 // 

// CAMERA_SOURCE
mavlink20.CAMERA_SOURCE_DEFAULT = 0 // Default camera source.
mavlink20.CAMERA_SOURCE_RGB = 1 // RGB camera source.
mavlink20.CAMERA_SOURCE_IR = 2 // IR camera source.
mavlink20.CAMERA_SOURCE_NDVI = 3 // NDVI camera source.
mavlink20.CAMERA_SOURCE_ENUM_END = 4 // 

// PARAM_ACK
mavlink20.PARAM_ACK_ACCEPTED = 0 // Parameter value ACCEPTED and SET
mavlink20.PARAM_ACK_VALUE_UNSUPPORTED = 1 // Parameter value UNKNOWN/UNSUPPORTED
mavlink20.PARAM_ACK_FAILED = 2 // Parameter failed to set
mavlink20.PARAM_ACK_IN_PROGRESS = 3 // Parameter value received but not yet set/accepted. A subsequent
                        // PARAM_EXT_ACK with the final result will
                        // follow once operation is completed. This is
                        // returned immediately for parameters that
                        // take longer to set, indicating that the the
                        // parameter was received and does not need to
                        // be resent.
mavlink20.PARAM_ACK_ENUM_END = 4 // 

// CAMERA_MODE
mavlink20.CAMERA_MODE_IMAGE = 0 // Camera is in image/photo capture mode.
mavlink20.CAMERA_MODE_VIDEO = 1 // Camera is in video capture mode.
mavlink20.CAMERA_MODE_IMAGE_SURVEY = 2 // Camera is in image survey capture mode. It allows for camera
                        // controller to do specific settings for
                        // surveys.
mavlink20.CAMERA_MODE_ENUM_END = 3 // 

// MAV_ARM_AUTH_DENIED_REASON
mavlink20.MAV_ARM_AUTH_DENIED_REASON_GENERIC = 0 // Not a specific reason
mavlink20.MAV_ARM_AUTH_DENIED_REASON_NONE = 1 // Authorizer will send the error as string to GCS
mavlink20.MAV_ARM_AUTH_DENIED_REASON_INVALID_WAYPOINT = 2 // At least one waypoint have a invalid value
mavlink20.MAV_ARM_AUTH_DENIED_REASON_TIMEOUT = 3 // Timeout in the authorizer process(in case it depends on network)
mavlink20.MAV_ARM_AUTH_DENIED_REASON_AIRSPACE_IN_USE = 4 // Airspace of the mission in use by another vehicle, second result
                        // parameter can have the waypoint id that
                        // caused it to be denied.
mavlink20.MAV_ARM_AUTH_DENIED_REASON_BAD_WEATHER = 5 // Weather is not good to fly
mavlink20.MAV_ARM_AUTH_DENIED_REASON_ENUM_END = 6 // 

// RC_TYPE
mavlink20.RC_TYPE_SPEKTRUM = 0 // Spektrum
mavlink20.RC_TYPE_CRSF = 1 // CRSF
mavlink20.RC_TYPE_ENUM_END = 2 // 

// RC_SUB_TYPE
mavlink20.RC_SUB_TYPE_SPEKTRUM_DSM2 = 0 // Spektrum DSM2
mavlink20.RC_SUB_TYPE_SPEKTRUM_DSMX = 1 // Spektrum DSMX
mavlink20.RC_SUB_TYPE_SPEKTRUM_DSMX8 = 2 // Spektrum DSMX8
mavlink20.RC_SUB_TYPE_ENUM_END = 3 // 

// POSITION_TARGET_TYPEMASK
mavlink20.POSITION_TARGET_TYPEMASK_X_IGNORE = 1 // Ignore position x
mavlink20.POSITION_TARGET_TYPEMASK_Y_IGNORE = 2 // Ignore position y
mavlink20.POSITION_TARGET_TYPEMASK_Z_IGNORE = 4 // Ignore position z
mavlink20.POSITION_TARGET_TYPEMASK_VX_IGNORE = 8 // Ignore velocity x
mavlink20.POSITION_TARGET_TYPEMASK_VY_IGNORE = 16 // Ignore velocity y
mavlink20.POSITION_TARGET_TYPEMASK_VZ_IGNORE = 32 // Ignore velocity z
mavlink20.POSITION_TARGET_TYPEMASK_AX_IGNORE = 64 // Ignore acceleration x
mavlink20.POSITION_TARGET_TYPEMASK_AY_IGNORE = 128 // Ignore acceleration y
mavlink20.POSITION_TARGET_TYPEMASK_AZ_IGNORE = 256 // Ignore acceleration z
mavlink20.POSITION_TARGET_TYPEMASK_FORCE_SET = 512 // Use force instead of acceleration
mavlink20.POSITION_TARGET_TYPEMASK_YAW_IGNORE = 1024 // Ignore yaw
mavlink20.POSITION_TARGET_TYPEMASK_YAW_RATE_IGNORE = 2048 // Ignore yaw rate
mavlink20.POSITION_TARGET_TYPEMASK_ENUM_END = 2049 // 

// ATTITUDE_TARGET_TYPEMASK
mavlink20.ATTITUDE_TARGET_TYPEMASK_BODY_ROLL_RATE_IGNORE = 1 // Ignore body roll rate
mavlink20.ATTITUDE_TARGET_TYPEMASK_BODY_PITCH_RATE_IGNORE = 2 // Ignore body pitch rate
mavlink20.ATTITUDE_TARGET_TYPEMASK_BODY_YAW_RATE_IGNORE = 4 // Ignore body yaw rate
mavlink20.ATTITUDE_TARGET_TYPEMASK_THRUST_BODY_SET = 32 // Use 3D body thrust setpoint instead of throttle
mavlink20.ATTITUDE_TARGET_TYPEMASK_THROTTLE_IGNORE = 64 // Ignore throttle
mavlink20.ATTITUDE_TARGET_TYPEMASK_ATTITUDE_IGNORE = 128 // Ignore attitude
mavlink20.ATTITUDE_TARGET_TYPEMASK_ENUM_END = 129 // 

// UTM_FLIGHT_STATE
mavlink20.UTM_FLIGHT_STATE_UNKNOWN = 1 // The flight state can't be determined.
mavlink20.UTM_FLIGHT_STATE_GROUND = 2 // UAS on ground.
mavlink20.UTM_FLIGHT_STATE_AIRBORNE = 3 // UAS airborne.
mavlink20.UTM_FLIGHT_STATE_EMERGENCY = 16 // UAS is in an emergency flight state.
mavlink20.UTM_FLIGHT_STATE_NOCTRL = 32 // UAS has no active controls.
mavlink20.UTM_FLIGHT_STATE_ENUM_END = 33 // 

// UTM_DATA_AVAIL_FLAGS
mavlink20.UTM_DATA_AVAIL_FLAGS_TIME_VALID = 1 // The field time contains valid data.
mavlink20.UTM_DATA_AVAIL_FLAGS_UAS_ID_AVAILABLE = 2 // The field uas_id contains valid data.
mavlink20.UTM_DATA_AVAIL_FLAGS_POSITION_AVAILABLE = 4 // The fields lat, lon and h_acc contain valid data.
mavlink20.UTM_DATA_AVAIL_FLAGS_ALTITUDE_AVAILABLE = 8 // The fields alt and v_acc contain valid data.
mavlink20.UTM_DATA_AVAIL_FLAGS_RELATIVE_ALTITUDE_AVAILABLE = 16 // The field relative_alt contains valid data.
mavlink20.UTM_DATA_AVAIL_FLAGS_HORIZONTAL_VELO_AVAILABLE = 32 // The fields vx and vy contain valid data.
mavlink20.UTM_DATA_AVAIL_FLAGS_VERTICAL_VELO_AVAILABLE = 64 // The field vz contains valid data.
mavlink20.UTM_DATA_AVAIL_FLAGS_NEXT_WAYPOINT_AVAILABLE = 128 // The fields next_lat, next_lon and next_alt contain valid data.
mavlink20.UTM_DATA_AVAIL_FLAGS_ENUM_END = 129 // 

// CELLULAR_STATUS_FLAG
mavlink20.CELLULAR_STATUS_FLAG_UNKNOWN = 0 // State unknown or not reportable.
mavlink20.CELLULAR_STATUS_FLAG_FAILED = 1 // Modem is unusable
mavlink20.CELLULAR_STATUS_FLAG_INITIALIZING = 2 // Modem is being initialized
mavlink20.CELLULAR_STATUS_FLAG_LOCKED = 3 // Modem is locked
mavlink20.CELLULAR_STATUS_FLAG_DISABLED = 4 // Modem is not enabled and is powered down
mavlink20.CELLULAR_STATUS_FLAG_DISABLING = 5 // Modem is currently transitioning to the CELLULAR_STATUS_FLAG_DISABLED
                        // state
mavlink20.CELLULAR_STATUS_FLAG_ENABLING = 6 // Modem is currently transitioning to the CELLULAR_STATUS_FLAG_ENABLED
                        // state
mavlink20.CELLULAR_STATUS_FLAG_ENABLED = 7 // Modem is enabled and powered on but not registered with a network
                        // provider and not available for data
                        // connections
mavlink20.CELLULAR_STATUS_FLAG_SEARCHING = 8 // Modem is searching for a network provider to register
mavlink20.CELLULAR_STATUS_FLAG_REGISTERED = 9 // Modem is registered with a network provider, and data connections and
                        // messaging may be available for use
mavlink20.CELLULAR_STATUS_FLAG_DISCONNECTING = 10 // Modem is disconnecting and deactivating the last active packet data
                        // bearer. This state will not be entered if
                        // more than one packet data bearer is active
                        // and one of the active bearers is
                        // deactivated
mavlink20.CELLULAR_STATUS_FLAG_CONNECTING = 11 // Modem is activating and connecting the first packet data bearer.
                        // Subsequent bearer activations when another
                        // bearer is already active do not cause this
                        // state to be entered
mavlink20.CELLULAR_STATUS_FLAG_CONNECTED = 12 // One or more packet data bearers is active and connected
mavlink20.CELLULAR_STATUS_FLAG_ENUM_END = 13 // 

// CELLULAR_NETWORK_FAILED_REASON
mavlink20.CELLULAR_NETWORK_FAILED_REASON_NONE = 0 // No error
mavlink20.CELLULAR_NETWORK_FAILED_REASON_UNKNOWN = 1 // Error state is unknown
mavlink20.CELLULAR_NETWORK_FAILED_REASON_SIM_MISSING = 2 // SIM is required for the modem but missing
mavlink20.CELLULAR_NETWORK_FAILED_REASON_SIM_ERROR = 3 // SIM is available, but not usable for connection
mavlink20.CELLULAR_NETWORK_FAILED_REASON_ENUM_END = 4 // 

// CELLULAR_NETWORK_RADIO_TYPE
mavlink20.CELLULAR_NETWORK_RADIO_TYPE_NONE = 0 // 
mavlink20.CELLULAR_NETWORK_RADIO_TYPE_GSM = 1 // 
mavlink20.CELLULAR_NETWORK_RADIO_TYPE_CDMA = 2 // 
mavlink20.CELLULAR_NETWORK_RADIO_TYPE_WCDMA = 3 // 
mavlink20.CELLULAR_NETWORK_RADIO_TYPE_LTE = 4 // 
mavlink20.CELLULAR_NETWORK_RADIO_TYPE_ENUM_END = 5 // 

// PRECISION_LAND_MODE
mavlink20.PRECISION_LAND_MODE_DISABLED = 0 // Normal (non-precision) landing.
mavlink20.PRECISION_LAND_MODE_OPPORTUNISTIC = 1 // Use precision landing if beacon detected when land command accepted,
                        // otherwise land normally.
mavlink20.PRECISION_LAND_MODE_REQUIRED = 2 // Use precision landing, searching for beacon if not found when land
                        // command accepted (land normally if beacon
                        // cannot be found).
mavlink20.PRECISION_LAND_MODE_ENUM_END = 3 // 

// PARACHUTE_ACTION
mavlink20.PARACHUTE_DISABLE = 0 // Disable auto-release of parachute (i.e. release triggered by crash
                        // detectors).
mavlink20.PARACHUTE_ENABLE = 1 // Enable auto-release of parachute.
mavlink20.PARACHUTE_RELEASE = 2 // Release parachute and kill motors.
mavlink20.PARACHUTE_ACTION_ENUM_END = 3 // 

// MAV_TUNNEL_PAYLOAD_TYPE
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_UNKNOWN = 0 // Encoding of payload unknown.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED0 = 200 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED1 = 201 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED2 = 202 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED3 = 203 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED4 = 204 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED5 = 205 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED6 = 206 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED7 = 207 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED8 = 208 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED9 = 209 // Registered for STorM32 gimbal controller.
mavlink20.MAV_TUNNEL_PAYLOAD_TYPE_ENUM_END = 210 // 

// MAV_ODID_ID_TYPE
mavlink20.MAV_ODID_ID_TYPE_NONE = 0 // No type defined.
mavlink20.MAV_ODID_ID_TYPE_SERIAL_NUMBER = 1 // Manufacturer Serial Number (ANSI/CTA-2063 format).
mavlink20.MAV_ODID_ID_TYPE_CAA_REGISTRATION_ID = 2 // CAA (Civil Aviation Authority) registered ID. Format: [ICAO Country
                        // Code].[CAA Assigned ID].
mavlink20.MAV_ODID_ID_TYPE_UTM_ASSIGNED_UUID = 3 // UTM (Unmanned Traffic Management) assigned UUID (RFC4122).
mavlink20.MAV_ODID_ID_TYPE_SPECIFIC_SESSION_ID = 4 // A 20 byte ID for a specific flight/session. The exact ID type is
                        // indicated by the first byte of uas_id and
                        // these type values are managed by ICAO.
mavlink20.MAV_ODID_ID_TYPE_ENUM_END = 5 // 

// MAV_ODID_UA_TYPE
mavlink20.MAV_ODID_UA_TYPE_NONE = 0 // No UA (Unmanned Aircraft) type defined.
mavlink20.MAV_ODID_UA_TYPE_AEROPLANE = 1 // Aeroplane/Airplane. Fixed wing.
mavlink20.MAV_ODID_UA_TYPE_HELICOPTER_OR_MULTIROTOR = 2 // Helicopter or multirotor.
mavlink20.MAV_ODID_UA_TYPE_GYROPLANE = 3 // Gyroplane.
mavlink20.MAV_ODID_UA_TYPE_HYBRID_LIFT = 4 // VTOL (Vertical Take-Off and Landing). Fixed wing aircraft that can
                        // take off vertically.
mavlink20.MAV_ODID_UA_TYPE_ORNITHOPTER = 5 // Ornithopter.
mavlink20.MAV_ODID_UA_TYPE_GLIDER = 6 // Glider.
mavlink20.MAV_ODID_UA_TYPE_KITE = 7 // Kite.
mavlink20.MAV_ODID_UA_TYPE_FREE_BALLOON = 8 // Free Balloon.
mavlink20.MAV_ODID_UA_TYPE_CAPTIVE_BALLOON = 9 // Captive Balloon.
mavlink20.MAV_ODID_UA_TYPE_AIRSHIP = 10 // Airship. E.g. a blimp.
mavlink20.MAV_ODID_UA_TYPE_FREE_FALL_PARACHUTE = 11 // Free Fall/Parachute (unpowered).
mavlink20.MAV_ODID_UA_TYPE_ROCKET = 12 // Rocket.
mavlink20.MAV_ODID_UA_TYPE_TETHERED_POWERED_AIRCRAFT = 13 // Tethered powered aircraft.
mavlink20.MAV_ODID_UA_TYPE_GROUND_OBSTACLE = 14 // Ground Obstacle.
mavlink20.MAV_ODID_UA_TYPE_OTHER = 15 // Other type of aircraft not listed earlier.
mavlink20.MAV_ODID_UA_TYPE_ENUM_END = 16 // 

// MAV_ODID_STATUS
mavlink20.MAV_ODID_STATUS_UNDECLARED = 0 // The status of the (UA) Unmanned Aircraft is undefined.
mavlink20.MAV_ODID_STATUS_GROUND = 1 // The UA is on the ground.
mavlink20.MAV_ODID_STATUS_AIRBORNE = 2 // The UA is in the air.
mavlink20.MAV_ODID_STATUS_EMERGENCY = 3 // The UA is having an emergency.
mavlink20.MAV_ODID_STATUS_REMOTE_ID_SYSTEM_FAILURE = 4 // The remote ID system is failing or unreliable in some way.
mavlink20.MAV_ODID_STATUS_ENUM_END = 5 // 

// MAV_ODID_HEIGHT_REF
mavlink20.MAV_ODID_HEIGHT_REF_OVER_TAKEOFF = 0 // The height field is relative to the take-off location.
mavlink20.MAV_ODID_HEIGHT_REF_OVER_GROUND = 1 // The height field is relative to ground.
mavlink20.MAV_ODID_HEIGHT_REF_ENUM_END = 2 // 

// MAV_ODID_HOR_ACC
mavlink20.MAV_ODID_HOR_ACC_UNKNOWN = 0 // The horizontal accuracy is unknown.
mavlink20.MAV_ODID_HOR_ACC_10NM = 1 // The horizontal accuracy is smaller than 10 Nautical Miles. 18.52 km.
mavlink20.MAV_ODID_HOR_ACC_4NM = 2 // The horizontal accuracy is smaller than 4 Nautical Miles. 7.408 km.
mavlink20.MAV_ODID_HOR_ACC_2NM = 3 // The horizontal accuracy is smaller than 2 Nautical Miles. 3.704 km.
mavlink20.MAV_ODID_HOR_ACC_1NM = 4 // The horizontal accuracy is smaller than 1 Nautical Miles. 1.852 km.
mavlink20.MAV_ODID_HOR_ACC_0_5NM = 5 // The horizontal accuracy is smaller than 0.5 Nautical Miles. 926 m.
mavlink20.MAV_ODID_HOR_ACC_0_3NM = 6 // The horizontal accuracy is smaller than 0.3 Nautical Miles. 555.6 m.
mavlink20.MAV_ODID_HOR_ACC_0_1NM = 7 // The horizontal accuracy is smaller than 0.1 Nautical Miles. 185.2 m.
mavlink20.MAV_ODID_HOR_ACC_0_05NM = 8 // The horizontal accuracy is smaller than 0.05 Nautical Miles. 92.6 m.
mavlink20.MAV_ODID_HOR_ACC_30_METER = 9 // The horizontal accuracy is smaller than 30 meter.
mavlink20.MAV_ODID_HOR_ACC_10_METER = 10 // The horizontal accuracy is smaller than 10 meter.
mavlink20.MAV_ODID_HOR_ACC_3_METER = 11 // The horizontal accuracy is smaller than 3 meter.
mavlink20.MAV_ODID_HOR_ACC_1_METER = 12 // The horizontal accuracy is smaller than 1 meter.
mavlink20.MAV_ODID_HOR_ACC_ENUM_END = 13 // 

// MAV_ODID_VER_ACC
mavlink20.MAV_ODID_VER_ACC_UNKNOWN = 0 // The vertical accuracy is unknown.
mavlink20.MAV_ODID_VER_ACC_150_METER = 1 // The vertical accuracy is smaller than 150 meter.
mavlink20.MAV_ODID_VER_ACC_45_METER = 2 // The vertical accuracy is smaller than 45 meter.
mavlink20.MAV_ODID_VER_ACC_25_METER = 3 // The vertical accuracy is smaller than 25 meter.
mavlink20.MAV_ODID_VER_ACC_10_METER = 4 // The vertical accuracy is smaller than 10 meter.
mavlink20.MAV_ODID_VER_ACC_3_METER = 5 // The vertical accuracy is smaller than 3 meter.
mavlink20.MAV_ODID_VER_ACC_1_METER = 6 // The vertical accuracy is smaller than 1 meter.
mavlink20.MAV_ODID_VER_ACC_ENUM_END = 7 // 

// MAV_ODID_SPEED_ACC
mavlink20.MAV_ODID_SPEED_ACC_UNKNOWN = 0 // The speed accuracy is unknown.
mavlink20.MAV_ODID_SPEED_ACC_10_METERS_PER_SECOND = 1 // The speed accuracy is smaller than 10 meters per second.
mavlink20.MAV_ODID_SPEED_ACC_3_METERS_PER_SECOND = 2 // The speed accuracy is smaller than 3 meters per second.
mavlink20.MAV_ODID_SPEED_ACC_1_METERS_PER_SECOND = 3 // The speed accuracy is smaller than 1 meters per second.
mavlink20.MAV_ODID_SPEED_ACC_0_3_METERS_PER_SECOND = 4 // The speed accuracy is smaller than 0.3 meters per second.
mavlink20.MAV_ODID_SPEED_ACC_ENUM_END = 5 // 

// MAV_ODID_TIME_ACC
mavlink20.MAV_ODID_TIME_ACC_UNKNOWN = 0 // The timestamp accuracy is unknown.
mavlink20.MAV_ODID_TIME_ACC_0_1_SECOND = 1 // The timestamp accuracy is smaller than or equal to 0.1 second.
mavlink20.MAV_ODID_TIME_ACC_0_2_SECOND = 2 // The timestamp accuracy is smaller than or equal to 0.2 second.
mavlink20.MAV_ODID_TIME_ACC_0_3_SECOND = 3 // The timestamp accuracy is smaller than or equal to 0.3 second.
mavlink20.MAV_ODID_TIME_ACC_0_4_SECOND = 4 // The timestamp accuracy is smaller than or equal to 0.4 second.
mavlink20.MAV_ODID_TIME_ACC_0_5_SECOND = 5 // The timestamp accuracy is smaller than or equal to 0.5 second.
mavlink20.MAV_ODID_TIME_ACC_0_6_SECOND = 6 // The timestamp accuracy is smaller than or equal to 0.6 second.
mavlink20.MAV_ODID_TIME_ACC_0_7_SECOND = 7 // The timestamp accuracy is smaller than or equal to 0.7 second.
mavlink20.MAV_ODID_TIME_ACC_0_8_SECOND = 8 // The timestamp accuracy is smaller than or equal to 0.8 second.
mavlink20.MAV_ODID_TIME_ACC_0_9_SECOND = 9 // The timestamp accuracy is smaller than or equal to 0.9 second.
mavlink20.MAV_ODID_TIME_ACC_1_0_SECOND = 10 // The timestamp accuracy is smaller than or equal to 1.0 second.
mavlink20.MAV_ODID_TIME_ACC_1_1_SECOND = 11 // The timestamp accuracy is smaller than or equal to 1.1 second.
mavlink20.MAV_ODID_TIME_ACC_1_2_SECOND = 12 // The timestamp accuracy is smaller than or equal to 1.2 second.
mavlink20.MAV_ODID_TIME_ACC_1_3_SECOND = 13 // The timestamp accuracy is smaller than or equal to 1.3 second.
mavlink20.MAV_ODID_TIME_ACC_1_4_SECOND = 14 // The timestamp accuracy is smaller than or equal to 1.4 second.
mavlink20.MAV_ODID_TIME_ACC_1_5_SECOND = 15 // The timestamp accuracy is smaller than or equal to 1.5 second.
mavlink20.MAV_ODID_TIME_ACC_ENUM_END = 16 // 

// MAV_ODID_AUTH_TYPE
mavlink20.MAV_ODID_AUTH_TYPE_NONE = 0 // No authentication type is specified.
mavlink20.MAV_ODID_AUTH_TYPE_UAS_ID_SIGNATURE = 1 // Signature for the UAS (Unmanned Aircraft System) ID.
mavlink20.MAV_ODID_AUTH_TYPE_OPERATOR_ID_SIGNATURE = 2 // Signature for the Operator ID.
mavlink20.MAV_ODID_AUTH_TYPE_MESSAGE_SET_SIGNATURE = 3 // Signature for the entire message set.
mavlink20.MAV_ODID_AUTH_TYPE_NETWORK_REMOTE_ID = 4 // Authentication is provided by Network Remote ID.
mavlink20.MAV_ODID_AUTH_TYPE_SPECIFIC_AUTHENTICATION = 5 // The exact authentication type is indicated by the first byte of
                        // authentication_data and these type values
                        // are managed by ICAO.
mavlink20.MAV_ODID_AUTH_TYPE_ENUM_END = 6 // 

// MAV_ODID_DESC_TYPE
mavlink20.MAV_ODID_DESC_TYPE_TEXT = 0 // Optional free-form text description of the purpose of the flight.
mavlink20.MAV_ODID_DESC_TYPE_EMERGENCY = 1 // Optional additional clarification when status ==
                        // MAV_ODID_STATUS_EMERGENCY.
mavlink20.MAV_ODID_DESC_TYPE_EXTENDED_STATUS = 2 // Optional additional clarification when status !=
                        // MAV_ODID_STATUS_EMERGENCY.
mavlink20.MAV_ODID_DESC_TYPE_ENUM_END = 3 // 

// MAV_ODID_OPERATOR_LOCATION_TYPE
mavlink20.MAV_ODID_OPERATOR_LOCATION_TYPE_TAKEOFF = 0 // The location/altitude of the operator is the same as the take-off
                        // location.
mavlink20.MAV_ODID_OPERATOR_LOCATION_TYPE_LIVE_GNSS = 1 // The location/altitude of the operator is dynamic. E.g. based on live
                        // GNSS data.
mavlink20.MAV_ODID_OPERATOR_LOCATION_TYPE_FIXED = 2 // The location/altitude of the operator are fixed values.
mavlink20.MAV_ODID_OPERATOR_LOCATION_TYPE_ENUM_END = 3 // 

// MAV_ODID_CLASSIFICATION_TYPE
mavlink20.MAV_ODID_CLASSIFICATION_TYPE_UNDECLARED = 0 // The classification type for the UA is undeclared.
mavlink20.MAV_ODID_CLASSIFICATION_TYPE_EU = 1 // The classification type for the UA follows EU (European Union)
                        // specifications.
mavlink20.MAV_ODID_CLASSIFICATION_TYPE_ENUM_END = 2 // 

// MAV_ODID_CATEGORY_EU
mavlink20.MAV_ODID_CATEGORY_EU_UNDECLARED = 0 // The category for the UA, according to the EU specification, is
                        // undeclared.
mavlink20.MAV_ODID_CATEGORY_EU_OPEN = 1 // The category for the UA, according to the EU specification, is the
                        // Open category.
mavlink20.MAV_ODID_CATEGORY_EU_SPECIFIC = 2 // The category for the UA, according to the EU specification, is the
                        // Specific category.
mavlink20.MAV_ODID_CATEGORY_EU_CERTIFIED = 3 // The category for the UA, according to the EU specification, is the
                        // Certified category.
mavlink20.MAV_ODID_CATEGORY_EU_ENUM_END = 4 // 

// MAV_ODID_CLASS_EU
mavlink20.MAV_ODID_CLASS_EU_UNDECLARED = 0 // The class for the UA, according to the EU specification, is
                        // undeclared.
mavlink20.MAV_ODID_CLASS_EU_CLASS_0 = 1 // The class for the UA, according to the EU specification, is Class 0.
mavlink20.MAV_ODID_CLASS_EU_CLASS_1 = 2 // The class for the UA, according to the EU specification, is Class 1.
mavlink20.MAV_ODID_CLASS_EU_CLASS_2 = 3 // The class for the UA, according to the EU specification, is Class 2.
mavlink20.MAV_ODID_CLASS_EU_CLASS_3 = 4 // The class for the UA, according to the EU specification, is Class 3.
mavlink20.MAV_ODID_CLASS_EU_CLASS_4 = 5 // The class for the UA, according to the EU specification, is Class 4.
mavlink20.MAV_ODID_CLASS_EU_CLASS_5 = 6 // The class for the UA, according to the EU specification, is Class 5.
mavlink20.MAV_ODID_CLASS_EU_CLASS_6 = 7 // The class for the UA, according to the EU specification, is Class 6.
mavlink20.MAV_ODID_CLASS_EU_ENUM_END = 8 // 

// MAV_ODID_OPERATOR_ID_TYPE
mavlink20.MAV_ODID_OPERATOR_ID_TYPE_CAA = 0 // CAA (Civil Aviation Authority) registered operator ID.
mavlink20.MAV_ODID_OPERATOR_ID_TYPE_ENUM_END = 1 // 

// MAV_ODID_ARM_STATUS
mavlink20.MAV_ODID_ARM_STATUS_GOOD_TO_ARM = 0 // Passing arming checks.
mavlink20.MAV_ODID_ARM_STATUS_PRE_ARM_FAIL_GENERIC = 1 // Generic arming failure, see error string for details.
mavlink20.MAV_ODID_ARM_STATUS_ENUM_END = 2 // 

// TUNE_FORMAT
mavlink20.TUNE_FORMAT_QBASIC1_1 = 1 // Format is QBasic 1.1 Play:
                        // https://www.qbasic.net/en/reference/qb11/St
                        // atement/PLAY-006.htm.
mavlink20.TUNE_FORMAT_MML_MODERN = 2 // Format is Modern Music Markup Language (MML):
                        // https://en.wikipedia.org/wiki/Music_Macro_L
                        // anguage#Modern_MML.
mavlink20.TUNE_FORMAT_ENUM_END = 3 // 

// AIS_TYPE
mavlink20.AIS_TYPE_UNKNOWN = 0 // Not available (default).
mavlink20.AIS_TYPE_RESERVED_1 = 1 // 
mavlink20.AIS_TYPE_RESERVED_2 = 2 // 
mavlink20.AIS_TYPE_RESERVED_3 = 3 // 
mavlink20.AIS_TYPE_RESERVED_4 = 4 // 
mavlink20.AIS_TYPE_RESERVED_5 = 5 // 
mavlink20.AIS_TYPE_RESERVED_6 = 6 // 
mavlink20.AIS_TYPE_RESERVED_7 = 7 // 
mavlink20.AIS_TYPE_RESERVED_8 = 8 // 
mavlink20.AIS_TYPE_RESERVED_9 = 9 // 
mavlink20.AIS_TYPE_RESERVED_10 = 10 // 
mavlink20.AIS_TYPE_RESERVED_11 = 11 // 
mavlink20.AIS_TYPE_RESERVED_12 = 12 // 
mavlink20.AIS_TYPE_RESERVED_13 = 13 // 
mavlink20.AIS_TYPE_RESERVED_14 = 14 // 
mavlink20.AIS_TYPE_RESERVED_15 = 15 // 
mavlink20.AIS_TYPE_RESERVED_16 = 16 // 
mavlink20.AIS_TYPE_RESERVED_17 = 17 // 
mavlink20.AIS_TYPE_RESERVED_18 = 18 // 
mavlink20.AIS_TYPE_RESERVED_19 = 19 // 
mavlink20.AIS_TYPE_WIG = 20 // Wing In Ground effect.
mavlink20.AIS_TYPE_WIG_HAZARDOUS_A = 21 // 
mavlink20.AIS_TYPE_WIG_HAZARDOUS_B = 22 // 
mavlink20.AIS_TYPE_WIG_HAZARDOUS_C = 23 // 
mavlink20.AIS_TYPE_WIG_HAZARDOUS_D = 24 // 
mavlink20.AIS_TYPE_WIG_RESERVED_1 = 25 // 
mavlink20.AIS_TYPE_WIG_RESERVED_2 = 26 // 
mavlink20.AIS_TYPE_WIG_RESERVED_3 = 27 // 
mavlink20.AIS_TYPE_WIG_RESERVED_4 = 28 // 
mavlink20.AIS_TYPE_WIG_RESERVED_5 = 29 // 
mavlink20.AIS_TYPE_FISHING = 30 // 
mavlink20.AIS_TYPE_TOWING = 31 // 
mavlink20.AIS_TYPE_TOWING_LARGE = 32 // Towing: length exceeds 200m or breadth exceeds 25m.
mavlink20.AIS_TYPE_DREDGING = 33 // Dredging or other underwater ops.
mavlink20.AIS_TYPE_DIVING = 34 // 
mavlink20.AIS_TYPE_MILITARY = 35 // 
mavlink20.AIS_TYPE_SAILING = 36 // 
mavlink20.AIS_TYPE_PLEASURE = 37 // 
mavlink20.AIS_TYPE_RESERVED_20 = 38 // 
mavlink20.AIS_TYPE_RESERVED_21 = 39 // 
mavlink20.AIS_TYPE_HSC = 40 // High Speed Craft.
mavlink20.AIS_TYPE_HSC_HAZARDOUS_A = 41 // 
mavlink20.AIS_TYPE_HSC_HAZARDOUS_B = 42 // 
mavlink20.AIS_TYPE_HSC_HAZARDOUS_C = 43 // 
mavlink20.AIS_TYPE_HSC_HAZARDOUS_D = 44 // 
mavlink20.AIS_TYPE_HSC_RESERVED_1 = 45 // 
mavlink20.AIS_TYPE_HSC_RESERVED_2 = 46 // 
mavlink20.AIS_TYPE_HSC_RESERVED_3 = 47 // 
mavlink20.AIS_TYPE_HSC_RESERVED_4 = 48 // 
mavlink20.AIS_TYPE_HSC_UNKNOWN = 49 // 
mavlink20.AIS_TYPE_PILOT = 50 // 
mavlink20.AIS_TYPE_SAR = 51 // Search And Rescue vessel.
mavlink20.AIS_TYPE_TUG = 52 // 
mavlink20.AIS_TYPE_PORT_TENDER = 53 // 
mavlink20.AIS_TYPE_ANTI_POLLUTION = 54 // Anti-pollution equipment.
mavlink20.AIS_TYPE_LAW_ENFORCEMENT = 55 // 
mavlink20.AIS_TYPE_SPARE_LOCAL_1 = 56 // 
mavlink20.AIS_TYPE_SPARE_LOCAL_2 = 57 // 
mavlink20.AIS_TYPE_MEDICAL_TRANSPORT = 58 // 
mavlink20.AIS_TYPE_NONECOMBATANT = 59 // Noncombatant ship according to RR Resolution No. 18.
mavlink20.AIS_TYPE_PASSENGER = 60 // 
mavlink20.AIS_TYPE_PASSENGER_HAZARDOUS_A = 61 // 
mavlink20.AIS_TYPE_PASSENGER_HAZARDOUS_B = 62 // 
mavlink20.AIS_TYPE_PASSENGER_HAZARDOUS_C = 63 // 
mavlink20.AIS_TYPE_PASSENGER_HAZARDOUS_D = 64 // 
mavlink20.AIS_TYPE_PASSENGER_RESERVED_1 = 65 // 
mavlink20.AIS_TYPE_PASSENGER_RESERVED_2 = 66 // 
mavlink20.AIS_TYPE_PASSENGER_RESERVED_3 = 67 // 
mavlink20.AIS_TYPE_PASSENGER_RESERVED_4 = 68 // 
mavlink20.AIS_TYPE_PASSENGER_UNKNOWN = 69 // 
mavlink20.AIS_TYPE_CARGO = 70 // 
mavlink20.AIS_TYPE_CARGO_HAZARDOUS_A = 71 // 
mavlink20.AIS_TYPE_CARGO_HAZARDOUS_B = 72 // 
mavlink20.AIS_TYPE_CARGO_HAZARDOUS_C = 73 // 
mavlink20.AIS_TYPE_CARGO_HAZARDOUS_D = 74 // 
mavlink20.AIS_TYPE_CARGO_RESERVED_1 = 75 // 
mavlink20.AIS_TYPE_CARGO_RESERVED_2 = 76 // 
mavlink20.AIS_TYPE_CARGO_RESERVED_3 = 77 // 
mavlink20.AIS_TYPE_CARGO_RESERVED_4 = 78 // 
mavlink20.AIS_TYPE_CARGO_UNKNOWN = 79 // 
mavlink20.AIS_TYPE_TANKER = 80 // 
mavlink20.AIS_TYPE_TANKER_HAZARDOUS_A = 81 // 
mavlink20.AIS_TYPE_TANKER_HAZARDOUS_B = 82 // 
mavlink20.AIS_TYPE_TANKER_HAZARDOUS_C = 83 // 
mavlink20.AIS_TYPE_TANKER_HAZARDOUS_D = 84 // 
mavlink20.AIS_TYPE_TANKER_RESERVED_1 = 85 // 
mavlink20.AIS_TYPE_TANKER_RESERVED_2 = 86 // 
mavlink20.AIS_TYPE_TANKER_RESERVED_3 = 87 // 
mavlink20.AIS_TYPE_TANKER_RESERVED_4 = 88 // 
mavlink20.AIS_TYPE_TANKER_UNKNOWN = 89 // 
mavlink20.AIS_TYPE_OTHER = 90 // 
mavlink20.AIS_TYPE_OTHER_HAZARDOUS_A = 91 // 
mavlink20.AIS_TYPE_OTHER_HAZARDOUS_B = 92 // 
mavlink20.AIS_TYPE_OTHER_HAZARDOUS_C = 93 // 
mavlink20.AIS_TYPE_OTHER_HAZARDOUS_D = 94 // 
mavlink20.AIS_TYPE_OTHER_RESERVED_1 = 95 // 
mavlink20.AIS_TYPE_OTHER_RESERVED_2 = 96 // 
mavlink20.AIS_TYPE_OTHER_RESERVED_3 = 97 // 
mavlink20.AIS_TYPE_OTHER_RESERVED_4 = 98 // 
mavlink20.AIS_TYPE_OTHER_UNKNOWN = 99 // 
mavlink20.AIS_TYPE_ENUM_END = 100 // 

// AIS_NAV_STATUS
mavlink20.UNDER_WAY = 0 // Under way using engine.
mavlink20.AIS_NAV_ANCHORED = 1 // 
mavlink20.AIS_NAV_UN_COMMANDED = 2 // 
mavlink20.AIS_NAV_RESTRICTED_MANOEUVERABILITY = 3 // 
mavlink20.AIS_NAV_DRAUGHT_CONSTRAINED = 4 // 
mavlink20.AIS_NAV_MOORED = 5 // 
mavlink20.AIS_NAV_AGROUND = 6 // 
mavlink20.AIS_NAV_FISHING = 7 // 
mavlink20.AIS_NAV_SAILING = 8 // 
mavlink20.AIS_NAV_RESERVED_HSC = 9 // 
mavlink20.AIS_NAV_RESERVED_WIG = 10 // 
mavlink20.AIS_NAV_RESERVED_1 = 11 // 
mavlink20.AIS_NAV_RESERVED_2 = 12 // 
mavlink20.AIS_NAV_RESERVED_3 = 13 // 
mavlink20.AIS_NAV_AIS_SART = 14 // Search And Rescue Transponder.
mavlink20.AIS_NAV_UNKNOWN = 15 // Not available (default).
mavlink20.AIS_NAV_STATUS_ENUM_END = 16 // 

// AIS_FLAGS
mavlink20.AIS_FLAGS_POSITION_ACCURACY = 1 // 1 = Position accuracy less than 10m, 0 = position accuracy greater
                        // than 10m.
mavlink20.AIS_FLAGS_VALID_COG = 2 // 
mavlink20.AIS_FLAGS_VALID_VELOCITY = 4 // 
mavlink20.AIS_FLAGS_HIGH_VELOCITY = 8 // 1 = Velocity over 52.5765m/s (102.2 knots)
mavlink20.AIS_FLAGS_VALID_TURN_RATE = 16 // 
mavlink20.AIS_FLAGS_TURN_RATE_SIGN_ONLY = 32 // Only the sign of the returned turn rate value is valid, either greater
                        // than 5deg/30s or less than -5deg/30s
mavlink20.AIS_FLAGS_VALID_DIMENSIONS = 64 // 
mavlink20.AIS_FLAGS_LARGE_BOW_DIMENSION = 128 // Distance to bow is larger than 511m
mavlink20.AIS_FLAGS_LARGE_STERN_DIMENSION = 256 // Distance to stern is larger than 511m
mavlink20.AIS_FLAGS_LARGE_PORT_DIMENSION = 512 // Distance to port side is larger than 63m
mavlink20.AIS_FLAGS_LARGE_STARBOARD_DIMENSION = 1024 // Distance to starboard side is larger than 63m
mavlink20.AIS_FLAGS_VALID_CALLSIGN = 2048 // 
mavlink20.AIS_FLAGS_VALID_NAME = 4096 // 
mavlink20.AIS_FLAGS_ENUM_END = 4097 // 

// FAILURE_UNIT
mavlink20.FAILURE_UNIT_SENSOR_GYRO = 0 // 
mavlink20.FAILURE_UNIT_SENSOR_ACCEL = 1 // 
mavlink20.FAILURE_UNIT_SENSOR_MAG = 2 // 
mavlink20.FAILURE_UNIT_SENSOR_BARO = 3 // 
mavlink20.FAILURE_UNIT_SENSOR_GPS = 4 // 
mavlink20.FAILURE_UNIT_SENSOR_OPTICAL_FLOW = 5 // 
mavlink20.FAILURE_UNIT_SENSOR_VIO = 6 // 
mavlink20.FAILURE_UNIT_SENSOR_DISTANCE_SENSOR = 7 // 
mavlink20.FAILURE_UNIT_SENSOR_AIRSPEED = 8 // 
mavlink20.FAILURE_UNIT_SYSTEM_BATTERY = 100 // 
mavlink20.FAILURE_UNIT_SYSTEM_MOTOR = 101 // 
mavlink20.FAILURE_UNIT_SYSTEM_SERVO = 102 // 
mavlink20.FAILURE_UNIT_SYSTEM_AVOIDANCE = 103 // 
mavlink20.FAILURE_UNIT_SYSTEM_RC_SIGNAL = 104 // 
mavlink20.FAILURE_UNIT_SYSTEM_MAVLINK_SIGNAL = 105 // 
mavlink20.FAILURE_UNIT_ENUM_END = 106 // 

// FAILURE_TYPE
mavlink20.FAILURE_TYPE_OK = 0 // No failure injected, used to reset a previous failure.
mavlink20.FAILURE_TYPE_OFF = 1 // Sets unit off, so completely non-responsive.
mavlink20.FAILURE_TYPE_STUCK = 2 // Unit is stuck e.g. keeps reporting the same value.
mavlink20.FAILURE_TYPE_GARBAGE = 3 // Unit is reporting complete garbage.
mavlink20.FAILURE_TYPE_WRONG = 4 // Unit is consistently wrong.
mavlink20.FAILURE_TYPE_SLOW = 5 // Unit is slow, so e.g. reporting at slower than expected rate.
mavlink20.FAILURE_TYPE_DELAYED = 6 // Data of unit is delayed in time.
mavlink20.FAILURE_TYPE_INTERMITTENT = 7 // Unit is sometimes working, sometimes not.
mavlink20.FAILURE_TYPE_ENUM_END = 8 // 

// NAV_VTOL_LAND_OPTIONS
mavlink20.NAV_VTOL_LAND_OPTIONS_DEFAULT = 0 // Default autopilot landing behaviour.
mavlink20.NAV_VTOL_LAND_OPTIONS_FW_DESCENT = 1 // Descend in fixed wing mode, transitioning to multicopter mode for
                        // vertical landing when close to the ground.
                        // The fixed wing descent pattern is at the
                        // discretion of the vehicle (e.g. transition
                        // altitude, loiter direction, radius, and
                        // speed, etc.).
mavlink20.NAV_VTOL_LAND_OPTIONS_HOVER_DESCENT = 2 // Land in multicopter mode on reaching the landing coordinates (the
                        // whole landing is by "hover descent").
mavlink20.NAV_VTOL_LAND_OPTIONS_ENUM_END = 3 // 

// MAV_WINCH_STATUS_FLAG
mavlink20.MAV_WINCH_STATUS_HEALTHY = 1 // Winch is healthy
mavlink20.MAV_WINCH_STATUS_FULLY_RETRACTED = 2 // Winch line is fully retracted
mavlink20.MAV_WINCH_STATUS_MOVING = 4 // Winch motor is moving
mavlink20.MAV_WINCH_STATUS_CLUTCH_ENGAGED = 8 // Winch clutch is engaged allowing motor to move freely.
mavlink20.MAV_WINCH_STATUS_LOCKED = 16 // Winch is locked by locking mechanism.
mavlink20.MAV_WINCH_STATUS_DROPPING = 32 // Winch is gravity dropping payload.
mavlink20.MAV_WINCH_STATUS_ARRESTING = 64 // Winch is arresting payload descent.
mavlink20.MAV_WINCH_STATUS_GROUND_SENSE = 128 // Winch is using torque measurements to sense the ground.
mavlink20.MAV_WINCH_STATUS_RETRACTING = 256 // Winch is returning to the fully retracted position.
mavlink20.MAV_WINCH_STATUS_REDELIVER = 512 // Winch is redelivering the payload. This is a failover state if the
                        // line tension goes above a threshold during
                        // RETRACTING.
mavlink20.MAV_WINCH_STATUS_ABANDON_LINE = 1024 // Winch is abandoning the line and possibly payload. Winch unspools the
                        // entire calculated line length. This is a
                        // failover state from REDELIVER if the number
                        // of attempts exceeds a threshold.
mavlink20.MAV_WINCH_STATUS_LOCKING = 2048 // Winch is engaging the locking mechanism.
mavlink20.MAV_WINCH_STATUS_LOAD_LINE = 4096 // Winch is spooling on line.
mavlink20.MAV_WINCH_STATUS_LOAD_PAYLOAD = 8192 // Winch is loading a payload.
mavlink20.MAV_WINCH_STATUS_FLAG_ENUM_END = 8193 // 

// MAG_CAL_STATUS
mavlink20.MAG_CAL_NOT_STARTED = 0 // 
mavlink20.MAG_CAL_WAITING_TO_START = 1 // 
mavlink20.MAG_CAL_RUNNING_STEP_ONE = 2 // 
mavlink20.MAG_CAL_RUNNING_STEP_TWO = 3 // 
mavlink20.MAG_CAL_SUCCESS = 4 // 
mavlink20.MAG_CAL_FAILED = 5 // 
mavlink20.MAG_CAL_BAD_ORIENTATION = 6 // 
mavlink20.MAG_CAL_BAD_RADIUS = 7 // 
mavlink20.MAG_CAL_STATUS_ENUM_END = 8 // 

// MAV_EVENT_ERROR_REASON
mavlink20.MAV_EVENT_ERROR_REASON_UNAVAILABLE = 0 // The requested event is not available (anymore).
mavlink20.MAV_EVENT_ERROR_REASON_ENUM_END = 1 // 

// MAV_EVENT_CURRENT_SEQUENCE_FLAGS
mavlink20.MAV_EVENT_CURRENT_SEQUENCE_FLAGS_RESET = 1 // A sequence reset has happened (e.g. vehicle reboot).
mavlink20.MAV_EVENT_CURRENT_SEQUENCE_FLAGS_ENUM_END = 2 // 

// HIL_SENSOR_UPDATED_FLAGS
mavlink20.HIL_SENSOR_UPDATED_NONE = 0 // None of the fields in HIL_SENSOR have been updated
mavlink20.HIL_SENSOR_UPDATED_XACC = 1 // The value in the xacc field has been updated
mavlink20.HIL_SENSOR_UPDATED_YACC = 2 // The value in the yacc field has been updated
mavlink20.HIL_SENSOR_UPDATED_ZACC = 4 // The value in the zacc field has been updated
mavlink20.HIL_SENSOR_UPDATED_XGYRO = 8 // The value in the xgyro field has been updated
mavlink20.HIL_SENSOR_UPDATED_YGYRO = 16 // The value in the ygyro field has been updated
mavlink20.HIL_SENSOR_UPDATED_ZGYRO = 32 // The value in the zgyro field has been updated
mavlink20.HIL_SENSOR_UPDATED_XMAG = 64 // The value in the xmag field has been updated
mavlink20.HIL_SENSOR_UPDATED_YMAG = 128 // The value in the ymag field has been updated
mavlink20.HIL_SENSOR_UPDATED_ZMAG = 256 // The value in the zmag field has been updated
mavlink20.HIL_SENSOR_UPDATED_ABS_PRESSURE = 512 // The value in the abs_pressure field has been updated
mavlink20.HIL_SENSOR_UPDATED_DIFF_PRESSURE = 1024 // The value in the diff_pressure field has been updated
mavlink20.HIL_SENSOR_UPDATED_PRESSURE_ALT = 2048 // The value in the pressure_alt field has been updated
mavlink20.HIL_SENSOR_UPDATED_TEMPERATURE = 4096 // The value in the temperature field has been updated
mavlink20.HIL_SENSOR_UPDATED_RESET = 2147483648 // Full reset of attitude/position/velocities/etc was performed in sim
                        // (Bit 31).
mavlink20.HIL_SENSOR_UPDATED_FLAGS_ENUM_END = 2147483649 // 

// HIGHRES_IMU_UPDATED_FLAGS
mavlink20.HIGHRES_IMU_UPDATED_NONE = 0 // None of the fields in HIGHRES_IMU have been updated
mavlink20.HIGHRES_IMU_UPDATED_XACC = 1 // The value in the xacc field has been updated
mavlink20.HIGHRES_IMU_UPDATED_YACC = 2 // The value in the yacc field has been updated
mavlink20.HIGHRES_IMU_UPDATED_ZACC = 4 // The value in the zacc field has been updated since
mavlink20.HIGHRES_IMU_UPDATED_XGYRO = 8 // The value in the xgyro field has been updated
mavlink20.HIGHRES_IMU_UPDATED_YGYRO = 16 // The value in the ygyro field has been updated
mavlink20.HIGHRES_IMU_UPDATED_ZGYRO = 32 // The value in the zgyro field has been updated
mavlink20.HIGHRES_IMU_UPDATED_XMAG = 64 // The value in the xmag field has been updated
mavlink20.HIGHRES_IMU_UPDATED_YMAG = 128 // The value in the ymag field has been updated
mavlink20.HIGHRES_IMU_UPDATED_ZMAG = 256 // The value in the zmag field has been updated
mavlink20.HIGHRES_IMU_UPDATED_ABS_PRESSURE = 512 // The value in the abs_pressure field has been updated
mavlink20.HIGHRES_IMU_UPDATED_DIFF_PRESSURE = 1024 // The value in the diff_pressure field has been updated
mavlink20.HIGHRES_IMU_UPDATED_PRESSURE_ALT = 2048 // The value in the pressure_alt field has been updated
mavlink20.HIGHRES_IMU_UPDATED_TEMPERATURE = 4096 // The value in the temperature field has been updated
mavlink20.HIGHRES_IMU_UPDATED_ALL = 65535 // All fields in HIGHRES_IMU have been updated.
mavlink20.HIGHRES_IMU_UPDATED_FLAGS_ENUM_END = 65536 // 

// CAN_FILTER_OP
mavlink20.CAN_FILTER_REPLACE = 0 // 
mavlink20.CAN_FILTER_ADD = 1 // 
mavlink20.CAN_FILTER_REMOVE = 2 // 
mavlink20.CAN_FILTER_OP_ENUM_END = 3 // 

// MAV_FTP_ERR
mavlink20.MAV_FTP_ERR_NONE = 0 // None: No error
mavlink20.MAV_FTP_ERR_FAIL = 1 // Fail: Unknown failure
mavlink20.MAV_FTP_ERR_FAILERRNO = 2 // FailErrno: Command failed, Err number sent back in
                        // PayloadHeader.data[1].                 This
                        // is a file-system error number understood by
                        // the server operating system.
mavlink20.MAV_FTP_ERR_INVALIDDATASIZE = 3 // InvalidDataSize: Payload size is invalid
mavlink20.MAV_FTP_ERR_INVALIDSESSION = 4 // InvalidSession: Session is not currently open
mavlink20.MAV_FTP_ERR_NOSESSIONSAVAILABLE = 5 // NoSessionsAvailable: All available sessions are already in use
mavlink20.MAV_FTP_ERR_EOF = 6 // EOF: Offset past end of file for ListDirectory and ReadFile commands
mavlink20.MAV_FTP_ERR_UNKNOWNCOMMAND = 7 // UnknownCommand: Unknown command / opcode
mavlink20.MAV_FTP_ERR_FILEEXISTS = 8 // FileExists: File/directory already exists
mavlink20.MAV_FTP_ERR_FILEPROTECTED = 9 // FileProtected: File/directory is write protected
mavlink20.MAV_FTP_ERR_FILENOTFOUND = 10 // FileNotFound: File/directory not found
mavlink20.MAV_FTP_ERR_ENUM_END = 11 // 

// MAV_FTP_OPCODE
mavlink20.MAV_FTP_OPCODE_NONE = 0 // None. Ignored, always ACKed
mavlink20.MAV_FTP_OPCODE_TERMINATESESSION = 1 // TerminateSession: Terminates open Read session
mavlink20.MAV_FTP_OPCODE_RESETSESSION = 2 // ResetSessions: Terminates all open read sessions
mavlink20.MAV_FTP_OPCODE_LISTDIRECTORY = 3 // ListDirectory. List files and directories in path from offset
mavlink20.MAV_FTP_OPCODE_OPENFILERO = 4 // OpenFileRO: Opens file at path for reading, returns session
mavlink20.MAV_FTP_OPCODE_READFILE = 5 // ReadFile: Reads size bytes from offset in session
mavlink20.MAV_FTP_OPCODE_CREATEFILE = 6 // CreateFile: Creates file at path for writing, returns session
mavlink20.MAV_FTP_OPCODE_WRITEFILE = 7 // WriteFile: Writes size bytes to offset in session
mavlink20.MAV_FTP_OPCODE_REMOVEFILE = 8 // RemoveFile: Remove file at path
mavlink20.MAV_FTP_OPCODE_CREATEDIRECTORY = 9 // CreateDirectory: Creates directory at path
mavlink20.MAV_FTP_OPCODE_REMOVEDIRECTORY = 10 // RemoveDirectory: Removes directory at path. The directory must be
                        // empty.
mavlink20.MAV_FTP_OPCODE_OPENFILEWO = 11 // OpenFileWO: Opens file at path for writing, returns session
mavlink20.MAV_FTP_OPCODE_TRUNCATEFILE = 12 // TruncateFile: Truncate file at path to offset length
mavlink20.MAV_FTP_OPCODE_RENAME = 13 // Rename: Rename path1 to path2
mavlink20.MAV_FTP_OPCODE_CALCFILECRC = 14 // CalcFileCRC32: Calculate CRC32 for file at path
mavlink20.MAV_FTP_OPCODE_BURSTREADFILE = 15 // BurstReadFile: Burst download session file
mavlink20.MAV_FTP_OPCODE_ACK = 128 // ACK: ACK response
mavlink20.MAV_FTP_OPCODE_NAK = 129 // NAK: NAK response
mavlink20.MAV_FTP_OPCODE_ENUM_END = 130 // 

// MISSION_STATE
mavlink20.MISSION_STATE_UNKNOWN = 0 // The mission status reporting is not supported.
mavlink20.MISSION_STATE_NO_MISSION = 1 // No mission on the vehicle.
mavlink20.MISSION_STATE_NOT_STARTED = 2 // Mission has not started. This is the case after a mission has uploaded
                        // but not yet started executing.
mavlink20.MISSION_STATE_ACTIVE = 3 // Mission is active, and will execute mission items when in auto mode.
mavlink20.MISSION_STATE_PAUSED = 4 // Mission is paused when in auto mode.
mavlink20.MISSION_STATE_COMPLETE = 5 // Mission has executed all mission items.
mavlink20.MISSION_STATE_ENUM_END = 6 // 

// SAFETY_SWITCH_STATE
mavlink20.SAFETY_SWITCH_STATE_SAFE = 0 // Safety switch is engaged and vehicle should be safe to approach.
mavlink20.SAFETY_SWITCH_STATE_DANGEROUS = 1 // Safety switch is NOT engaged and motors, propellers and other
                        // actuators should be considered active.
mavlink20.SAFETY_SWITCH_STATE_ENUM_END = 2 // 

// ILLUMINATOR_MODE
mavlink20.ILLUMINATOR_MODE_UNKNOWN = 0 // Illuminator mode is not specified/unknown
mavlink20.ILLUMINATOR_MODE_INTERNAL_CONTROL = 1 // Illuminator behavior is controlled by MAV_CMD_DO_ILLUMINATOR_CONFIGURE
                        // settings
mavlink20.ILLUMINATOR_MODE_EXTERNAL_SYNC = 2 // Illuminator behavior is controlled by external factors: e.g. an
                        // external hardware signal
mavlink20.ILLUMINATOR_MODE_ENUM_END = 3 // 

// ILLUMINATOR_ERROR_FLAGS
mavlink20.ILLUMINATOR_ERROR_FLAGS_THERMAL_THROTTLING = 1 // Illuminator thermal throttling error.
mavlink20.ILLUMINATOR_ERROR_FLAGS_OVER_TEMPERATURE_SHUTDOWN = 2 // Illuminator over temperature shutdown error.
mavlink20.ILLUMINATOR_ERROR_FLAGS_THERMISTOR_FAILURE = 4 // Illuminator thermistor failure.
mavlink20.ILLUMINATOR_ERROR_FLAGS_ENUM_END = 5 // 

// AIRSPEED_SENSOR_FLAGS
mavlink20.AIRSPEED_SENSOR_UNHEALTHY = 0 // Airspeed sensor is unhealthy
mavlink20.AIRSPEED_SENSOR_USING = 1 // True if the data from this sensor is being actively used by the flight
                        // controller for guidance, navigation or
                        // control.
mavlink20.AIRSPEED_SENSOR_FLAGS_ENUM_END = 2 // 

// MAV_STANDARD_MODE
mavlink20.MAV_STANDARD_MODE_NON_STANDARD = 0 // Non standard mode.           This may be used when reporting the mode
                        // if the current flight mode is not a
                        // standard mode.
mavlink20.MAV_STANDARD_MODE_POSITION_HOLD = 1 // Position mode (manual).           Position-controlled and stabilized
                        // manual mode.           When sticks are
                        // released vehicles return to their level-
                        // flight orientation and hold both position
                        // and altitude against wind and external
                        // forces.           This mode can only be set
                        // by vehicles that can hold a fixed position.
                        // Multicopter (MC) vehicles actively brake
                        // and hold both position and altitude against
                        // wind and external forces.           Hybrid
                        // MC/FW ("VTOL") vehicles first transition to
                        // multicopter mode (if needed) but otherwise
                        // behave in the same way as MC vehicles.
                        // Fixed-wing (FW) vehicles must not support
                        // this mode.           Other vehicle types
                        // must not support this mode (this may be
                        // revisited through the PR process).
mavlink20.MAV_STANDARD_MODE_ORBIT = 2 // Orbit (manual).           Position-controlled and stabilized manual
                        // mode.           The vehicle circles around
                        // a fixed setpoint in the horizontal plane at
                        // a particular radius, altitude, and
                        // direction.           Flight stacks may
                        // further allow manual control over the
                        // setpoint position, radius, direction,
                        // speed, and/or altitude of the circle, but
                        // this is not mandated.           Flight
                        // stacks may support the [MAV_CMD_DO_ORBIT](h
                        // ttps://mavlink.io/en/messages/common.html#M
                        // AV_CMD_DO_ORBIT) for changing the orbit
                        // parameters.           MC and FW vehicles
                        // may support this mode.           Hybrid
                        // MC/FW ("VTOL") vehicles may support this
                        // mode in MC/FW or both modes; if the mode is
                        // not supported by the current configuration
                        // the vehicle should transition to the
                        // supported configuration.           Other
                        // vehicle types must not support this mode
                        // (this may be revisited through the PR
                        // process).
mavlink20.MAV_STANDARD_MODE_CRUISE = 3 // Cruise mode (manual).           Position-controlled and stabilized
                        // manual mode.           When sticks are
                        // released vehicles return to their level-
                        // flight orientation and hold their original
                        // track against wind and external forces.
                        // Fixed-wing (FW) vehicles level orientation
                        // and maintain current track and altitude
                        // against wind and external forces.
                        // Hybrid MC/FW ("VTOL") vehicles first
                        // transition to FW mode (if needed) but
                        // otherwise behave in the same way as MC
                        // vehicles.           Multicopter (MC)
                        // vehicles must not support this mode.
                        // Other vehicle types must not support this
                        // mode (this may be revisited through the PR
                        // process).
mavlink20.MAV_STANDARD_MODE_ALTITUDE_HOLD = 4 // Altitude hold (manual).           Altitude-controlled and stabilized
                        // manual mode.           When sticks are
                        // released vehicles return to their level-
                        // flight orientation and hold their altitude.
                        // MC vehicles continue with existing momentum
                        // and may move with wind (or other external
                        // forces).           FW vehicles continue
                        // with current heading, but may be moved off-
                        // track by wind.           Hybrid MC/FW
                        // ("VTOL") vehicles behave according to their
                        // current configuration/mode (FW or MC).
                        // Other vehicle types must not support this
                        // mode (this may be revisited through the PR
                        // process).
mavlink20.MAV_STANDARD_MODE_SAFE_RECOVERY = 5 // Safe recovery mode (auto).           Automatic mode that takes vehicle
                        // to a predefined safe location via a safe
                        // flight path, and may also automatically
                        // land the vehicle.           This mode is
                        // more commonly referred to as RTL and/or or
                        // Smart RTL.           The precise return
                        // location, flight path, and landing
                        // behaviour depend on vehicle configuration
                        // and type.           For example, the
                        // vehicle might return to the home/launch
                        // location, a rally point, or the start of a
                        // mission landing, it might follow a direct
                        // path, mission path, or breadcrumb path, and
                        // land using a mission landing pattern or
                        // some other kind of descent.
mavlink20.MAV_STANDARD_MODE_MISSION = 6 // Mission mode (automatic).           Automatic mode that executes
                        // MAVLink missions.           Missions are
                        // executed from the current waypoint as soon
                        // as the mode is enabled.
mavlink20.MAV_STANDARD_MODE_LAND = 7 // Land mode (auto).           Automatic mode that lands the vehicle at
                        // the current location.           The precise
                        // landing behaviour depends on vehicle
                        // configuration and type.
mavlink20.MAV_STANDARD_MODE_TAKEOFF = 8 // Takeoff mode (auto).           Automatic takeoff mode.           The
                        // precise takeoff behaviour depends on
                        // vehicle configuration and type.
mavlink20.MAV_STANDARD_MODE_ENUM_END = 9 // 

// MAV_MODE_PROPERTY
mavlink20.MAV_MODE_PROPERTY_ADVANCED = 1 // If set, this mode is an advanced mode.           For example a rate-
                        // controlled manual mode might be advanced,
                        // whereas a position-controlled manual mode
                        // is not.           A GCS can optionally use
                        // this flag to configure the UI for its
                        // intended users.
mavlink20.MAV_MODE_PROPERTY_NOT_USER_SELECTABLE = 2 // If set, this mode should not be added to the list of selectable modes.
                        // The mode might still be selected by the FC
                        // directly (for example as part of a
                        // failsafe).
mavlink20.MAV_MODE_PROPERTY_ENUM_END = 3 // 

// MAV_BATTERY_STATUS_FLAGS
mavlink20.MAV_BATTERY_STATUS_FLAGS_NOT_READY_TO_USE = 1 //            The battery is not ready to use (fly).           Set if the
                        // battery has faults or other conditions that
                        // make it unsafe to fly with.           Note:
                        // It will be the logical OR of other status
                        // bits (chosen by the
                        // manufacturer/integrator).
mavlink20.MAV_BATTERY_STATUS_FLAGS_CHARGING = 2 //            Battery is charging.
mavlink20.MAV_BATTERY_STATUS_FLAGS_CELL_BALANCING = 4 //            Battery is cell balancing (during charging).           Not
                        // ready to use
                        // (MAV_BATTERY_STATUS_FLAGS_NOT_READY_TO_USE
                        // may be set).
mavlink20.MAV_BATTERY_STATUS_FLAGS_FAULT_CELL_IMBALANCE = 8 //            Battery cells are not balanced.           Not ready to use.
mavlink20.MAV_BATTERY_STATUS_FLAGS_AUTO_DISCHARGING = 16 //            Battery is auto discharging (towards storage level).
                        // Not ready to use
                        // (MAV_BATTERY_STATUS_FLAGS_NOT_READY_TO_USE
                        // would be set).
mavlink20.MAV_BATTERY_STATUS_FLAGS_REQUIRES_SERVICE = 32 //            Battery requires service (not safe to fly).           This
                        // is set at vendor discretion.           It
                        // is likely to be set for most faults, and
                        // may also be set according to a maintenance
                        // schedule (such as age, or number of
                        // recharge cycles, etc.).
mavlink20.MAV_BATTERY_STATUS_FLAGS_BAD_BATTERY = 64 //            Battery is faulty and cannot be repaired (not safe to fly).
                        // This is set at vendor discretion.
                        // The battery should be disposed of safely.
mavlink20.MAV_BATTERY_STATUS_FLAGS_PROTECTIONS_ENABLED = 128 //            Automatic battery protection monitoring is enabled.
                        // When enabled, the system will monitor for
                        // certain kinds of faults, such as cells
                        // being over-voltage.           If a fault is
                        // triggered then and protections are enabled
                        // then a safety fault (MAV_BATTERY_STATUS_FLA
                        // GS_FAULT_PROTECTION_SYSTEM) will be set and
                        // power from the battery will be stopped.
                        // Note that battery protection monitoring
                        // should only be enabled when the vehicle is
                        // landed. Once the vehicle is armed, or
                        // starts moving, the protections should be
                        // disabled to prevent false positives from
                        // disabling the output.
mavlink20.MAV_BATTERY_STATUS_FLAGS_FAULT_PROTECTION_SYSTEM = 256 //            The battery fault protection system had detected a fault
                        // and cut all power from the battery.
                        // This will only trigger if MAV_BATTERY_STATU
                        // S_FLAGS_PROTECTIONS_ENABLED is set.
                        // Other faults like
                        // MAV_BATTERY_STATUS_FLAGS_FAULT_OVER_VOLT
                        // may also be set, indicating the cause of
                        // the protection fault.
mavlink20.MAV_BATTERY_STATUS_FLAGS_FAULT_OVER_VOLT = 512 // One or more cells are above their maximum voltage rating.
mavlink20.MAV_BATTERY_STATUS_FLAGS_FAULT_UNDER_VOLT = 1024 //            One or more cells are below their minimum voltage rating.
                        // A battery that had deep-discharged might be
                        // irrepairably damaged, and set both
                        // MAV_BATTERY_STATUS_FLAGS_FAULT_UNDER_VOLT
                        // and MAV_BATTERY_STATUS_FLAGS_BAD_BATTERY.
mavlink20.MAV_BATTERY_STATUS_FLAGS_FAULT_OVER_TEMPERATURE = 2048 // Over-temperature fault.
mavlink20.MAV_BATTERY_STATUS_FLAGS_FAULT_UNDER_TEMPERATURE = 4096 // Under-temperature fault.
mavlink20.MAV_BATTERY_STATUS_FLAGS_FAULT_OVER_CURRENT = 8192 // Over-current fault.
mavlink20.MAV_BATTERY_STATUS_FLAGS_FAULT_SHORT_CIRCUIT = 16384 //            Short circuit event detected.           The battery may or
                        // may not be safe to use (check other flags).
mavlink20.MAV_BATTERY_STATUS_FLAGS_FAULT_INCOMPATIBLE_VOLTAGE = 32768 // Voltage not compatible with power rail voltage (batteries on same
                        // power rail should have similar voltage).
mavlink20.MAV_BATTERY_STATUS_FLAGS_FAULT_INCOMPATIBLE_FIRMWARE = 65536 // Battery firmware is not compatible with current autopilot firmware.
mavlink20.MAV_BATTERY_STATUS_FLAGS_FAULT_INCOMPATIBLE_CELLS_CONFIGURATION = 131072 // Battery is not compatible due to cell configuration (e.g. 5s1p when
                        // vehicle requires 6s).
mavlink20.MAV_BATTERY_STATUS_FLAGS_CAPACITY_RELATIVE_TO_FULL = 262144 //            Battery capacity_consumed and capacity_remaining values are
                        // relative to a full battery (they sum to the
                        // total capacity of the battery).
                        // This flag would be set for a smart battery
                        // that can accurately determine its remaining
                        // charge across vehicle reboots and
                        // discharge/recharge cycles.           If
                        // unset the capacity_consumed indicates the
                        // consumption since vehicle power-on, as
                        // measured using a power monitor. The
                        // capacity_remaining, if provided, indicates
                        // the estimated remaining capacity on the
                        // assumption that the battery was full on
                        // vehicle boot.           If unset a GCS is
                        // recommended to advise that users fully
                        // charge the battery on power on.
mavlink20.MAV_BATTERY_STATUS_FLAGS_EXTENDED = 4294967295 // Reserved (not used). If set, this will indicate that an additional
                        // status field exists for higher status
                        // values.
mavlink20.MAV_BATTERY_STATUS_FLAGS_ENUM_END = 4294967296 // 

// GCS_CONTROL_STATUS_FLAGS
mavlink20.GCS_CONTROL_STATUS_FLAGS_SYSTEM_MANAGER = 1 // If set, this CONTROL_STATUS publishes the controlling GCS for the
                        // whole system. If unset, the CONTROL_STATUS
                        // indicates the controlling GCS for just the
                        // component emitting the message. Note that
                        // to request control of the system a GCS
                        // should send
                        // MAV_CMD_REQUEST_OPERATOR_CONTROL to the
                        // component emitting CONTROL_STATUS with this
                        // flag set.
mavlink20.GCS_CONTROL_STATUS_FLAGS_TAKEOVER_ALLOWED = 2 // Takeover allowed (requests for control will be granted). If not set
                        // requests for control will be rejected, but
                        // the controlling GCS will be notified (and
                        // may release control or allow takeover).
mavlink20.GCS_CONTROL_STATUS_FLAGS_ENUM_END = 3 // 

// TARGET_ABSOLUTE_SENSOR_CAPABILITY_FLAGS
mavlink20.TARGET_ABSOLUTE_SENSOR_CAPABILITY_POSITION = 1 // 
mavlink20.TARGET_ABSOLUTE_SENSOR_CAPABILITY_VELOCITY = 2 // 
mavlink20.TARGET_ABSOLUTE_SENSOR_CAPABILITY_ACCELERATION = 4 // 
mavlink20.TARGET_ABSOLUTE_SENSOR_CAPABILITY_ATTITUDE = 8 // 
mavlink20.TARGET_ABSOLUTE_SENSOR_CAPABILITY_RATES = 16 // 
mavlink20.TARGET_ABSOLUTE_SENSOR_CAPABILITY_FLAGS_ENUM_END = 17 // 

// TARGET_OBS_FRAME
mavlink20.TARGET_OBS_FRAME_LOCAL_NED = 0 // NED local tangent frame (x: North, y: East, z: Down) with origin fixed
                        // relative to earth.
mavlink20.TARGET_OBS_FRAME_BODY_FRD = 1 // FRD local frame aligned to the vehicle's attitude (x: Forward, y:
                        // Right, z: Down) with an origin that travels
                        // with vehicle.
mavlink20.TARGET_OBS_FRAME_LOCAL_OFFSET_NED = 2 // NED local tangent frame (x: North, y: East, z: Down) with an origin
                        // that travels with vehicle.
mavlink20.TARGET_OBS_FRAME_OTHER = 3 // Other sensor frame for target observations neither in local NED nor in
                        // body FRD.
mavlink20.TARGET_OBS_FRAME_ENUM_END = 4 // 

// RADIO_RC_CHANNELS_FLAGS
mavlink20.RADIO_RC_CHANNELS_FLAGS_FAILSAFE = 1 // Failsafe is active. The content of the RC channels data in the
                        // RADIO_RC_CHANNELS message is implementation
                        // dependent.
mavlink20.RADIO_RC_CHANNELS_FLAGS_OUTDATED = 2 // Channel data may be out of date. This is set when the receiver is
                        // unable to validate incoming data from the
                        // transmitter and has therefore resent the
                        // last valid data it received.
mavlink20.RADIO_RC_CHANNELS_FLAGS_ENUM_END = 3 // 

// GPS_SYSTEM_ERROR_FLAGS
mavlink20.GPS_SYSTEM_ERROR_INCOMING_CORRECTIONS = 1 // There are problems with incoming correction streams.
mavlink20.GPS_SYSTEM_ERROR_CONFIGURATION = 2 // There are problems with the configuration.
mavlink20.GPS_SYSTEM_ERROR_SOFTWARE = 4 // There are problems with the software on the GPS receiver.
mavlink20.GPS_SYSTEM_ERROR_ANTENNA = 8 // There are problems with an antenna connected to the GPS receiver.
mavlink20.GPS_SYSTEM_ERROR_EVENT_CONGESTION = 16 // There are problems handling all incoming events.
mavlink20.GPS_SYSTEM_ERROR_CPU_OVERLOAD = 32 // The GPS receiver CPU is overloaded.
mavlink20.GPS_SYSTEM_ERROR_OUTPUT_CONGESTION = 64 // The GPS receiver is experiencing output congestion.
mavlink20.GPS_SYSTEM_ERROR_FLAGS_ENUM_END = 65 // 

// GPS_AUTHENTICATION_STATE
mavlink20.GPS_AUTHENTICATION_STATE_UNKNOWN = 0 // The GPS receiver does not provide GPS signal authentication info.
mavlink20.GPS_AUTHENTICATION_STATE_INITIALIZING = 1 // The GPS receiver is initializing signal authentication.
mavlink20.GPS_AUTHENTICATION_STATE_ERROR = 2 // The GPS receiver encountered an error while initializing signal
                        // authentication.
mavlink20.GPS_AUTHENTICATION_STATE_OK = 3 // The GPS receiver has correctly authenticated all signals.
mavlink20.GPS_AUTHENTICATION_STATE_DISABLED = 4 // GPS signal authentication is disabled on the receiver.
mavlink20.GPS_AUTHENTICATION_STATE_ENUM_END = 5 // 

// GPS_JAMMING_STATE
mavlink20.GPS_JAMMING_STATE_UNKNOWN = 0 // The GPS receiver does not provide GPS signal jamming info.
mavlink20.GPS_JAMMING_STATE_OK = 1 // The GPS receiver detected no signal jamming.
mavlink20.GPS_JAMMING_STATE_MITIGATED = 2 // The GPS receiver detected and mitigated signal jamming.
mavlink20.GPS_JAMMING_STATE_DETECTED = 3 // The GPS receiver detected signal jamming.
mavlink20.GPS_JAMMING_STATE_ENUM_END = 4 // 

// GPS_SPOOFING_STATE
mavlink20.GPS_SPOOFING_STATE_UNKNOWN = 0 // The GPS receiver does not provide GPS signal spoofing info.
mavlink20.GPS_SPOOFING_STATE_OK = 1 // The GPS receiver detected no signal spoofing.
mavlink20.GPS_SPOOFING_STATE_MITIGATED = 2 // The GPS receiver detected and mitigated signal spoofing.
mavlink20.GPS_SPOOFING_STATE_DETECTED = 3 // The GPS receiver detected signal spoofing but still has a fix.
mavlink20.GPS_SPOOFING_STATE_ENUM_END = 4 // 

// GPS_RAIM_STATE
mavlink20.GPS_RAIM_STATE_UNKNOWN = 0 // RAIM capability is unknown.
mavlink20.GPS_RAIM_STATE_DISABLED = 1 // RAIM is disabled.
mavlink20.GPS_RAIM_STATE_OK = 2 // RAIM integrity check was successful.
mavlink20.GPS_RAIM_STATE_FAILED = 3 // RAIM integrity check failed.
mavlink20.GPS_RAIM_STATE_ENUM_END = 4 // 

// ICAROUS_TRACK_BAND_TYPES
mavlink20.ICAROUS_TRACK_BAND_TYPE_NONE = 0 // 
mavlink20.ICAROUS_TRACK_BAND_TYPE_NEAR = 1 // 
mavlink20.ICAROUS_TRACK_BAND_TYPE_RECOVERY = 2 // 
mavlink20.ICAROUS_TRACK_BAND_TYPES_ENUM_END = 3 // 

// ICAROUS_FMS_STATE
mavlink20.ICAROUS_FMS_STATE_IDLE = 0 // 
mavlink20.ICAROUS_FMS_STATE_TAKEOFF = 1 // 
mavlink20.ICAROUS_FMS_STATE_CLIMB = 2 // 
mavlink20.ICAROUS_FMS_STATE_CRUISE = 3 // 
mavlink20.ICAROUS_FMS_STATE_APPROACH = 4 // 
mavlink20.ICAROUS_FMS_STATE_LAND = 5 // 
mavlink20.ICAROUS_FMS_STATE_ENUM_END = 6 // 

// MAV_AUTOPILOT
mavlink20.MAV_AUTOPILOT_GENERIC = 0 // Generic autopilot, full support for everything
mavlink20.MAV_AUTOPILOT_RESERVED = 1 // Reserved for future use.
mavlink20.MAV_AUTOPILOT_SLUGS = 2 // SLUGS autopilot, http://slugsuav.soe.ucsc.edu
mavlink20.MAV_AUTOPILOT_ARDUPILOTMEGA = 3 // ArduPilot - Plane/Copter/Rover/Sub/Tracker, https://ardupilot.org
mavlink20.MAV_AUTOPILOT_OPENPILOT = 4 // OpenPilot, http://openpilot.org
mavlink20.MAV_AUTOPILOT_GENERIC_WAYPOINTS_ONLY = 5 // Generic autopilot only supporting simple waypoints
mavlink20.MAV_AUTOPILOT_GENERIC_WAYPOINTS_AND_SIMPLE_NAVIGATION_ONLY = 6 // Generic autopilot supporting waypoints and other simple navigation
                        // commands
mavlink20.MAV_AUTOPILOT_GENERIC_MISSION_FULL = 7 // Generic autopilot supporting the full mission command set
mavlink20.MAV_AUTOPILOT_INVALID = 8 // No valid autopilot, e.g. a GCS or other MAVLink component
mavlink20.MAV_AUTOPILOT_PPZ = 9 // PPZ UAV - http://nongnu.org/paparazzi
mavlink20.MAV_AUTOPILOT_UDB = 10 // UAV Dev Board
mavlink20.MAV_AUTOPILOT_FP = 11 // FlexiPilot
mavlink20.MAV_AUTOPILOT_PX4 = 12 // PX4 Autopilot - http://px4.io/
mavlink20.MAV_AUTOPILOT_SMACCMPILOT = 13 // SMACCMPilot - http://smaccmpilot.org
mavlink20.MAV_AUTOPILOT_AUTOQUAD = 14 // AutoQuad -- http://autoquad.org
mavlink20.MAV_AUTOPILOT_ARMAZILA = 15 // Armazila -- http://armazila.com
mavlink20.MAV_AUTOPILOT_AEROB = 16 // Aerob -- http://aerob.ru
mavlink20.MAV_AUTOPILOT_ASLUAV = 17 // ASLUAV autopilot -- http://www.asl.ethz.ch
mavlink20.MAV_AUTOPILOT_SMARTAP = 18 // SmartAP Autopilot - http://sky-drones.com
mavlink20.MAV_AUTOPILOT_AIRRAILS = 19 // AirRails - http://uaventure.com
mavlink20.MAV_AUTOPILOT_REFLEX = 20 // Fusion Reflex - https://fusion.engineering
mavlink20.MAV_AUTOPILOT_ENUM_END = 21 // 

// MAV_TYPE
mavlink20.MAV_TYPE_GENERIC = 0 // Generic micro air vehicle
mavlink20.MAV_TYPE_FIXED_WING = 1 // Fixed wing aircraft.
mavlink20.MAV_TYPE_QUADROTOR = 2 // Quadrotor
mavlink20.MAV_TYPE_COAXIAL = 3 // Coaxial helicopter
mavlink20.MAV_TYPE_HELICOPTER = 4 // Normal helicopter with tail rotor.
mavlink20.MAV_TYPE_ANTENNA_TRACKER = 5 // Ground installation
mavlink20.MAV_TYPE_GCS = 6 // Operator control unit / ground control station
mavlink20.MAV_TYPE_AIRSHIP = 7 // Airship, controlled
mavlink20.MAV_TYPE_FREE_BALLOON = 8 // Free balloon, uncontrolled
mavlink20.MAV_TYPE_ROCKET = 9 // Rocket
mavlink20.MAV_TYPE_GROUND_ROVER = 10 // Ground rover
mavlink20.MAV_TYPE_SURFACE_BOAT = 11 // Surface vessel, boat, ship
mavlink20.MAV_TYPE_SUBMARINE = 12 // Submarine
mavlink20.MAV_TYPE_HEXAROTOR = 13 // Hexarotor
mavlink20.MAV_TYPE_OCTOROTOR = 14 // Octorotor
mavlink20.MAV_TYPE_TRICOPTER = 15 // Tricopter
mavlink20.MAV_TYPE_FLAPPING_WING = 16 // Flapping wing
mavlink20.MAV_TYPE_KITE = 17 // Kite
mavlink20.MAV_TYPE_ONBOARD_CONTROLLER = 18 // Onboard companion controller
mavlink20.MAV_TYPE_VTOL_TAILSITTER_DUOROTOR = 19 // Two-rotor Tailsitter VTOL that additionally uses control surfaces in
                        // vertical operation. Note, value previously
                        // named MAV_TYPE_VTOL_DUOROTOR.
mavlink20.MAV_TYPE_VTOL_TAILSITTER_QUADROTOR = 20 // Quad-rotor Tailsitter VTOL using a V-shaped quad config in vertical
                        // operation. Note: value previously named
                        // MAV_TYPE_VTOL_QUADROTOR.
mavlink20.MAV_TYPE_VTOL_TILTROTOR = 21 // Tiltrotor VTOL. Fuselage and wings stay (nominally) horizontal in all
                        // flight phases. It able to tilt (some)
                        // rotors to provide thrust in cruise flight.
mavlink20.MAV_TYPE_VTOL_FIXEDROTOR = 22 // VTOL with separate fixed rotors for hover and cruise flight. Fuselage
                        // and wings stay (nominally) horizontal in
                        // all flight phases.
mavlink20.MAV_TYPE_VTOL_TAILSITTER = 23 // Tailsitter VTOL. Fuselage and wings orientation changes depending on
                        // flight phase: vertical for hover,
                        // horizontal for cruise. Use more specific
                        // VTOL MAV_TYPE_VTOL_TAILSITTER_DUOROTOR or
                        // MAV_TYPE_VTOL_TAILSITTER_QUADROTOR if
                        // appropriate.
mavlink20.MAV_TYPE_VTOL_TILTWING = 24 // Tiltwing VTOL. Fuselage stays horizontal in all flight phases. The
                        // whole wing, along with any attached engine,
                        // can tilt between vertical and horizontal
                        // mode.
mavlink20.MAV_TYPE_VTOL_RESERVED5 = 25 // VTOL reserved 5
mavlink20.MAV_TYPE_GIMBAL = 26 // Gimbal
mavlink20.MAV_TYPE_ADSB = 27 // ADSB system
mavlink20.MAV_TYPE_PARAFOIL = 28 // Steerable, nonrigid airfoil
mavlink20.MAV_TYPE_DODECAROTOR = 29 // Dodecarotor
mavlink20.MAV_TYPE_CAMERA = 30 // Camera
mavlink20.MAV_TYPE_CHARGING_STATION = 31 // Charging station
mavlink20.MAV_TYPE_FLARM = 32 // FLARM collision avoidance system
mavlink20.MAV_TYPE_SERVO = 33 // Servo
mavlink20.MAV_TYPE_ODID = 34 // Open Drone ID. See https://mavlink.io/en/services/opendroneid.html.
mavlink20.MAV_TYPE_DECAROTOR = 35 // Decarotor
mavlink20.MAV_TYPE_BATTERY = 36 // Battery
mavlink20.MAV_TYPE_PARACHUTE = 37 // Parachute
mavlink20.MAV_TYPE_LOG = 38 // Log
mavlink20.MAV_TYPE_OSD = 39 // OSD
mavlink20.MAV_TYPE_IMU = 40 // IMU
mavlink20.MAV_TYPE_GPS = 41 // GPS
mavlink20.MAV_TYPE_WINCH = 42 // Winch
mavlink20.MAV_TYPE_GENERIC_MULTIROTOR = 43 // Generic multirotor that does not fit into a specific type or whose
                        // type is unknown
mavlink20.MAV_TYPE_ILLUMINATOR = 44 // Illuminator. An illuminator is a light source that is used for
                        // lighting up dark areas external to the
                        // sytstem: e.g. a torch or searchlight (as
                        // opposed to a light source for illuminating
                        // the system itself, e.g. an indicator
                        // light).
mavlink20.MAV_TYPE_ENUM_END = 45 // 

// MAV_MODE_FLAG
mavlink20.MAV_MODE_FLAG_CUSTOM_MODE_ENABLED = 1 // 0b00000001 Reserved for future use.
mavlink20.MAV_MODE_FLAG_TEST_ENABLED = 2 // 0b00000010 system has a test mode enabled. This flag is intended for
                        // temporary system tests and should not be
                        // used for stable implementations.
mavlink20.MAV_MODE_FLAG_AUTO_ENABLED = 4 // 0b00000100 autonomous mode enabled, system finds its own goal
                        // positions. Guided flag can be set or not,
                        // depends on the actual implementation.
mavlink20.MAV_MODE_FLAG_GUIDED_ENABLED = 8 // 0b00001000 guided mode enabled, system flies waypoints / mission
                        // items.
mavlink20.MAV_MODE_FLAG_STABILIZE_ENABLED = 16 // 0b00010000 system stabilizes electronically its attitude (and
                        // optionally position). It needs however
                        // further control inputs to move around.
mavlink20.MAV_MODE_FLAG_HIL_ENABLED = 32 // 0b00100000 hardware in the loop simulation. All motors / actuators are
                        // blocked, but internal software is full
                        // operational.
mavlink20.MAV_MODE_FLAG_MANUAL_INPUT_ENABLED = 64 // 0b01000000 remote control input is enabled.
mavlink20.MAV_MODE_FLAG_SAFETY_ARMED = 128 // 0b10000000 MAV safety set to armed. Motors are enabled / running / can
                        // start. Ready to fly. Additional note: this
                        // flag is to be ignore when sent in the
                        // command MAV_CMD_DO_SET_MODE and
                        // MAV_CMD_COMPONENT_ARM_DISARM shall be used
                        // instead. The flag can still be used to
                        // report the armed state.
mavlink20.MAV_MODE_FLAG_ENUM_END = 129 // 

// MAV_MODE_FLAG_DECODE_POSITION
mavlink20.MAV_MODE_FLAG_DECODE_POSITION_CUSTOM_MODE = 1 // Eighth bit: 00000001
mavlink20.MAV_MODE_FLAG_DECODE_POSITION_TEST = 2 // Seventh bit: 00000010
mavlink20.MAV_MODE_FLAG_DECODE_POSITION_AUTO = 4 // Sixth bit:   00000100
mavlink20.MAV_MODE_FLAG_DECODE_POSITION_GUIDED = 8 // Fifth bit:  00001000
mavlink20.MAV_MODE_FLAG_DECODE_POSITION_STABILIZE = 16 // Fourth bit: 00010000
mavlink20.MAV_MODE_FLAG_DECODE_POSITION_HIL = 32 // Third bit:  00100000
mavlink20.MAV_MODE_FLAG_DECODE_POSITION_MANUAL = 64 // Second bit: 01000000
mavlink20.MAV_MODE_FLAG_DECODE_POSITION_SAFETY = 128 // First bit:  10000000
mavlink20.MAV_MODE_FLAG_DECODE_POSITION_ENUM_END = 129 // 

// MAV_STATE
mavlink20.MAV_STATE_UNINIT = 0 // Uninitialized system, state is unknown.
mavlink20.MAV_STATE_BOOT = 1 // System is booting up.
mavlink20.MAV_STATE_CALIBRATING = 2 // System is calibrating and not flight-ready.
mavlink20.MAV_STATE_STANDBY = 3 // System is grounded and on standby. It can be launched any time.
mavlink20.MAV_STATE_ACTIVE = 4 // System is active and might be already airborne. Motors are engaged.
mavlink20.MAV_STATE_CRITICAL = 5 // System is in a non-normal flight mode (failsafe). It can however still
                        // navigate.
mavlink20.MAV_STATE_EMERGENCY = 6 // System is in a non-normal flight mode (failsafe). It lost control over
                        // parts or over the whole airframe. It is in
                        // mayday and going down.
mavlink20.MAV_STATE_POWEROFF = 7 // System just initialized its power-down sequence, will shut down now.
mavlink20.MAV_STATE_FLIGHT_TERMINATION = 8 // System is terminating itself (failsafe or commanded).
mavlink20.MAV_STATE_ENUM_END = 9 // 

// MAV_COMPONENT
mavlink20.MAV_COMP_ID_ALL = 0 // Target id (target_component) used to broadcast messages to all
                        // components of the receiving system.
                        // Components should attempt to process
                        // messages with this component ID and forward
                        // to components on any other interfaces.
                        // Note: This is not a valid *source*
                        // component id for a message.
mavlink20.MAV_COMP_ID_AUTOPILOT1 = 1 // System flight controller component ("autopilot"). Only one autopilot
                        // is expected in a particular system.
mavlink20.MAV_COMP_ID_USER1 = 25 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER2 = 26 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER3 = 27 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER4 = 28 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER5 = 29 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER6 = 30 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER7 = 31 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER8 = 32 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER9 = 33 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER10 = 34 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER11 = 35 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER12 = 36 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER13 = 37 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER14 = 38 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER15 = 39 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER16 = 40 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER17 = 41 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER18 = 42 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER19 = 43 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER20 = 44 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER21 = 45 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER22 = 46 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER23 = 47 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER24 = 48 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER25 = 49 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER26 = 50 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER27 = 51 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER28 = 52 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER29 = 53 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER30 = 54 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER31 = 55 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER32 = 56 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER33 = 57 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER34 = 58 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER35 = 59 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER36 = 60 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER37 = 61 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER38 = 62 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER39 = 63 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER40 = 64 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER41 = 65 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER42 = 66 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER43 = 67 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_TELEMETRY_RADIO = 68 // Telemetry radio (e.g. SiK radio, or other component that emits
                        // RADIO_STATUS messages).
mavlink20.MAV_COMP_ID_USER45 = 69 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER46 = 70 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER47 = 71 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER48 = 72 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER49 = 73 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER50 = 74 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER51 = 75 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER52 = 76 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER53 = 77 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER54 = 78 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER55 = 79 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER56 = 80 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER57 = 81 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER58 = 82 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER59 = 83 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER60 = 84 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER61 = 85 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER62 = 86 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER63 = 87 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER64 = 88 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER65 = 89 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER66 = 90 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER67 = 91 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER68 = 92 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER69 = 93 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER70 = 94 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER71 = 95 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER72 = 96 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER73 = 97 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER74 = 98 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_USER75 = 99 // Id for a component on privately managed MAVLink network. Can be used
                        // for any purpose but may not be published by
                        // components outside of the private network.
mavlink20.MAV_COMP_ID_CAMERA = 100 // Camera #1.
mavlink20.MAV_COMP_ID_CAMERA2 = 101 // Camera #2.
mavlink20.MAV_COMP_ID_CAMERA3 = 102 // Camera #3.
mavlink20.MAV_COMP_ID_CAMERA4 = 103 // Camera #4.
mavlink20.MAV_COMP_ID_CAMERA5 = 104 // Camera #5.
mavlink20.MAV_COMP_ID_CAMERA6 = 105 // Camera #6.
mavlink20.MAV_COMP_ID_SERVO1 = 140 // Servo #1.
mavlink20.MAV_COMP_ID_SERVO2 = 141 // Servo #2.
mavlink20.MAV_COMP_ID_SERVO3 = 142 // Servo #3.
mavlink20.MAV_COMP_ID_SERVO4 = 143 // Servo #4.
mavlink20.MAV_COMP_ID_SERVO5 = 144 // Servo #5.
mavlink20.MAV_COMP_ID_SERVO6 = 145 // Servo #6.
mavlink20.MAV_COMP_ID_SERVO7 = 146 // Servo #7.
mavlink20.MAV_COMP_ID_SERVO8 = 147 // Servo #8.
mavlink20.MAV_COMP_ID_SERVO9 = 148 // Servo #9.
mavlink20.MAV_COMP_ID_SERVO10 = 149 // Servo #10.
mavlink20.MAV_COMP_ID_SERVO11 = 150 // Servo #11.
mavlink20.MAV_COMP_ID_SERVO12 = 151 // Servo #12.
mavlink20.MAV_COMP_ID_SERVO13 = 152 // Servo #13.
mavlink20.MAV_COMP_ID_SERVO14 = 153 // Servo #14.
mavlink20.MAV_COMP_ID_GIMBAL = 154 // Gimbal #1.
mavlink20.MAV_COMP_ID_LOG = 155 // Logging component.
mavlink20.MAV_COMP_ID_ADSB = 156 // Automatic Dependent Surveillance-Broadcast (ADS-B) component.
mavlink20.MAV_COMP_ID_OSD = 157 // On Screen Display (OSD) devices for video links.
mavlink20.MAV_COMP_ID_PERIPHERAL = 158 // Generic autopilot peripheral component ID. Meant for devices that do
                        // not implement the parameter microservice.
mavlink20.MAV_COMP_ID_QX1_GIMBAL = 159 // Gimbal ID for QX1.
mavlink20.MAV_COMP_ID_FLARM = 160 // FLARM collision alert component.
mavlink20.MAV_COMP_ID_PARACHUTE = 161 // Parachute component.
mavlink20.MAV_COMP_ID_WINCH = 169 // Winch component.
mavlink20.MAV_COMP_ID_GIMBAL2 = 171 // Gimbal #2.
mavlink20.MAV_COMP_ID_GIMBAL3 = 172 // Gimbal #3.
mavlink20.MAV_COMP_ID_GIMBAL4 = 173 // Gimbal #4
mavlink20.MAV_COMP_ID_GIMBAL5 = 174 // Gimbal #5.
mavlink20.MAV_COMP_ID_GIMBAL6 = 175 // Gimbal #6.
mavlink20.MAV_COMP_ID_BATTERY = 180 // Battery #1.
mavlink20.MAV_COMP_ID_BATTERY2 = 181 // Battery #2.
mavlink20.MAV_COMP_ID_MAVCAN = 189 // CAN over MAVLink client.
mavlink20.MAV_COMP_ID_MISSIONPLANNER = 190 // Component that can generate/supply a mission flight plan (e.g. GCS or
                        // developer API).
mavlink20.MAV_COMP_ID_ONBOARD_COMPUTER = 191 // Component that lives on the onboard computer (companion computer) and
                        // has some generic functionalities, such as
                        // settings system parameters and monitoring
                        // the status of some processes that don't
                        // directly speak mavlink and so on.
mavlink20.MAV_COMP_ID_ONBOARD_COMPUTER2 = 192 // Component that lives on the onboard computer (companion computer) and
                        // has some generic functionalities, such as
                        // settings system parameters and monitoring
                        // the status of some processes that don't
                        // directly speak mavlink and so on.
mavlink20.MAV_COMP_ID_ONBOARD_COMPUTER3 = 193 // Component that lives on the onboard computer (companion computer) and
                        // has some generic functionalities, such as
                        // settings system parameters and monitoring
                        // the status of some processes that don't
                        // directly speak mavlink and so on.
mavlink20.MAV_COMP_ID_ONBOARD_COMPUTER4 = 194 // Component that lives on the onboard computer (companion computer) and
                        // has some generic functionalities, such as
                        // settings system parameters and monitoring
                        // the status of some processes that don't
                        // directly speak mavlink and so on.
mavlink20.MAV_COMP_ID_PATHPLANNER = 195 // Component that finds an optimal path between points based on a certain
                        // constraint (e.g. minimum snap, shortest
                        // path, cost, etc.).
mavlink20.MAV_COMP_ID_OBSTACLE_AVOIDANCE = 196 // Component that plans a collision free path between two points.
mavlink20.MAV_COMP_ID_VISUAL_INERTIAL_ODOMETRY = 197 // Component that provides position estimates using VIO techniques.
mavlink20.MAV_COMP_ID_PAIRING_MANAGER = 198 // Component that manages pairing of vehicle and GCS.
mavlink20.MAV_COMP_ID_IMU = 200 // Inertial Measurement Unit (IMU) #1.
mavlink20.MAV_COMP_ID_IMU_2 = 201 // Inertial Measurement Unit (IMU) #2.
mavlink20.MAV_COMP_ID_IMU_3 = 202 // Inertial Measurement Unit (IMU) #3.
mavlink20.MAV_COMP_ID_GPS = 220 // GPS #1.
mavlink20.MAV_COMP_ID_GPS2 = 221 // GPS #2.
mavlink20.MAV_COMP_ID_ODID_TXRX_1 = 236 // Open Drone ID transmitter/receiver (Bluetooth/WiFi/Internet).
mavlink20.MAV_COMP_ID_ODID_TXRX_2 = 237 // Open Drone ID transmitter/receiver (Bluetooth/WiFi/Internet).
mavlink20.MAV_COMP_ID_ODID_TXRX_3 = 238 // Open Drone ID transmitter/receiver (Bluetooth/WiFi/Internet).
mavlink20.MAV_COMP_ID_UDP_BRIDGE = 240 // Component to bridge MAVLink to UDP (i.e. from a UART).
mavlink20.MAV_COMP_ID_UART_BRIDGE = 241 // Component to bridge to UART (i.e. from UDP).
mavlink20.MAV_COMP_ID_TUNNEL_NODE = 242 // Component handling TUNNEL messages (e.g. vendor specific GUI of a
                        // component).
mavlink20.MAV_COMP_ID_ILLUMINATOR = 243 // Illuminator
mavlink20.MAV_COMP_ID_SYSTEM_CONTROL = 250 // Deprecated, don't use. Component for handling system messages (e.g. to
                        // ARM, takeoff, etc.).
mavlink20.MAV_COMPONENT_ENUM_END = 251 // 

// UALBERTA_AUTOPILOT_MODE
mavlink20.MODE_MANUAL_DIRECT = 1 // Raw input pulse widts sent to output
mavlink20.MODE_MANUAL_SCALED = 2 // Inputs are normalized using calibration, the converted back to raw
                        // pulse widths for output
mavlink20.MODE_AUTO_PID_ATT = 3 // 
mavlink20.MODE_AUTO_PID_VEL = 4 // 
mavlink20.MODE_AUTO_PID_POS = 5 // 
mavlink20.UALBERTA_AUTOPILOT_MODE_ENUM_END = 6 // 

// UALBERTA_NAV_MODE
mavlink20.NAV_AHRS_INIT = 1 // 
mavlink20.NAV_AHRS = 2 // AHRS mode
mavlink20.NAV_INS_GPS_INIT = 3 // INS/GPS initialization mode
mavlink20.NAV_INS_GPS = 4 // INS/GPS mode
mavlink20.UALBERTA_NAV_MODE_ENUM_END = 5 // 

// UALBERTA_PILOT_MODE
mavlink20.PILOT_MANUAL = 1 // 
mavlink20.PILOT_AUTO = 2 // 
mavlink20.PILOT_ROTO = 3 //  Rotomotion mode
mavlink20.UALBERTA_PILOT_MODE_ENUM_END = 4 // 

// UAVIONIX_ADSB_OUT_DYNAMIC_STATE
mavlink20.UAVIONIX_ADSB_OUT_DYNAMIC_STATE_INTENT_CHANGE = 1 // 
mavlink20.UAVIONIX_ADSB_OUT_DYNAMIC_STATE_AUTOPILOT_ENABLED = 2 // 
mavlink20.UAVIONIX_ADSB_OUT_DYNAMIC_STATE_NICBARO_CROSSCHECKED = 4 // 
mavlink20.UAVIONIX_ADSB_OUT_DYNAMIC_STATE_ON_GROUND = 8 // 
mavlink20.UAVIONIX_ADSB_OUT_DYNAMIC_STATE_IDENT = 16 // 
mavlink20.UAVIONIX_ADSB_OUT_DYNAMIC_STATE_ENUM_END = 17 // 

// UAVIONIX_ADSB_OUT_RF_SELECT
mavlink20.UAVIONIX_ADSB_OUT_RF_SELECT_STANDBY = 0 // 
mavlink20.UAVIONIX_ADSB_OUT_RF_SELECT_RX_ENABLED = 1 // 
mavlink20.UAVIONIX_ADSB_OUT_RF_SELECT_TX_ENABLED = 2 // 
mavlink20.UAVIONIX_ADSB_OUT_RF_SELECT_ENUM_END = 3 // 

// UAVIONIX_ADSB_OUT_DYNAMIC_GPS_FIX
mavlink20.UAVIONIX_ADSB_OUT_DYNAMIC_GPS_FIX_NONE_0 = 0 // 
mavlink20.UAVIONIX_ADSB_OUT_DYNAMIC_GPS_FIX_NONE_1 = 1 // 
mavlink20.UAVIONIX_ADSB_OUT_DYNAMIC_GPS_FIX_2D = 2 // 
mavlink20.UAVIONIX_ADSB_OUT_DYNAMIC_GPS_FIX_3D = 3 // 
mavlink20.UAVIONIX_ADSB_OUT_DYNAMIC_GPS_FIX_DGPS = 4 // 
mavlink20.UAVIONIX_ADSB_OUT_DYNAMIC_GPS_FIX_RTK = 5 // 
mavlink20.UAVIONIX_ADSB_OUT_DYNAMIC_GPS_FIX_ENUM_END = 6 // 

// UAVIONIX_ADSB_RF_HEALTH
mavlink20.UAVIONIX_ADSB_RF_HEALTH_INITIALIZING = 0 // 
mavlink20.UAVIONIX_ADSB_RF_HEALTH_OK = 1 // 
mavlink20.UAVIONIX_ADSB_RF_HEALTH_FAIL_TX = 2 // 
mavlink20.UAVIONIX_ADSB_RF_HEALTH_FAIL_RX = 16 // 
mavlink20.UAVIONIX_ADSB_RF_HEALTH_ENUM_END = 17 // 

// UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE
mavlink20.UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_NO_DATA = 0 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L15M_W23M = 1 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L25M_W28P5M = 2 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L25_34M = 3 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L35_33M = 4 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L35_38M = 5 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L45_39P5M = 6 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L45_45M = 7 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L55_45M = 8 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L55_52M = 9 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L65_59P5M = 10 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L65_67M = 11 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L75_W72P5M = 12 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L75_W80M = 13 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L85_W80M = 14 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L85_W90M = 15 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_ENUM_END = 16 // 

// UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT
mavlink20.UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT_NO_DATA = 0 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT_LEFT_2M = 1 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT_LEFT_4M = 2 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT_LEFT_6M = 3 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT_RIGHT_0M = 4 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT_RIGHT_2M = 5 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT_RIGHT_4M = 6 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT_RIGHT_6M = 7 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT_ENUM_END = 8 // 

// UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LON
mavlink20.UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LON_NO_DATA = 0 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LON_APPLIED_BY_SENSOR = 1 // 
mavlink20.UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LON_ENUM_END = 2 // 

// UAVIONIX_ADSB_EMERGENCY_STATUS
mavlink20.UAVIONIX_ADSB_OUT_NO_EMERGENCY = 0 // 
mavlink20.UAVIONIX_ADSB_OUT_GENERAL_EMERGENCY = 1 // 
mavlink20.UAVIONIX_ADSB_OUT_LIFEGUARD_EMERGENCY = 2 // 
mavlink20.UAVIONIX_ADSB_OUT_MINIMUM_FUEL_EMERGENCY = 3 // 
mavlink20.UAVIONIX_ADSB_OUT_NO_COMM_EMERGENCY = 4 // 
mavlink20.UAVIONIX_ADSB_OUT_UNLAWFUL_INTERFERANCE_EMERGENCY = 5 // 
mavlink20.UAVIONIX_ADSB_OUT_DOWNED_AIRCRAFT_EMERGENCY = 6 // 
mavlink20.UAVIONIX_ADSB_OUT_RESERVED = 7 // 
mavlink20.UAVIONIX_ADSB_EMERGENCY_STATUS_ENUM_END = 8 // 

// MAV_STORM32_TUNNEL_PAYLOAD_TYPE
mavlink20.MAV_STORM32_TUNNEL_PAYLOAD_TYPE_STORM32_CH1_IN = 200 // Registered for STorM32 gimbal controller. For communication with
                        // gimbal or camera.
mavlink20.MAV_STORM32_TUNNEL_PAYLOAD_TYPE_STORM32_CH1_OUT = 201 // Registered for STorM32 gimbal controller. For communication with
                        // gimbal or camera.
mavlink20.MAV_STORM32_TUNNEL_PAYLOAD_TYPE_STORM32_CH2_IN = 202 // Registered for STorM32 gimbal controller. For communication with
                        // gimbal.
mavlink20.MAV_STORM32_TUNNEL_PAYLOAD_TYPE_STORM32_CH2_OUT = 203 // Registered for STorM32 gimbal controller. For communication with
                        // gimbal.
mavlink20.MAV_STORM32_TUNNEL_PAYLOAD_TYPE_STORM32_CH3_IN = 204 // Registered for STorM32 gimbal controller. For communication with
                        // camera.
mavlink20.MAV_STORM32_TUNNEL_PAYLOAD_TYPE_STORM32_CH3_OUT = 205 // Registered for STorM32 gimbal controller. For communication with
                        // camera.
mavlink20.MAV_STORM32_TUNNEL_PAYLOAD_TYPE_ENUM_END = 206 // 

// MAV_STORM32_GIMBAL_PREARM_FLAGS
mavlink20.MAV_STORM32_GIMBAL_PREARM_FLAGS_IS_NORMAL = 1 // STorM32 gimbal is in normal state.
mavlink20.MAV_STORM32_GIMBAL_PREARM_FLAGS_IMUS_WORKING = 2 // The IMUs are healthy and working normally.
mavlink20.MAV_STORM32_GIMBAL_PREARM_FLAGS_MOTORS_WORKING = 4 // The motors are active and working normally.
mavlink20.MAV_STORM32_GIMBAL_PREARM_FLAGS_ENCODERS_WORKING = 8 // The encoders are healthy and working normally.
mavlink20.MAV_STORM32_GIMBAL_PREARM_FLAGS_VOLTAGE_OK = 16 // A battery voltage is applied and is in range.
mavlink20.MAV_STORM32_GIMBAL_PREARM_FLAGS_VIRTUALCHANNELS_RECEIVING = 32 // Virtual input channels are receiving data.
mavlink20.MAV_STORM32_GIMBAL_PREARM_FLAGS_MAVLINK_RECEIVING = 64 // Mavlink messages are being received.
mavlink20.MAV_STORM32_GIMBAL_PREARM_FLAGS_STORM32LINK_QFIX = 128 // The STorM32Link data indicates QFix.
mavlink20.MAV_STORM32_GIMBAL_PREARM_FLAGS_STORM32LINK_WORKING = 256 // The STorM32Link is working.
mavlink20.MAV_STORM32_GIMBAL_PREARM_FLAGS_CAMERA_CONNECTED = 512 // The camera has been found and is connected.
mavlink20.MAV_STORM32_GIMBAL_PREARM_FLAGS_AUX0_LOW = 1024 // The signal on the AUX0 input pin is low.
mavlink20.MAV_STORM32_GIMBAL_PREARM_FLAGS_AUX1_LOW = 2048 // The signal on the AUX1 input pin is low.
mavlink20.MAV_STORM32_GIMBAL_PREARM_FLAGS_NTLOGGER_WORKING = 4096 // The NTLogger is working normally.
mavlink20.MAV_STORM32_GIMBAL_PREARM_FLAGS_ENUM_END = 4097 // 

// MAV_STORM32_CAMERA_PREARM_FLAGS
mavlink20.MAV_STORM32_CAMERA_PREARM_FLAGS_CONNECTED = 1 // The camera has been found and is connected.
mavlink20.MAV_STORM32_CAMERA_PREARM_FLAGS_ENUM_END = 2 // 

// MAV_STORM32_GIMBAL_MANAGER_CAP_FLAGS
mavlink20.MAV_STORM32_GIMBAL_MANAGER_CAP_FLAGS_HAS_PROFILES = 1 // The gimbal manager supports several profiles.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_CAP_FLAGS_ENUM_END = 2 // 

// MAV_STORM32_GIMBAL_MANAGER_FLAGS
mavlink20.MAV_STORM32_GIMBAL_MANAGER_FLAGS_NONE = 0 // 0 = ignore.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_FLAGS_RC_ACTIVE = 1 // Request to set RC input to active, or report RC input is active.
                        // Implies RC mixed. RC exclusive is achieved
                        // by setting all clients to inactive.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_FLAGS_CLIENT_ONBOARD_ACTIVE = 2 // Request to set onboard/companion computer client to active, or report
                        // this client is active.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_FLAGS_CLIENT_AUTOPILOT_ACTIVE = 4 // Request to set autopliot client to active, or report this client is
                        // active.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_FLAGS_CLIENT_GCS_ACTIVE = 8 // Request to set GCS client to active, or report this client is active.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_FLAGS_CLIENT_CAMERA_ACTIVE = 16 // Request to set camera client to active, or report this client is
                        // active.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_FLAGS_CLIENT_GCS2_ACTIVE = 32 // Request to set GCS2 client to active, or report this client is active.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_FLAGS_CLIENT_CAMERA2_ACTIVE = 64 // Request to set camera2 client to active, or report this client is
                        // active.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_FLAGS_CLIENT_CUSTOM_ACTIVE = 128 // Request to set custom client to active, or report this client is
                        // active.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_FLAGS_CLIENT_CUSTOM2_ACTIVE = 256 // Request to set custom2 client to active, or report this client is
                        // active.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_FLAGS_SET_SUPERVISON = 512 // Request supervision. This flag is only for setting, it is not
                        // reported.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_FLAGS_SET_RELEASE = 1024 // Release supervision. This flag is only for setting, it is not
                        // reported.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_FLAGS_ENUM_END = 1025 // 

// MAV_STORM32_GIMBAL_MANAGER_CLIENT
mavlink20.MAV_STORM32_GIMBAL_MANAGER_CLIENT_NONE = 0 // For convenience.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_CLIENT_ONBOARD = 1 // This is the onboard/companion computer client.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_CLIENT_AUTOPILOT = 2 // This is the autopilot client.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_CLIENT_GCS = 3 // This is the GCS client.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_CLIENT_CAMERA = 4 // This is the camera client.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_CLIENT_GCS2 = 5 // This is the GCS2 client.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_CLIENT_CAMERA2 = 6 // This is the camera2 client.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_CLIENT_CUSTOM = 7 // This is the custom client.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_CLIENT_CUSTOM2 = 8 // This is the custom2 client.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_CLIENT_ENUM_END = 9 // 

// MAV_STORM32_GIMBAL_MANAGER_PROFILE
mavlink20.MAV_STORM32_GIMBAL_MANAGER_PROFILE_DEFAULT = 0 // Default profile. Implementation specific.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_PROFILE_CUSTOM = 1 // Not supported/deprecated.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_PROFILE_COOPERATIVE = 2 // Profile with cooperative behavior.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_PROFILE_EXCLUSIVE = 3 // Profile with exclusive behavior.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_PROFILE_PRIORITY_COOPERATIVE = 4 // Profile with priority and cooperative behavior for equal priority.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_PROFILE_PRIORITY_EXCLUSIVE = 5 // Profile with priority and exclusive behavior for equal priority.
mavlink20.MAV_STORM32_GIMBAL_MANAGER_PROFILE_ENUM_END = 6 // 

// MAV_QSHOT_MODE
mavlink20.MAV_QSHOT_MODE_UNDEFINED = 0 // Undefined shot mode. Can be used to determine if qshots should be used
                        // or not.
mavlink20.MAV_QSHOT_MODE_DEFAULT = 1 // Start normal gimbal operation. Is usually used to return back from a
                        // shot.
mavlink20.MAV_QSHOT_MODE_GIMBAL_RETRACT = 2 // Load and keep safe gimbal position and stop stabilization.
mavlink20.MAV_QSHOT_MODE_GIMBAL_NEUTRAL = 3 // Load neutral gimbal position and keep it while stabilizing.
mavlink20.MAV_QSHOT_MODE_GIMBAL_MISSION = 4 // Start mission with gimbal control.
mavlink20.MAV_QSHOT_MODE_GIMBAL_RC_CONTROL = 5 // Start RC gimbal control.
mavlink20.MAV_QSHOT_MODE_POI_TARGETING = 6 // Start gimbal tracking the point specified by Lat, Lon, Alt.
mavlink20.MAV_QSHOT_MODE_SYSID_TARGETING = 7 // Start gimbal tracking the system with specified system ID.
mavlink20.MAV_QSHOT_MODE_CABLECAM_2POINT = 8 // Start 2-point cable cam quick shot.
mavlink20.MAV_QSHOT_MODE_HOME_TARGETING = 9 // Start gimbal tracking the home location.
mavlink20.MAV_QSHOT_MODE_ENUM_END = 10 // 

// MAV_AVSS_COMMAND_FAILURE_REASON
mavlink20.PRS_NOT_STEADY = 1 // AVSS defined command failure reason. PRS not steady.
mavlink20.PRS_DTM_NOT_ARMED = 2 // AVSS defined command failure reason. PRS DTM not armed.
mavlink20.PRS_OTM_NOT_ARMED = 3 // AVSS defined command failure reason. PRS OTM not armed.
mavlink20.MAV_AVSS_COMMAND_FAILURE_REASON_ENUM_END = 4 // 

// AVSS_M300_OPERATION_MODE
mavlink20.MODE_M300_MANUAL_CTRL = 0 // In manual control mode
mavlink20.MODE_M300_ATTITUDE = 1 // In attitude mode
mavlink20.MODE_M300_P_GPS = 6 // In GPS mode
mavlink20.MODE_M300_HOTPOINT_MODE = 9 // In hotpoint mode
mavlink20.MODE_M300_ASSISTED_TAKEOFF = 10 // In assisted takeoff mode
mavlink20.MODE_M300_AUTO_TAKEOFF = 11 // In auto takeoff mode
mavlink20.MODE_M300_AUTO_LANDING = 12 // In auto landing mode
mavlink20.MODE_M300_NAVI_GO_HOME = 15 // In go home mode
mavlink20.MODE_M300_NAVI_SDK_CTRL = 17 // In sdk control mode
mavlink20.MODE_M300_S_SPORT = 31 // In sport mode
mavlink20.MODE_M300_FORCE_AUTO_LANDING = 33 // In force auto landing mode
mavlink20.MODE_M300_T_TRIPOD = 38 // In tripod mode
mavlink20.MODE_M300_SEARCH_MODE = 40 // In search mode
mavlink20.MODE_M300_ENGINE_START = 41 // In engine mode
mavlink20.AVSS_M300_OPERATION_MODE_ENUM_END = 42 // 

// AVSS_HORSEFLY_OPERATION_MODE
mavlink20.MODE_HORSEFLY_MANUAL_CTRL = 0 // In manual control mode
mavlink20.MODE_HORSEFLY_AUTO_TAKEOFF = 1 // In auto takeoff mode
mavlink20.MODE_HORSEFLY_AUTO_LANDING = 2 // In auto landing mode
mavlink20.MODE_HORSEFLY_NAVI_GO_HOME = 3 // In go home mode
mavlink20.MODE_HORSEFLY_DROP = 4 // In drop mode
mavlink20.AVSS_HORSEFLY_OPERATION_MODE_ENUM_END = 5 // 

// AIRLINK_AUTH_RESPONSE_TYPE
mavlink20.AIRLINK_ERROR_LOGIN_OR_PASS = 0 // Login or password error
mavlink20.AIRLINK_AUTH_OK = 1 // Auth successful
mavlink20.AIRLINK_AUTH_RESPONSE_TYPE_ENUM_END = 2 // 

// AIRLINK_EYE_GS_HOLE_PUSH_RESP_TYPE
mavlink20.AIRLINK_HPR_PARTNER_NOT_READY = 0 // 
mavlink20.AIRLINK_HPR_PARTNER_READY = 1 // 
mavlink20.AIRLINK_EYE_GS_HOLE_PUSH_RESP_TYPE_ENUM_END = 2 // 

// AIRLINK_EYE_IP_VERSION
mavlink20.AIRLINK_IP_V4 = 0 // 
mavlink20.AIRLINK_IP_V6 = 1 // 
mavlink20.AIRLINK_EYE_IP_VERSION_ENUM_END = 2 // 

// AIRLINK_EYE_HOLE_PUSH_TYPE
mavlink20.AIRLINK_HP_NOT_PENETRATED = 0 // 
mavlink20.AIRLINK_HP_BROKEN = 1 // 
mavlink20.AIRLINK_EYE_HOLE_PUSH_TYPE_ENUM_END = 2 // 

// AIRLINK_EYE_TURN_INIT_TYPE
mavlink20.AIRLINK_TURN_INIT_START = 0 // 
mavlink20.AIRLINK_TURN_INIT_OK = 1 // 
mavlink20.AIRLINK_TURN_INIT_BAD = 2 // 
mavlink20.AIRLINK_EYE_TURN_INIT_TYPE_ENUM_END = 3 // 

// message IDs
mavlink20.MAVLINK_MSG_ID_BAD_DATA = -1
mavlink20.MAVLINK_MSG_ID_SENSOR_OFFSETS = 150
mavlink20.MAVLINK_MSG_ID_SET_MAG_OFFSETS = 151
mavlink20.MAVLINK_MSG_ID_MEMINFO = 152
mavlink20.MAVLINK_MSG_ID_AP_ADC = 153
mavlink20.MAVLINK_MSG_ID_DIGICAM_CONFIGURE = 154
mavlink20.MAVLINK_MSG_ID_DIGICAM_CONTROL = 155
mavlink20.MAVLINK_MSG_ID_MOUNT_CONFIGURE = 156
mavlink20.MAVLINK_MSG_ID_MOUNT_CONTROL = 157
mavlink20.MAVLINK_MSG_ID_MOUNT_STATUS = 158
mavlink20.MAVLINK_MSG_ID_FENCE_POINT = 160
mavlink20.MAVLINK_MSG_ID_FENCE_FETCH_POINT = 161
mavlink20.MAVLINK_MSG_ID_AHRS = 163
mavlink20.MAVLINK_MSG_ID_SIMSTATE = 164
mavlink20.MAVLINK_MSG_ID_HWSTATUS = 165
mavlink20.MAVLINK_MSG_ID_RADIO = 166
mavlink20.MAVLINK_MSG_ID_LIMITS_STATUS = 167
mavlink20.MAVLINK_MSG_ID_WIND = 168
mavlink20.MAVLINK_MSG_ID_DATA16 = 169
mavlink20.MAVLINK_MSG_ID_DATA32 = 170
mavlink20.MAVLINK_MSG_ID_DATA64 = 171
mavlink20.MAVLINK_MSG_ID_DATA96 = 172
mavlink20.MAVLINK_MSG_ID_RANGEFINDER = 173
mavlink20.MAVLINK_MSG_ID_AIRSPEED_AUTOCAL = 174
mavlink20.MAVLINK_MSG_ID_RALLY_POINT = 175
mavlink20.MAVLINK_MSG_ID_RALLY_FETCH_POINT = 176
mavlink20.MAVLINK_MSG_ID_COMPASSMOT_STATUS = 177
mavlink20.MAVLINK_MSG_ID_AHRS2 = 178
mavlink20.MAVLINK_MSG_ID_CAMERA_STATUS = 179
mavlink20.MAVLINK_MSG_ID_CAMERA_FEEDBACK = 180
mavlink20.MAVLINK_MSG_ID_BATTERY2 = 181
mavlink20.MAVLINK_MSG_ID_AHRS3 = 182
mavlink20.MAVLINK_MSG_ID_AUTOPILOT_VERSION_REQUEST = 183
mavlink20.MAVLINK_MSG_ID_REMOTE_LOG_DATA_BLOCK = 184
mavlink20.MAVLINK_MSG_ID_REMOTE_LOG_BLOCK_STATUS = 185
mavlink20.MAVLINK_MSG_ID_LED_CONTROL = 186
mavlink20.MAVLINK_MSG_ID_MAG_CAL_PROGRESS = 191
mavlink20.MAVLINK_MSG_ID_EKF_STATUS_REPORT = 193
mavlink20.MAVLINK_MSG_ID_PID_TUNING = 194
mavlink20.MAVLINK_MSG_ID_DEEPSTALL = 195
mavlink20.MAVLINK_MSG_ID_GIMBAL_REPORT = 200
mavlink20.MAVLINK_MSG_ID_GIMBAL_CONTROL = 201
mavlink20.MAVLINK_MSG_ID_GIMBAL_TORQUE_CMD_REPORT = 214
mavlink20.MAVLINK_MSG_ID_GOPRO_HEARTBEAT = 215
mavlink20.MAVLINK_MSG_ID_GOPRO_GET_REQUEST = 216
mavlink20.MAVLINK_MSG_ID_GOPRO_GET_RESPONSE = 217
mavlink20.MAVLINK_MSG_ID_GOPRO_SET_REQUEST = 218
mavlink20.MAVLINK_MSG_ID_GOPRO_SET_RESPONSE = 219
mavlink20.MAVLINK_MSG_ID_RPM = 226
mavlink20.MAVLINK_MSG_ID_DEVICE_OP_READ = 11000
mavlink20.MAVLINK_MSG_ID_DEVICE_OP_READ_REPLY = 11001
mavlink20.MAVLINK_MSG_ID_DEVICE_OP_WRITE = 11002
mavlink20.MAVLINK_MSG_ID_DEVICE_OP_WRITE_REPLY = 11003
mavlink20.MAVLINK_MSG_ID_SECURE_COMMAND = 11004
mavlink20.MAVLINK_MSG_ID_SECURE_COMMAND_REPLY = 11005
mavlink20.MAVLINK_MSG_ID_ADAP_TUNING = 11010
mavlink20.MAVLINK_MSG_ID_VISION_POSITION_DELTA = 11011
mavlink20.MAVLINK_MSG_ID_AOA_SSA = 11020
mavlink20.MAVLINK_MSG_ID_ESC_TELEMETRY_1_TO_4 = 11030
mavlink20.MAVLINK_MSG_ID_ESC_TELEMETRY_5_TO_8 = 11031
mavlink20.MAVLINK_MSG_ID_ESC_TELEMETRY_9_TO_12 = 11032
mavlink20.MAVLINK_MSG_ID_OSD_PARAM_CONFIG = 11033
mavlink20.MAVLINK_MSG_ID_OSD_PARAM_CONFIG_REPLY = 11034
mavlink20.MAVLINK_MSG_ID_OSD_PARAM_SHOW_CONFIG = 11035
mavlink20.MAVLINK_MSG_ID_OSD_PARAM_SHOW_CONFIG_REPLY = 11036
mavlink20.MAVLINK_MSG_ID_OBSTACLE_DISTANCE_3D = 11037
mavlink20.MAVLINK_MSG_ID_WATER_DEPTH = 11038
mavlink20.MAVLINK_MSG_ID_MCU_STATUS = 11039
mavlink20.MAVLINK_MSG_ID_ESC_TELEMETRY_13_TO_16 = 11040
mavlink20.MAVLINK_MSG_ID_ESC_TELEMETRY_17_TO_20 = 11041
mavlink20.MAVLINK_MSG_ID_ESC_TELEMETRY_21_TO_24 = 11042
mavlink20.MAVLINK_MSG_ID_ESC_TELEMETRY_25_TO_28 = 11043
mavlink20.MAVLINK_MSG_ID_ESC_TELEMETRY_29_TO_32 = 11044
mavlink20.MAVLINK_MSG_ID_COMMAND_INT_STAMPED = 223
mavlink20.MAVLINK_MSG_ID_COMMAND_LONG_STAMPED = 224
mavlink20.MAVLINK_MSG_ID_SENS_POWER = 8002
mavlink20.MAVLINK_MSG_ID_SENS_MPPT = 8003
mavlink20.MAVLINK_MSG_ID_ASLCTRL_DATA = 8004
mavlink20.MAVLINK_MSG_ID_ASLCTRL_DEBUG = 8005
mavlink20.MAVLINK_MSG_ID_ASLUAV_STATUS = 8006
mavlink20.MAVLINK_MSG_ID_EKF_EXT = 8007
mavlink20.MAVLINK_MSG_ID_ASL_OBCTRL = 8008
mavlink20.MAVLINK_MSG_ID_SENS_ATMOS = 8009
mavlink20.MAVLINK_MSG_ID_SENS_BATMON = 8010
mavlink20.MAVLINK_MSG_ID_FW_SOARING_DATA = 8011
mavlink20.MAVLINK_MSG_ID_SENSORPOD_STATUS = 8012
mavlink20.MAVLINK_MSG_ID_SENS_POWER_BOARD = 8013
mavlink20.MAVLINK_MSG_ID_GSM_LINK_STATUS = 8014
mavlink20.MAVLINK_MSG_ID_SATCOM_LINK_STATUS = 8015
mavlink20.MAVLINK_MSG_ID_SENSOR_AIRFLOW_ANGLES = 8016
mavlink20.MAVLINK_MSG_ID_SYS_STATUS = 1
mavlink20.MAVLINK_MSG_ID_SYSTEM_TIME = 2
mavlink20.MAVLINK_MSG_ID_PING = 4
mavlink20.MAVLINK_MSG_ID_CHANGE_OPERATOR_CONTROL = 5
mavlink20.MAVLINK_MSG_ID_CHANGE_OPERATOR_CONTROL_ACK = 6
mavlink20.MAVLINK_MSG_ID_AUTH_KEY = 7
mavlink20.MAVLINK_MSG_ID_LINK_NODE_STATUS = 8
mavlink20.MAVLINK_MSG_ID_SET_MODE = 11
mavlink20.MAVLINK_MSG_ID_PARAM_REQUEST_READ = 20
mavlink20.MAVLINK_MSG_ID_PARAM_REQUEST_LIST = 21
mavlink20.MAVLINK_MSG_ID_PARAM_VALUE = 22
mavlink20.MAVLINK_MSG_ID_PARAM_SET = 23
mavlink20.MAVLINK_MSG_ID_GPS_RAW_INT = 24
mavlink20.MAVLINK_MSG_ID_GPS_STATUS = 25
mavlink20.MAVLINK_MSG_ID_SCALED_IMU = 26
mavlink20.MAVLINK_MSG_ID_RAW_IMU = 27
mavlink20.MAVLINK_MSG_ID_RAW_PRESSURE = 28
mavlink20.MAVLINK_MSG_ID_SCALED_PRESSURE = 29
mavlink20.MAVLINK_MSG_ID_ATTITUDE = 30
mavlink20.MAVLINK_MSG_ID_ATTITUDE_QUATERNION = 31
mavlink20.MAVLINK_MSG_ID_LOCAL_POSITION_NED = 32
mavlink20.MAVLINK_MSG_ID_GLOBAL_POSITION_INT = 33
mavlink20.MAVLINK_MSG_ID_RC_CHANNELS_SCALED = 34
mavlink20.MAVLINK_MSG_ID_RC_CHANNELS_RAW = 35
mavlink20.MAVLINK_MSG_ID_SERVO_OUTPUT_RAW = 36
mavlink20.MAVLINK_MSG_ID_MISSION_REQUEST_PARTIAL_LIST = 37
mavlink20.MAVLINK_MSG_ID_MISSION_WRITE_PARTIAL_LIST = 38
mavlink20.MAVLINK_MSG_ID_MISSION_ITEM = 39
mavlink20.MAVLINK_MSG_ID_MISSION_REQUEST = 40
mavlink20.MAVLINK_MSG_ID_MISSION_SET_CURRENT = 41
mavlink20.MAVLINK_MSG_ID_MISSION_CURRENT = 42
mavlink20.MAVLINK_MSG_ID_MISSION_REQUEST_LIST = 43
mavlink20.MAVLINK_MSG_ID_MISSION_COUNT = 44
mavlink20.MAVLINK_MSG_ID_MISSION_CLEAR_ALL = 45
mavlink20.MAVLINK_MSG_ID_MISSION_ITEM_REACHED = 46
mavlink20.MAVLINK_MSG_ID_MISSION_ACK = 47
mavlink20.MAVLINK_MSG_ID_SET_GPS_GLOBAL_ORIGIN = 48
mavlink20.MAVLINK_MSG_ID_GPS_GLOBAL_ORIGIN = 49
mavlink20.MAVLINK_MSG_ID_PARAM_MAP_RC = 50
mavlink20.MAVLINK_MSG_ID_MISSION_REQUEST_INT = 51
mavlink20.MAVLINK_MSG_ID_SAFETY_SET_ALLOWED_AREA = 54
mavlink20.MAVLINK_MSG_ID_SAFETY_ALLOWED_AREA = 55
mavlink20.MAVLINK_MSG_ID_ATTITUDE_QUATERNION_COV = 61
mavlink20.MAVLINK_MSG_ID_NAV_CONTROLLER_OUTPUT = 62
mavlink20.MAVLINK_MSG_ID_GLOBAL_POSITION_INT_COV = 63
mavlink20.MAVLINK_MSG_ID_LOCAL_POSITION_NED_COV = 64
mavlink20.MAVLINK_MSG_ID_RC_CHANNELS = 65
mavlink20.MAVLINK_MSG_ID_REQUEST_DATA_STREAM = 66
mavlink20.MAVLINK_MSG_ID_DATA_STREAM = 67
mavlink20.MAVLINK_MSG_ID_MANUAL_CONTROL = 69
mavlink20.MAVLINK_MSG_ID_RC_CHANNELS_OVERRIDE = 70
mavlink20.MAVLINK_MSG_ID_MISSION_ITEM_INT = 73
mavlink20.MAVLINK_MSG_ID_VFR_HUD = 74
mavlink20.MAVLINK_MSG_ID_COMMAND_INT = 75
mavlink20.MAVLINK_MSG_ID_COMMAND_LONG = 76
mavlink20.MAVLINK_MSG_ID_COMMAND_ACK = 77
mavlink20.MAVLINK_MSG_ID_COMMAND_CANCEL = 80
mavlink20.MAVLINK_MSG_ID_MANUAL_SETPOINT = 81
mavlink20.MAVLINK_MSG_ID_SET_ATTITUDE_TARGET = 82
mavlink20.MAVLINK_MSG_ID_ATTITUDE_TARGET = 83
mavlink20.MAVLINK_MSG_ID_SET_POSITION_TARGET_LOCAL_NED = 84
mavlink20.MAVLINK_MSG_ID_POSITION_TARGET_LOCAL_NED = 85
mavlink20.MAVLINK_MSG_ID_SET_POSITION_TARGET_GLOBAL_INT = 86
mavlink20.MAVLINK_MSG_ID_POSITION_TARGET_GLOBAL_INT = 87
mavlink20.MAVLINK_MSG_ID_LOCAL_POSITION_NED_SYSTEM_GLOBAL_OFFSET = 89
mavlink20.MAVLINK_MSG_ID_HIL_STATE = 90
mavlink20.MAVLINK_MSG_ID_HIL_CONTROLS = 91
mavlink20.MAVLINK_MSG_ID_HIL_RC_INPUTS_RAW = 92
mavlink20.MAVLINK_MSG_ID_HIL_ACTUATOR_CONTROLS = 93
mavlink20.MAVLINK_MSG_ID_OPTICAL_FLOW = 100
mavlink20.MAVLINK_MSG_ID_GLOBAL_VISION_POSITION_ESTIMATE = 101
mavlink20.MAVLINK_MSG_ID_VISION_POSITION_ESTIMATE = 102
mavlink20.MAVLINK_MSG_ID_VISION_SPEED_ESTIMATE = 103
mavlink20.MAVLINK_MSG_ID_VICON_POSITION_ESTIMATE = 104
mavlink20.MAVLINK_MSG_ID_HIGHRES_IMU = 105
mavlink20.MAVLINK_MSG_ID_OPTICAL_FLOW_RAD = 106
mavlink20.MAVLINK_MSG_ID_HIL_SENSOR = 107
mavlink20.MAVLINK_MSG_ID_SIM_STATE = 108
mavlink20.MAVLINK_MSG_ID_RADIO_STATUS = 109
mavlink20.MAVLINK_MSG_ID_FILE_TRANSFER_PROTOCOL = 110
mavlink20.MAVLINK_MSG_ID_TIMESYNC = 111
mavlink20.MAVLINK_MSG_ID_CAMERA_TRIGGER = 112
mavlink20.MAVLINK_MSG_ID_HIL_GPS = 113
mavlink20.MAVLINK_MSG_ID_HIL_OPTICAL_FLOW = 114
mavlink20.MAVLINK_MSG_ID_HIL_STATE_QUATERNION = 115
mavlink20.MAVLINK_MSG_ID_SCALED_IMU2 = 116
mavlink20.MAVLINK_MSG_ID_LOG_REQUEST_LIST = 117
mavlink20.MAVLINK_MSG_ID_LOG_ENTRY = 118
mavlink20.MAVLINK_MSG_ID_LOG_REQUEST_DATA = 119
mavlink20.MAVLINK_MSG_ID_LOG_DATA = 120
mavlink20.MAVLINK_MSG_ID_LOG_ERASE = 121
mavlink20.MAVLINK_MSG_ID_LOG_REQUEST_END = 122
mavlink20.MAVLINK_MSG_ID_GPS_INJECT_DATA = 123
mavlink20.MAVLINK_MSG_ID_GPS2_RAW = 124
mavlink20.MAVLINK_MSG_ID_POWER_STATUS = 125
mavlink20.MAVLINK_MSG_ID_SERIAL_CONTROL = 126
mavlink20.MAVLINK_MSG_ID_GPS_RTK = 127
mavlink20.MAVLINK_MSG_ID_GPS2_RTK = 128
mavlink20.MAVLINK_MSG_ID_SCALED_IMU3 = 129
mavlink20.MAVLINK_MSG_ID_DATA_TRANSMISSION_HANDSHAKE = 130
mavlink20.MAVLINK_MSG_ID_ENCAPSULATED_DATA = 131
mavlink20.MAVLINK_MSG_ID_DISTANCE_SENSOR = 132
mavlink20.MAVLINK_MSG_ID_TERRAIN_REQUEST = 133
mavlink20.MAVLINK_MSG_ID_TERRAIN_DATA = 134
mavlink20.MAVLINK_MSG_ID_TERRAIN_CHECK = 135
mavlink20.MAVLINK_MSG_ID_TERRAIN_REPORT = 136
mavlink20.MAVLINK_MSG_ID_SCALED_PRESSURE2 = 137
mavlink20.MAVLINK_MSG_ID_ATT_POS_MOCAP = 138
mavlink20.MAVLINK_MSG_ID_SET_ACTUATOR_CONTROL_TARGET = 139
mavlink20.MAVLINK_MSG_ID_ACTUATOR_CONTROL_TARGET = 140
mavlink20.MAVLINK_MSG_ID_ALTITUDE = 141
mavlink20.MAVLINK_MSG_ID_RESOURCE_REQUEST = 142
mavlink20.MAVLINK_MSG_ID_SCALED_PRESSURE3 = 143
mavlink20.MAVLINK_MSG_ID_FOLLOW_TARGET = 144
mavlink20.MAVLINK_MSG_ID_CONTROL_SYSTEM_STATE = 146
mavlink20.MAVLINK_MSG_ID_BATTERY_STATUS = 147
mavlink20.MAVLINK_MSG_ID_AUTOPILOT_VERSION = 148
mavlink20.MAVLINK_MSG_ID_LANDING_TARGET = 149
mavlink20.MAVLINK_MSG_ID_FENCE_STATUS = 162
mavlink20.MAVLINK_MSG_ID_MAG_CAL_REPORT = 192
mavlink20.MAVLINK_MSG_ID_EFI_STATUS = 225
mavlink20.MAVLINK_MSG_ID_ESTIMATOR_STATUS = 230
mavlink20.MAVLINK_MSG_ID_WIND_COV = 231
mavlink20.MAVLINK_MSG_ID_GPS_INPUT = 232
mavlink20.MAVLINK_MSG_ID_GPS_RTCM_DATA = 233
mavlink20.MAVLINK_MSG_ID_HIGH_LATENCY = 234
mavlink20.MAVLINK_MSG_ID_HIGH_LATENCY2 = 235
mavlink20.MAVLINK_MSG_ID_VIBRATION = 241
mavlink20.MAVLINK_MSG_ID_HOME_POSITION = 242
mavlink20.MAVLINK_MSG_ID_SET_HOME_POSITION = 243
mavlink20.MAVLINK_MSG_ID_MESSAGE_INTERVAL = 244
mavlink20.MAVLINK_MSG_ID_EXTENDED_SYS_STATE = 245
mavlink20.MAVLINK_MSG_ID_ADSB_VEHICLE = 246
mavlink20.MAVLINK_MSG_ID_COLLISION = 247
mavlink20.MAVLINK_MSG_ID_V2_EXTENSION = 248
mavlink20.MAVLINK_MSG_ID_MEMORY_VECT = 249
mavlink20.MAVLINK_MSG_ID_DEBUG_VECT = 250
mavlink20.MAVLINK_MSG_ID_NAMED_VALUE_FLOAT = 251
mavlink20.MAVLINK_MSG_ID_NAMED_VALUE_INT = 252
mavlink20.MAVLINK_MSG_ID_STATUSTEXT = 253
mavlink20.MAVLINK_MSG_ID_DEBUG = 254
mavlink20.MAVLINK_MSG_ID_SETUP_SIGNING = 256
mavlink20.MAVLINK_MSG_ID_BUTTON_CHANGE = 257
mavlink20.MAVLINK_MSG_ID_PLAY_TUNE = 258
mavlink20.MAVLINK_MSG_ID_CAMERA_INFORMATION = 259
mavlink20.MAVLINK_MSG_ID_CAMERA_SETTINGS = 260
mavlink20.MAVLINK_MSG_ID_STORAGE_INFORMATION = 261
mavlink20.MAVLINK_MSG_ID_CAMERA_CAPTURE_STATUS = 262
mavlink20.MAVLINK_MSG_ID_CAMERA_IMAGE_CAPTURED = 263
mavlink20.MAVLINK_MSG_ID_FLIGHT_INFORMATION = 264
mavlink20.MAVLINK_MSG_ID_MOUNT_ORIENTATION = 265
mavlink20.MAVLINK_MSG_ID_LOGGING_DATA = 266
mavlink20.MAVLINK_MSG_ID_LOGGING_DATA_ACKED = 267
mavlink20.MAVLINK_MSG_ID_LOGGING_ACK = 268
mavlink20.MAVLINK_MSG_ID_VIDEO_STREAM_INFORMATION = 269
mavlink20.MAVLINK_MSG_ID_VIDEO_STREAM_STATUS = 270
mavlink20.MAVLINK_MSG_ID_CAMERA_FOV_STATUS = 271
mavlink20.MAVLINK_MSG_ID_CAMERA_TRACKING_IMAGE_STATUS = 275
mavlink20.MAVLINK_MSG_ID_CAMERA_TRACKING_GEO_STATUS = 276
mavlink20.MAVLINK_MSG_ID_CAMERA_THERMAL_RANGE = 277
mavlink20.MAVLINK_MSG_ID_GIMBAL_MANAGER_INFORMATION = 280
mavlink20.MAVLINK_MSG_ID_GIMBAL_MANAGER_STATUS = 281
mavlink20.MAVLINK_MSG_ID_GIMBAL_MANAGER_SET_ATTITUDE = 282
mavlink20.MAVLINK_MSG_ID_GIMBAL_DEVICE_INFORMATION = 283
mavlink20.MAVLINK_MSG_ID_GIMBAL_DEVICE_SET_ATTITUDE = 284
mavlink20.MAVLINK_MSG_ID_GIMBAL_DEVICE_ATTITUDE_STATUS = 285
mavlink20.MAVLINK_MSG_ID_AUTOPILOT_STATE_FOR_GIMBAL_DEVICE = 286
mavlink20.MAVLINK_MSG_ID_GIMBAL_MANAGER_SET_PITCHYAW = 287
mavlink20.MAVLINK_MSG_ID_GIMBAL_MANAGER_SET_MANUAL_CONTROL = 288
mavlink20.MAVLINK_MSG_ID_ESC_INFO = 290
mavlink20.MAVLINK_MSG_ID_ESC_STATUS = 291
mavlink20.MAVLINK_MSG_ID_WIFI_CONFIG_AP = 299
mavlink20.MAVLINK_MSG_ID_AIS_VESSEL = 301
mavlink20.MAVLINK_MSG_ID_UAVCAN_NODE_STATUS = 310
mavlink20.MAVLINK_MSG_ID_UAVCAN_NODE_INFO = 311
mavlink20.MAVLINK_MSG_ID_PARAM_EXT_REQUEST_READ = 320
mavlink20.MAVLINK_MSG_ID_PARAM_EXT_REQUEST_LIST = 321
mavlink20.MAVLINK_MSG_ID_PARAM_EXT_VALUE = 322
mavlink20.MAVLINK_MSG_ID_PARAM_EXT_SET = 323
mavlink20.MAVLINK_MSG_ID_PARAM_EXT_ACK = 324
mavlink20.MAVLINK_MSG_ID_OBSTACLE_DISTANCE = 330
mavlink20.MAVLINK_MSG_ID_ODOMETRY = 331
mavlink20.MAVLINK_MSG_ID_TRAJECTORY_REPRESENTATION_WAYPOINTS = 332
mavlink20.MAVLINK_MSG_ID_TRAJECTORY_REPRESENTATION_BEZIER = 333
mavlink20.MAVLINK_MSG_ID_CELLULAR_STATUS = 334
mavlink20.MAVLINK_MSG_ID_ISBD_LINK_STATUS = 335
mavlink20.MAVLINK_MSG_ID_CELLULAR_CONFIG = 336
mavlink20.MAVLINK_MSG_ID_RAW_RPM = 339
mavlink20.MAVLINK_MSG_ID_UTM_GLOBAL_POSITION = 340
mavlink20.MAVLINK_MSG_ID_DEBUG_FLOAT_ARRAY = 350
mavlink20.MAVLINK_MSG_ID_ORBIT_EXECUTION_STATUS = 360
mavlink20.MAVLINK_MSG_ID_SMART_BATTERY_INFO = 370
mavlink20.MAVLINK_MSG_ID_FUEL_STATUS = 371
mavlink20.MAVLINK_MSG_ID_BATTERY_INFO = 372
mavlink20.MAVLINK_MSG_ID_GENERATOR_STATUS = 373
mavlink20.MAVLINK_MSG_ID_ACTUATOR_OUTPUT_STATUS = 375
mavlink20.MAVLINK_MSG_ID_TIME_ESTIMATE_TO_TARGET = 380
mavlink20.MAVLINK_MSG_ID_TUNNEL = 385
mavlink20.MAVLINK_MSG_ID_CAN_FRAME = 386
mavlink20.MAVLINK_MSG_ID_ONBOARD_COMPUTER_STATUS = 390
mavlink20.MAVLINK_MSG_ID_COMPONENT_INFORMATION = 395
mavlink20.MAVLINK_MSG_ID_COMPONENT_INFORMATION_BASIC = 396
mavlink20.MAVLINK_MSG_ID_COMPONENT_METADATA = 397
mavlink20.MAVLINK_MSG_ID_PLAY_TUNE_V2 = 400
mavlink20.MAVLINK_MSG_ID_SUPPORTED_TUNES = 401
mavlink20.MAVLINK_MSG_ID_EVENT = 410
mavlink20.MAVLINK_MSG_ID_CURRENT_EVENT_SEQUENCE = 411
mavlink20.MAVLINK_MSG_ID_REQUEST_EVENT = 412
mavlink20.MAVLINK_MSG_ID_RESPONSE_EVENT_ERROR = 413
mavlink20.MAVLINK_MSG_ID_ILLUMINATOR_STATUS = 440
mavlink20.MAVLINK_MSG_ID_CANFD_FRAME = 387
mavlink20.MAVLINK_MSG_ID_CAN_FILTER_MODIFY = 388
mavlink20.MAVLINK_MSG_ID_WHEEL_DISTANCE = 9000
mavlink20.MAVLINK_MSG_ID_WINCH_STATUS = 9005
mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_BASIC_ID = 12900
mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_LOCATION = 12901
mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_AUTHENTICATION = 12902
mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_SELF_ID = 12903
mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_SYSTEM = 12904
mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_OPERATOR_ID = 12905
mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_MESSAGE_PACK = 12915
mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_ARM_STATUS = 12918
mavlink20.MAVLINK_MSG_ID_OPEN_DRONE_ID_SYSTEM_UPDATE = 12919
mavlink20.MAVLINK_MSG_ID_HYGROMETER_SENSOR = 12920
mavlink20.MAVLINK_MSG_ID_AIRSPEED = 295
mavlink20.MAVLINK_MSG_ID_SET_VELOCITY_LIMITS = 354
mavlink20.MAVLINK_MSG_ID_VELOCITY_LIMITS = 355
mavlink20.MAVLINK_MSG_ID_FIGURE_EIGHT_EXECUTION_STATUS = 361
mavlink20.MAVLINK_MSG_ID_BATTERY_STATUS_V2 = 369
mavlink20.MAVLINK_MSG_ID_GROUP_START = 414
mavlink20.MAVLINK_MSG_ID_GROUP_END = 415
mavlink20.MAVLINK_MSG_ID_RADIO_RC_CHANNELS = 420
mavlink20.MAVLINK_MSG_ID_AVAILABLE_MODES = 435
mavlink20.MAVLINK_MSG_ID_CURRENT_MODE = 436
mavlink20.MAVLINK_MSG_ID_AVAILABLE_MODES_MONITOR = 437
mavlink20.MAVLINK_MSG_ID_GNSS_INTEGRITY = 441
mavlink20.MAVLINK_MSG_ID_TARGET_ABSOLUTE = 510
mavlink20.MAVLINK_MSG_ID_TARGET_RELATIVE = 511
mavlink20.MAVLINK_MSG_ID_CONTROL_STATUS = 512
mavlink20.MAVLINK_MSG_ID_ICAROUS_HEARTBEAT = 42000
mavlink20.MAVLINK_MSG_ID_ICAROUS_KINEMATIC_BANDS = 42001
mavlink20.MAVLINK_MSG_ID_HEARTBEAT = 0
mavlink20.MAVLINK_MSG_ID_PROTOCOL_VERSION = 300
mavlink20.MAVLINK_MSG_ID_ARRAY_TEST_0 = 17150
mavlink20.MAVLINK_MSG_ID_ARRAY_TEST_1 = 17151
mavlink20.MAVLINK_MSG_ID_ARRAY_TEST_3 = 17153
mavlink20.MAVLINK_MSG_ID_ARRAY_TEST_4 = 17154
mavlink20.MAVLINK_MSG_ID_ARRAY_TEST_5 = 17155
mavlink20.MAVLINK_MSG_ID_ARRAY_TEST_6 = 17156
mavlink20.MAVLINK_MSG_ID_ARRAY_TEST_7 = 17157
mavlink20.MAVLINK_MSG_ID_ARRAY_TEST_8 = 17158
mavlink20.MAVLINK_MSG_ID_TEST_TYPES = 17000
mavlink20.MAVLINK_MSG_ID_NAV_FILTER_BIAS = 220
mavlink20.MAVLINK_MSG_ID_RADIO_CALIBRATION = 221
mavlink20.MAVLINK_MSG_ID_UALBERTA_SYS_STATUS = 222
mavlink20.MAVLINK_MSG_ID_UAVIONIX_ADSB_OUT_CFG = 10001
mavlink20.MAVLINK_MSG_ID_UAVIONIX_ADSB_OUT_DYNAMIC = 10002
mavlink20.MAVLINK_MSG_ID_UAVIONIX_ADSB_TRANSCEIVER_HEALTH_REPORT = 10003
mavlink20.MAVLINK_MSG_ID_STORM32_GIMBAL_MANAGER_INFORMATION = 60010
mavlink20.MAVLINK_MSG_ID_STORM32_GIMBAL_MANAGER_STATUS = 60011
mavlink20.MAVLINK_MSG_ID_STORM32_GIMBAL_MANAGER_CONTROL = 60012
mavlink20.MAVLINK_MSG_ID_STORM32_GIMBAL_MANAGER_CONTROL_PITCHYAW = 60013
mavlink20.MAVLINK_MSG_ID_STORM32_GIMBAL_MANAGER_CORRECT_ROLL = 60014
mavlink20.MAVLINK_MSG_ID_QSHOT_STATUS = 60020
mavlink20.MAVLINK_MSG_ID_FRSKY_PASSTHROUGH_ARRAY = 60040
mavlink20.MAVLINK_MSG_ID_PARAM_VALUE_ARRAY = 60041
mavlink20.MAVLINK_MSG_ID_AVSS_PRS_SYS_STATUS = 60050
mavlink20.MAVLINK_MSG_ID_AVSS_DRONE_POSITION = 60051
mavlink20.MAVLINK_MSG_ID_AVSS_DRONE_IMU = 60052
mavlink20.MAVLINK_MSG_ID_AVSS_DRONE_OPERATION_MODE = 60053
mavlink20.MAVLINK_MSG_ID_CUBEPILOT_RAW_RC = 50001
mavlink20.MAVLINK_MSG_ID_HERELINK_VIDEO_STREAM_INFORMATION = 50002
mavlink20.MAVLINK_MSG_ID_HERELINK_TELEM = 50003
mavlink20.MAVLINK_MSG_ID_CUBEPILOT_FIRMWARE_UPDATE_START = 50004
mavlink20.MAVLINK_MSG_ID_CUBEPILOT_FIRMWARE_UPDATE_RESP = 50005
mavlink20.MAVLINK_MSG_ID_AIRLINK_AUTH = 52000
mavlink20.MAVLINK_MSG_ID_AIRLINK_AUTH_RESPONSE = 52001
mavlink20.MAVLINK_MSG_ID_AIRLINK_EYE_GS_HOLE_PUSH_REQUEST = 52002
mavlink20.MAVLINK_MSG_ID_AIRLINK_EYE_GS_HOLE_PUSH_RESPONSE = 52003
mavlink20.MAVLINK_MSG_ID_AIRLINK_EYE_HP = 52004
mavlink20.MAVLINK_MSG_ID_AIRLINK_EYE_TURN_INIT = 52005
mavlink20.MAVLINK_MSG_ID_LOWEHEISER_GOV_EFI = 10151

module.exports = {
    mavlink20
};